import React from 'react';
import subMonths from 'date-fns/sub_months';
import addDays from 'date-fns/add_days';
import ReactTooltip from 'react-tooltip';
import startOfDay from 'date-fns/start_of_day';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import getISODay from 'date-fns/get_iso_day';
import { scaleLinear } from 'd3-scale';
import { extent } from 'd3-array';
import Grid from '@material-ui/core/Grid';
import tinycolor from 'tinycolor2';
import groupBy from 'lodash.groupby';
import isBeforeDay from 'date-fns/is_before';
import isSameDay from 'date-fns/is_same_day';
import getISOWeek from 'date-fns/get_iso_week';
import 'date-fns/difference_in_calendar_weeks';
import { unit } from 'mathjs';
import styled from 'styled-components';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var mockdata = {
  totals: {
    gridConsumed: 3217509455,
    solarGenerated: 206641140,
    solarReturned: 639605,
    solarConsumption: 206001535,
    co2Saved: 177576660,
    co2Produced: 2766787984,
    netConsumed: 3423510990
  },
  data: [{
    year: 2016,
    month: "Dec",
    dates: [{
      localDate: "2016-12-15T00:00:00.000Z",
      solarGenerated: 0,
      gridConsumed: 0,
      solarReturned: 0,
      solarConsumption: 0,
      co2Saved: 0,
      co2Produced: 0,
      netConsumed: 0,
      date: "2016-12-15T00:00:00.000Z"
    }, {
      localDate: "2016-12-16T00:00:00.000Z",
      solarGenerated: 8960,
      gridConsumed: 1187002,
      solarReturned: 37530,
      solarConsumption: -28570,
      co2Saved: 7600,
      co2Produced: 1020723,
      netConsumed: 1158432,
      date: "2016-12-16T00:00:00.000Z"
    }, {
      localDate: "2016-12-17T00:00:00.000Z",
      solarGenerated: 500440,
      gridConsumed: 3324600,
      solarReturned: 0,
      solarConsumption: 500440,
      co2Saved: 430080,
      co2Produced: 2858785,
      netConsumed: 3825040,
      date: "2016-12-17T00:00:00.000Z"
    }, {
      localDate: "2016-12-18T00:00:00.000Z",
      solarGenerated: 319900,
      gridConsumed: 3147710,
      solarReturned: 0,
      solarConsumption: 319900,
      co2Saved: 274780,
      co2Produced: 2706650,
      netConsumed: 3467610,
      date: "2016-12-18T00:00:00.000Z"
    }, {
      localDate: "2016-12-19T00:00:00.000Z",
      solarGenerated: 340300,
      gridConsumed: 3617760,
      solarReturned: 0,
      solarConsumption: 340300,
      co2Saved: 292260,
      co2Produced: 3110915,
      netConsumed: 3958060,
      date: "2016-12-19T00:00:00.000Z"
    }, {
      localDate: "2016-12-20T00:00:00.000Z",
      solarGenerated: 341200,
      gridConsumed: 3996310,
      solarReturned: 0,
      solarConsumption: 341200,
      co2Saved: 293100,
      co2Produced: 3436440,
      netConsumed: 4337510,
      date: "2016-12-20T00:00:00.000Z"
    }, {
      localDate: "2016-12-21T00:00:00.000Z",
      solarGenerated: 449220,
      gridConsumed: 5053360,
      solarReturned: 0,
      solarConsumption: 449220,
      co2Saved: 385980,
      co2Produced: 4345450,
      netConsumed: 5502580,
      date: "2016-12-21T00:00:00.000Z"
    }, {
      localDate: "2016-12-22T00:00:00.000Z",
      solarGenerated: 420400,
      gridConsumed: 4487110,
      solarReturned: 0,
      solarConsumption: 420400,
      co2Saved: 361240,
      co2Produced: 3858625,
      netConsumed: 4907510,
      date: "2016-12-22T00:00:00.000Z"
    }, {
      localDate: "2016-12-23T00:00:00.000Z",
      solarGenerated: 357740,
      gridConsumed: 4008885,
      solarReturned: 0,
      solarConsumption: 357740,
      co2Saved: 307300,
      co2Produced: 3447215,
      netConsumed: 4366625,
      date: "2016-12-23T00:00:00.000Z"
    }, {
      localDate: "2016-12-24T00:00:00.000Z",
      solarGenerated: 360940,
      gridConsumed: 3131955,
      solarReturned: 0,
      solarConsumption: 360940,
      co2Saved: 310000,
      co2Produced: 2693055,
      netConsumed: 3492895,
      date: "2016-12-24T00:00:00.000Z"
    }, {
      localDate: "2016-12-25T00:00:00.000Z",
      solarGenerated: 81180,
      gridConsumed: 2786945,
      solarReturned: 0,
      solarConsumption: 81180,
      co2Saved: 69580,
      co2Produced: 2396275,
      netConsumed: 2868125,
      date: "2016-12-25T00:00:00.000Z"
    }, {
      localDate: "2016-12-26T00:00:00.000Z",
      solarGenerated: 353260,
      gridConsumed: 3565500,
      solarReturned: 55,
      solarConsumption: 353205,
      co2Saved: 303560,
      co2Produced: 3065910,
      netConsumed: 3918705,
      date: "2016-12-26T00:00:00.000Z"
    }, {
      localDate: "2016-12-27T00:00:00.000Z",
      solarGenerated: 412360,
      gridConsumed: 3760410,
      solarReturned: 15,
      solarConsumption: 412345,
      co2Saved: 354240,
      co2Produced: 3233525,
      netConsumed: 4172755,
      date: "2016-12-27T00:00:00.000Z"
    }, {
      localDate: "2016-12-28T00:00:00.000Z",
      solarGenerated: 488980,
      gridConsumed: 3936145,
      solarReturned: 95,
      solarConsumption: 488885,
      co2Saved: 420260,
      co2Produced: 3384560,
      netConsumed: 4425030,
      date: "2016-12-28T00:00:00.000Z"
    }, {
      localDate: "2016-12-29T00:00:00.000Z",
      solarGenerated: 463940,
      gridConsumed: 4189120,
      solarReturned: 15,
      solarConsumption: 463925,
      co2Saved: 398680,
      co2Produced: 3602325,
      netConsumed: 4653045,
      date: "2016-12-29T00:00:00.000Z"
    }, {
      localDate: "2016-12-30T00:00:00.000Z",
      solarGenerated: 534080,
      gridConsumed: 4388005,
      solarReturned: 0,
      solarConsumption: 534080,
      co2Saved: 459160,
      co2Produced: 3773300,
      netConsumed: 4922085,
      date: "2016-12-30T00:00:00.000Z"
    }, {
      localDate: "2016-12-31T00:00:00.000Z",
      solarGenerated: 503480,
      gridConsumed: 4126300,
      solarReturned: 0,
      solarConsumption: 503480,
      co2Saved: 432780,
      co2Produced: 3548295,
      netConsumed: 4629780,
      date: "2016-12-31T00:00:00.000Z"
    }]
  }, {
    year: 2017,
    month: "Jan",
    dates: [{
      localDate: "2017-01-01T00:00:00.000Z",
      solarGenerated: 503980,
      gridConsumed: 4046310,
      solarReturned: 0,
      solarConsumption: 503980,
      co2Saved: 433160,
      co2Produced: 3479545,
      netConsumed: 4550290,
      date: "2017-01-01T00:00:00.000Z"
    }, {
      localDate: "2017-01-02T00:00:00.000Z",
      solarGenerated: 386500,
      gridConsumed: 4731305,
      solarReturned: 0,
      solarConsumption: 386500,
      co2Saved: 332240,
      co2Produced: 4068540,
      netConsumed: 5117805,
      date: "2017-01-02T00:00:00.000Z"
    }, {
      localDate: "2017-01-03T00:00:00.000Z",
      solarGenerated: 170820,
      gridConsumed: 3709070,
      solarReturned: 0,
      solarConsumption: 170820,
      co2Saved: 146760,
      co2Produced: 3189475,
      netConsumed: 3879890,
      date: "2017-01-03T00:00:00.000Z"
    }, {
      localDate: "2017-01-04T00:00:00.000Z",
      solarGenerated: 428580,
      gridConsumed: 4025410,
      solarReturned: 0,
      solarConsumption: 428580,
      co2Saved: 368320,
      co2Produced: 3461360,
      netConsumed: 4453990,
      date: "2017-01-04T00:00:00.000Z"
    }, {
      localDate: "2017-01-05T00:00:00.000Z",
      solarGenerated: 311680,
      gridConsumed: 4068955,
      solarReturned: 0,
      solarConsumption: 311680,
      co2Saved: 267900,
      co2Produced: 3498875,
      netConsumed: 4380635,
      date: "2017-01-05T00:00:00.000Z"
    }, {
      localDate: "2017-01-06T00:00:00.000Z",
      solarGenerated: 351520,
      gridConsumed: 4514615,
      solarReturned: 0,
      solarConsumption: 351520,
      co2Saved: 302220,
      co2Produced: 3882145,
      netConsumed: 4866135,
      date: "2017-01-06T00:00:00.000Z"
    }, {
      localDate: "2017-01-07T00:00:00.000Z",
      solarGenerated: 406120,
      gridConsumed: 3396985,
      solarReturned: 0,
      solarConsumption: 406120,
      co2Saved: 348980,
      co2Produced: 2921095,
      netConsumed: 3803105,
      date: "2017-01-07T00:00:00.000Z"
    }, {
      localDate: "2017-01-08T00:00:00.000Z",
      solarGenerated: 443900,
      gridConsumed: 3342770,
      solarReturned: 0,
      solarConsumption: 443900,
      co2Saved: 381460,
      co2Produced: 2874395,
      netConsumed: 3786670,
      date: "2017-01-08T00:00:00.000Z"
    }, {
      localDate: "2017-01-09T00:00:00.000Z",
      solarGenerated: 390520,
      gridConsumed: 5108230,
      solarReturned: 0,
      solarConsumption: 390520,
      co2Saved: 335860,
      co2Produced: 4392700,
      netConsumed: 5498750,
      date: "2017-01-09T00:00:00.000Z"
    }, {
      localDate: "2017-01-10T00:00:00.000Z",
      solarGenerated: 446340,
      gridConsumed: 5621605,
      solarReturned: 0,
      solarConsumption: 446340,
      co2Saved: 383640,
      co2Produced: 4834135,
      netConsumed: 6067945,
      date: "2017-01-10T00:00:00.000Z"
    }, {
      localDate: "2017-01-11T00:00:00.000Z",
      solarGenerated: 446260,
      gridConsumed: 5977240,
      solarReturned: 0,
      solarConsumption: 446260,
      co2Saved: 383500,
      co2Produced: 5140065,
      netConsumed: 6423500,
      date: "2017-01-11T00:00:00.000Z"
    }, {
      localDate: "2017-01-12T00:00:00.000Z",
      solarGenerated: 455720,
      gridConsumed: 6631765,
      solarReturned: 0,
      solarConsumption: 455720,
      co2Saved: 391700,
      co2Produced: 5702925,
      netConsumed: 7087485,
      date: "2017-01-12T00:00:00.000Z"
    }, {
      localDate: "2017-01-13T00:00:00.000Z",
      solarGenerated: 435680,
      gridConsumed: 5927580,
      solarReturned: 0,
      solarConsumption: 435680,
      co2Saved: 374400,
      co2Produced: 5097340,
      netConsumed: 6363260,
      date: "2017-01-13T00:00:00.000Z"
    }, {
      localDate: "2017-01-14T00:00:00.000Z",
      solarGenerated: 499320,
      gridConsumed: 4074185,
      solarReturned: 0,
      solarConsumption: 499320,
      co2Saved: 429220,
      co2Produced: 3503435,
      netConsumed: 4573505,
      date: "2017-01-14T00:00:00.000Z"
    }, {
      localDate: "2017-01-15T00:00:00.000Z",
      solarGenerated: 201180,
      gridConsumed: 3699830,
      solarReturned: 0,
      solarConsumption: 201180,
      co2Saved: 172880,
      co2Produced: 3181485,
      netConsumed: 3901010,
      date: "2017-01-15T00:00:00.000Z"
    }, {
      localDate: "2017-01-16T00:00:00.000Z",
      solarGenerated: 417520,
      gridConsumed: 7210485,
      solarReturned: 0,
      solarConsumption: 417520,
      co2Saved: 358820,
      co2Produced: 6200580,
      netConsumed: 7628005,
      date: "2017-01-16T00:00:00.000Z"
    }, {
      localDate: "2017-01-17T00:00:00.000Z",
      solarGenerated: 466740,
      gridConsumed: 7994725,
      solarReturned: 0,
      solarConsumption: 466740,
      co2Saved: 401140,
      co2Produced: 6875055,
      netConsumed: 8461465,
      date: "2017-01-17T00:00:00.000Z"
    }, {
      localDate: "2017-01-18T00:00:00.000Z",
      solarGenerated: 499860,
      gridConsumed: 8774030,
      solarReturned: 0,
      solarConsumption: 499860,
      co2Saved: 429580,
      co2Produced: 7545270,
      netConsumed: 9273890,
      date: "2017-01-18T00:00:00.000Z"
    }, {
      localDate: "2017-01-19T00:00:00.000Z",
      solarGenerated: 263260,
      gridConsumed: 7521470,
      solarReturned: 0,
      solarConsumption: 263260,
      co2Saved: 226180,
      co2Produced: 6468085,
      netConsumed: 7784730,
      date: "2017-01-19T00:00:00.000Z"
    }, {
      localDate: "2017-01-20T00:00:00.000Z",
      solarGenerated: 371660,
      gridConsumed: 8069735,
      solarReturned: 0,
      solarConsumption: 371660,
      co2Saved: 319220,
      co2Produced: 6939590,
      netConsumed: 8441395,
      date: "2017-01-20T00:00:00.000Z"
    }, {
      localDate: "2017-01-21T00:00:00.000Z",
      solarGenerated: 198540,
      gridConsumed: 4147395,
      solarReturned: 0,
      solarConsumption: 198540,
      co2Saved: 170380,
      co2Produced: 3566295,
      netConsumed: 4345935,
      date: "2017-01-21T00:00:00.000Z"
    }, {
      localDate: "2017-01-22T00:00:00.000Z",
      solarGenerated: 425020,
      gridConsumed: 3721340,
      solarReturned: 0,
      solarConsumption: 425020,
      co2Saved: 365160,
      co2Produced: 3199900,
      netConsumed: 4146360,
      date: "2017-01-22T00:00:00.000Z"
    }, {
      localDate: "2017-01-23T00:00:00.000Z",
      solarGenerated: 366700,
      gridConsumed: 7432875,
      solarReturned: 0,
      solarConsumption: 366700,
      co2Saved: 315220,
      co2Produced: 6391975,
      netConsumed: 7799575,
      date: "2017-01-23T00:00:00.000Z"
    }, {
      localDate: "2017-01-24T00:00:00.000Z",
      solarGenerated: 513000,
      gridConsumed: 9507090,
      solarReturned: 0,
      solarConsumption: 513000,
      co2Saved: 440940,
      co2Produced: 8175695,
      netConsumed: 10020090,
      date: "2017-01-24T00:00:00.000Z"
    }, {
      localDate: "2017-01-25T00:00:00.000Z",
      solarGenerated: 470160,
      gridConsumed: 10340310,
      solarReturned: 0,
      solarConsumption: 470160,
      co2Saved: 404140,
      co2Produced: 8892335,
      netConsumed: 10810470,
      date: "2017-01-25T00:00:00.000Z"
    }, {
      localDate: "2017-01-26T00:00:00.000Z",
      solarGenerated: 426400,
      gridConsumed: 4226475,
      solarReturned: 0,
      solarConsumption: 426400,
      co2Saved: 366460,
      co2Produced: 3634300,
      netConsumed: 4652875,
      date: "2017-01-26T00:00:00.000Z"
    }, {
      localDate: "2017-01-27T00:00:00.000Z",
      solarGenerated: 171920,
      gridConsumed: 9454555,
      solarReturned: 0,
      solarConsumption: 171920,
      co2Saved: 148020,
      co2Produced: 8130580,
      netConsumed: 9626475,
      date: "2017-01-27T00:00:00.000Z"
    }, {
      localDate: "2017-01-28T00:00:00.000Z",
      solarGenerated: 411940,
      gridConsumed: 2745655,
      solarReturned: 10,
      solarConsumption: 411930,
      co2Saved: 354020,
      co2Produced: 2360905,
      netConsumed: 3157585,
      date: "2017-01-28T00:00:00.000Z"
    }, {
      localDate: "2017-01-29T00:00:00.000Z",
      solarGenerated: 402660,
      gridConsumed: 3070935,
      solarReturned: 25,
      solarConsumption: 402635,
      co2Saved: 346160,
      co2Produced: 2640540,
      netConsumed: 3473570,
      date: "2017-01-29T00:00:00.000Z"
    }, {
      localDate: "2017-01-30T00:00:00.000Z",
      solarGenerated: 455060,
      gridConsumed: 10690640,
      solarReturned: 0,
      solarConsumption: 455060,
      co2Saved: 391080,
      co2Produced: 9193560,
      netConsumed: 11145700,
      date: "2017-01-30T00:00:00.000Z"
    }, {
      localDate: "2017-01-31T00:00:00.000Z",
      solarGenerated: 500340,
      gridConsumed: 11652215,
      solarReturned: 0,
      solarConsumption: 500340,
      co2Saved: 430040,
      co2Produced: 10020530,
      netConsumed: 12152555,
      date: "2017-01-31T00:00:00.000Z"
    }]
  }, {
    year: 2017,
    month: "Feb",
    dates: [{
      localDate: "2017-02-01T00:00:00.000Z",
      solarGenerated: 496680,
      gridConsumed: 9650125,
      solarReturned: 0,
      solarConsumption: 496680,
      co2Saved: 426980,
      co2Produced: 8298745,
      netConsumed: 10146805,
      date: "2017-02-01T00:00:00.000Z"
    }, {
      localDate: "2017-02-02T00:00:00.000Z",
      solarGenerated: 482940,
      gridConsumed: 10820310,
      solarReturned: 0,
      solarConsumption: 482940,
      co2Saved: 415180,
      co2Produced: 9305040,
      netConsumed: 11303250,
      date: "2017-02-02T00:00:00.000Z"
    }, {
      localDate: "2017-02-03T00:00:00.000Z",
      solarGenerated: 365520,
      gridConsumed: 10471815,
      solarReturned: 0,
      solarConsumption: 365520,
      co2Saved: 313900,
      co2Produced: 9005445,
      netConsumed: 10837335,
      date: "2017-02-03T00:00:00.000Z"
    }, {
      localDate: "2017-02-04T00:00:00.000Z",
      solarGenerated: 444460,
      gridConsumed: 3825625,
      solarReturned: 15,
      solarConsumption: 444445,
      co2Saved: 382040,
      co2Produced: 3289635,
      netConsumed: 4270070,
      date: "2017-02-04T00:00:00.000Z"
    }, {
      localDate: "2017-02-05T00:00:00.000Z",
      solarGenerated: 367220,
      gridConsumed: 3356800,
      solarReturned: 5,
      solarConsumption: 367215,
      co2Saved: 315720,
      co2Produced: 2886510,
      netConsumed: 3724015,
      date: "2017-02-05T00:00:00.000Z"
    }, {
      localDate: "2017-02-06T00:00:00.000Z",
      solarGenerated: 440960,
      gridConsumed: 10717920,
      solarReturned: 0,
      solarConsumption: 440960,
      co2Saved: 379060,
      co2Produced: 9216900,
      netConsumed: 11158880,
      date: "2017-02-06T00:00:00.000Z"
    }, {
      localDate: "2017-02-07T00:00:00.000Z",
      solarGenerated: 414800,
      gridConsumed: 11004260,
      solarReturned: 0,
      solarConsumption: 414800,
      co2Saved: 356600,
      co2Produced: 9463185,
      netConsumed: 11419060,
      date: "2017-02-07T00:00:00.000Z"
    }, {
      localDate: "2017-02-08T00:00:00.000Z",
      solarGenerated: 398640,
      gridConsumed: 10447575,
      solarReturned: 0,
      solarConsumption: 398640,
      co2Saved: 342560,
      co2Produced: 8984450,
      netConsumed: 10846215,
      date: "2017-02-08T00:00:00.000Z"
    }, {
      localDate: "2017-02-09T00:00:00.000Z",
      solarGenerated: 398960,
      gridConsumed: 10088465,
      solarReturned: 0,
      solarConsumption: 398960,
      co2Saved: 342960,
      co2Produced: 8675755,
      netConsumed: 10487425,
      date: "2017-02-09T00:00:00.000Z"
    }, {
      localDate: "2017-02-10T00:00:00.000Z",
      solarGenerated: 410380,
      gridConsumed: 10141905,
      solarReturned: 15,
      solarConsumption: 410365,
      co2Saved: 352640,
      co2Produced: 8721610,
      netConsumed: 10552270,
      date: "2017-02-10T00:00:00.000Z"
    }, {
      localDate: "2017-02-11T00:00:00.000Z",
      solarGenerated: 467020,
      gridConsumed: 3974265,
      solarReturned: 0,
      solarConsumption: 467020,
      co2Saved: 401540,
      co2Produced: 3417505,
      netConsumed: 4441285,
      date: "2017-02-11T00:00:00.000Z"
    }, {
      localDate: "2017-02-12T00:00:00.000Z",
      solarGenerated: 467040,
      gridConsumed: 3731515,
      solarReturned: 15,
      solarConsumption: 467025,
      co2Saved: 401260,
      co2Produced: 3208690,
      netConsumed: 4198540,
      date: "2017-02-12T00:00:00.000Z"
    }, {
      localDate: "2017-02-13T00:00:00.000Z",
      solarGenerated: 328980,
      gridConsumed: 11703735,
      solarReturned: 0,
      solarConsumption: 328980,
      co2Saved: 282720,
      co2Produced: 10064825,
      netConsumed: 12032715,
      date: "2017-02-13T00:00:00.000Z"
    }, {
      localDate: "2017-02-14T00:00:00.000Z",
      solarGenerated: 364780,
      gridConsumed: 9996395,
      solarReturned: 0,
      solarConsumption: 364780,
      co2Saved: 313340,
      co2Produced: 8596565,
      netConsumed: 10361175,
      date: "2017-02-14T00:00:00.000Z"
    }, {
      localDate: "2017-02-15T00:00:00.000Z",
      solarGenerated: 340800,
      gridConsumed: 9357640,
      solarReturned: 0,
      solarConsumption: 340800,
      co2Saved: 292980,
      co2Produced: 8047160,
      netConsumed: 9698440,
      date: "2017-02-15T00:00:00.000Z"
    }, {
      localDate: "2017-02-16T00:00:00.000Z",
      solarGenerated: 346080,
      gridConsumed: 9187915,
      solarReturned: 0,
      solarConsumption: 346080,
      co2Saved: 297540,
      co2Produced: 7901170,
      netConsumed: 9533995,
      date: "2017-02-16T00:00:00.000Z"
    }, {
      localDate: "2017-02-17T00:00:00.000Z",
      solarGenerated: 404360,
      gridConsumed: 9492105,
      solarReturned: 0,
      solarConsumption: 404360,
      co2Saved: 347720,
      co2Produced: 8162880,
      netConsumed: 9896465,
      date: "2017-02-17T00:00:00.000Z"
    }, {
      localDate: "2017-02-18T00:00:00.000Z",
      solarGenerated: 441380,
      gridConsumed: 3539775,
      solarReturned: 0,
      solarConsumption: 441380,
      co2Saved: 379340,
      co2Produced: 3043845,
      netConsumed: 3981155,
      date: "2017-02-18T00:00:00.000Z"
    }, {
      localDate: "2017-02-19T00:00:00.000Z",
      solarGenerated: 288400,
      gridConsumed: 3865878,
      solarReturned: 20,
      solarConsumption: 288380,
      co2Saved: 247780,
      co2Produced: 3324160,
      netConsumed: 4154258,
      date: "2017-02-19T00:00:00.000Z"
    }, {
      localDate: "2017-02-20T00:00:00.000Z",
      solarGenerated: 389740,
      gridConsumed: 9733115,
      solarReturned: 0,
      solarConsumption: 389740,
      co2Saved: 334920,
      co2Produced: 8369955,
      netConsumed: 10122855,
      date: "2017-02-20T00:00:00.000Z"
    }, {
      localDate: "2017-02-21T00:00:00.000Z",
      solarGenerated: 444540,
      gridConsumed: 10226815,
      solarReturned: 0,
      solarConsumption: 444540,
      co2Saved: 382060,
      co2Produced: 8794770,
      netConsumed: 10671355,
      date: "2017-02-21T00:00:00.000Z"
    }, {
      localDate: "2017-02-22T00:00:00.000Z",
      solarGenerated: 372220,
      gridConsumed: 8693855,
      solarReturned: 0,
      solarConsumption: 372220,
      co2Saved: 319840,
      co2Produced: 7476210,
      netConsumed: 9066075,
      date: "2017-02-22T00:00:00.000Z"
    }, {
      localDate: "2017-02-23T00:00:00.000Z",
      solarGenerated: 408360,
      gridConsumed: 8808610,
      solarReturned: 0,
      solarConsumption: 408360,
      co2Saved: 350980,
      co2Produced: 7574985,
      netConsumed: 9216970,
      date: "2017-02-23T00:00:00.000Z"
    }, {
      localDate: "2017-02-24T00:00:00.000Z",
      solarGenerated: 419660,
      gridConsumed: 8864960,
      solarReturned: 0,
      solarConsumption: 419660,
      co2Saved: 360640,
      co2Produced: 7623535,
      netConsumed: 9284620,
      date: "2017-02-24T00:00:00.000Z"
    }, {
      localDate: "2017-02-25T00:00:00.000Z",
      solarGenerated: 403800,
      gridConsumed: 2750265,
      solarReturned: 0,
      solarConsumption: 403800,
      co2Saved: 347020,
      co2Produced: 2364745,
      netConsumed: 3154065,
      date: "2017-02-25T00:00:00.000Z"
    }, {
      localDate: "2017-02-26T00:00:00.000Z",
      solarGenerated: 348980,
      gridConsumed: 3516000,
      solarReturned: 100,
      solarConsumption: 348880,
      co2Saved: 299820,
      co2Produced: 3023415,
      netConsumed: 3864880,
      date: "2017-02-26T00:00:00.000Z"
    }, {
      localDate: "2017-02-27T00:00:00.000Z",
      solarGenerated: 343220,
      gridConsumed: 7899790,
      solarReturned: 0,
      solarConsumption: 343220,
      co2Saved: 294920,
      co2Produced: 6793410,
      netConsumed: 8243010,
      date: "2017-02-27T00:00:00.000Z"
    }, {
      localDate: "2017-02-28T00:00:00.000Z",
      solarGenerated: 354440,
      gridConsumed: 8238895,
      solarReturned: 25,
      solarConsumption: 354415,
      co2Saved: 304680,
      co2Produced: 7085050,
      netConsumed: 8593310,
      date: "2017-02-28T00:00:00.000Z"
    }]
  }, {
    year: 2017,
    month: "Mar",
    dates: [{
      localDate: "2017-03-01T00:00:00.000Z",
      solarGenerated: 366720,
      gridConsumed: 9414565,
      solarReturned: 5,
      solarConsumption: 366715,
      co2Saved: 315300,
      co2Produced: 8096185,
      netConsumed: 9781280,
      date: "2017-03-01T00:00:00.000Z"
    }, {
      localDate: "2017-03-02T00:00:00.000Z",
      solarGenerated: 248640,
      gridConsumed: 9294695,
      solarReturned: 0,
      solarConsumption: 248640,
      co2Saved: 213640,
      co2Produced: 7993060,
      netConsumed: 9543335,
      date: "2017-03-02T00:00:00.000Z"
    }, {
      localDate: "2017-03-03T00:00:00.000Z",
      solarGenerated: 304240,
      gridConsumed: 9163240,
      solarReturned: 0,
      solarConsumption: 304240,
      co2Saved: 261380,
      co2Produced: 7880020,
      netConsumed: 9467480,
      date: "2017-03-03T00:00:00.000Z"
    }, {
      localDate: "2017-03-04T00:00:00.000Z",
      solarGenerated: 271080,
      gridConsumed: 3523320,
      solarReturned: 0,
      solarConsumption: 271080,
      co2Saved: 232920,
      co2Produced: 3029705,
      netConsumed: 3794400,
      date: "2017-03-04T00:00:00.000Z"
    }, {
      localDate: "2017-03-05T00:00:00.000Z",
      solarGenerated: 335420,
      gridConsumed: 4307520,
      solarReturned: 0,
      solarConsumption: 335420,
      co2Saved: 288200,
      co2Produced: 3703990,
      netConsumed: 4642940,
      date: "2017-03-05T00:00:00.000Z"
    }, {
      localDate: "2017-03-06T00:00:00.000Z",
      solarGenerated: 286160,
      gridConsumed: 9292790,
      solarReturned: 0,
      solarConsumption: 286160,
      co2Saved: 245860,
      co2Produced: 7991395,
      netConsumed: 9578950,
      date: "2017-03-06T00:00:00.000Z"
    }, {
      localDate: "2017-03-07T00:00:00.000Z",
      solarGenerated: 406980,
      gridConsumed: 8854190,
      solarReturned: 5,
      solarConsumption: 406975,
      co2Saved: 349720,
      co2Produced: 7614200,
      netConsumed: 9261165,
      date: "2017-03-07T00:00:00.000Z"
    }, {
      localDate: "2017-03-08T00:00:00.000Z",
      solarGenerated: 250380,
      gridConsumed: 7403105,
      solarReturned: 10,
      solarConsumption: 250370,
      co2Saved: 215280,
      co2Produced: 6366340,
      netConsumed: 7653475,
      date: "2017-03-08T00:00:00.000Z"
    }, {
      localDate: "2017-03-09T00:00:00.000Z",
      solarGenerated: 392700,
      gridConsumed: 8418505,
      solarReturned: 0,
      solarConsumption: 392700,
      co2Saved: 337580,
      co2Produced: 7239610,
      netConsumed: 8811205,
      date: "2017-03-09T00:00:00.000Z"
    }, {
      localDate: "2017-03-10T00:00:00.000Z",
      solarGenerated: 418860,
      gridConsumed: 8260695,
      solarReturned: 0,
      solarConsumption: 418860,
      co2Saved: 359980,
      co2Produced: 7103705,
      netConsumed: 8679555,
      date: "2017-03-10T00:00:00.000Z"
    }, {
      localDate: "2017-03-11T00:00:00.000Z",
      solarGenerated: 389480,
      gridConsumed: 3237815,
      solarReturned: 0,
      solarConsumption: 389480,
      co2Saved: 334780,
      co2Produced: 2784030,
      netConsumed: 3627295,
      date: "2017-03-11T00:00:00.000Z"
    }, {
      localDate: "2017-03-12T00:00:00.000Z",
      solarGenerated: 330960,
      gridConsumed: 3769200,
      solarReturned: 100,
      solarConsumption: 330860,
      co2Saved: 284420,
      co2Produced: 3241020,
      netConsumed: 4100060,
      date: "2017-03-12T00:00:00.000Z"
    }, {
      localDate: "2017-03-13T00:00:00.000Z",
      solarGenerated: 148120,
      gridConsumed: 8307555,
      solarReturned: 0,
      solarConsumption: 148120,
      co2Saved: 127140,
      co2Produced: 7144065,
      netConsumed: 8455675,
      date: "2017-03-13T00:00:00.000Z"
    }, {
      localDate: "2017-03-14T00:00:00.000Z",
      solarGenerated: 220900,
      gridConsumed: 9256010,
      solarReturned: 0,
      solarConsumption: 220900,
      co2Saved: 189820,
      co2Produced: 7959795,
      netConsumed: 9476910,
      date: "2017-03-14T00:00:00.000Z"
    }, {
      localDate: "2017-03-15T00:00:00.000Z",
      solarGenerated: 198780,
      gridConsumed: 8184490,
      solarReturned: 0,
      solarConsumption: 198780,
      co2Saved: 170640,
      co2Produced: 7038115,
      netConsumed: 8383270,
      date: "2017-03-15T00:00:00.000Z"
    }, {
      localDate: "2017-03-16T00:00:00.000Z",
      solarGenerated: 268000,
      gridConsumed: 9007420,
      solarReturned: 80,
      solarConsumption: 267920,
      co2Saved: 230380,
      co2Produced: 7745805,
      netConsumed: 9275340,
      date: "2017-03-16T00:00:00.000Z"
    }, {
      localDate: "2017-03-17T00:00:00.000Z",
      solarGenerated: 278900,
      gridConsumed: 8962410,
      solarReturned: 30,
      solarConsumption: 278870,
      co2Saved: 239700,
      co2Produced: 7707295,
      netConsumed: 9241280,
      date: "2017-03-17T00:00:00.000Z"
    }, {
      localDate: "2017-03-18T00:00:00.000Z",
      solarGenerated: 342380,
      gridConsumed: 3875085,
      solarReturned: 5,
      solarConsumption: 342375,
      co2Saved: 294180,
      co2Produced: 3332115,
      netConsumed: 4217460,
      date: "2017-03-18T00:00:00.000Z"
    }, {
      localDate: "2017-03-19T00:00:00.000Z",
      solarGenerated: 306880,
      gridConsumed: 3408125,
      solarReturned: 65,
      solarConsumption: 306815,
      co2Saved: 263720,
      co2Produced: 2930535,
      netConsumed: 3714940,
      date: "2017-03-19T00:00:00.000Z"
    }, {
      localDate: "2017-03-20T00:00:00.000Z",
      solarGenerated: 144240,
      gridConsumed: 8422235,
      solarReturned: 0,
      solarConsumption: 144240,
      co2Saved: 123800,
      co2Produced: 7242685,
      netConsumed: 8566475,
      date: "2017-03-20T00:00:00.000Z"
    }, {
      localDate: "2017-03-21T00:00:00.000Z",
      solarGenerated: 229460,
      gridConsumed: 9145675,
      solarReturned: 5,
      solarConsumption: 229455,
      co2Saved: 197060,
      co2Produced: 7864840,
      netConsumed: 9375130,
      date: "2017-03-21T00:00:00.000Z"
    }, {
      localDate: "2017-03-22T00:00:00.000Z",
      solarGenerated: 178220,
      gridConsumed: 8140650,
      solarReturned: 50,
      solarConsumption: 178170,
      co2Saved: 153000,
      co2Produced: 7000670,
      netConsumed: 8318820,
      date: "2017-03-22T00:00:00.000Z"
    }, {
      localDate: "2017-03-23T00:00:00.000Z",
      solarGenerated: 229740,
      gridConsumed: 8847745,
      solarReturned: 55,
      solarConsumption: 229685,
      co2Saved: 197340,
      co2Produced: 7608600,
      netConsumed: 9077430,
      date: "2017-03-23T00:00:00.000Z"
    }, {
      localDate: "2017-03-24T00:00:00.000Z",
      solarGenerated: 200200,
      gridConsumed: 6965290,
      solarReturned: 0,
      solarConsumption: 200200,
      co2Saved: 171980,
      co2Produced: 5989635,
      netConsumed: 7165490,
      date: "2017-03-24T00:00:00.000Z"
    }, {
      localDate: "2017-03-25T00:00:00.000Z",
      solarGenerated: 280820,
      gridConsumed: 2486105,
      solarReturned: 5,
      solarConsumption: 280815,
      co2Saved: 241220,
      co2Produced: 2137620,
      netConsumed: 2766920,
      date: "2017-03-25T00:00:00.000Z"
    }, {
      localDate: "2017-03-26T00:00:00.000Z",
      solarGenerated: 357840,
      gridConsumed: 2596925,
      solarReturned: 200,
      solarConsumption: 357640,
      co2Saved: 307560,
      co2Produced: 2233025,
      netConsumed: 2954565,
      date: "2017-03-26T00:00:00.000Z"
    }, {
      localDate: "2017-03-27T00:00:00.000Z",
      solarGenerated: 305060,
      gridConsumed: 8149620,
      solarReturned: 0,
      solarConsumption: 305060,
      co2Saved: 262120,
      co2Produced: 7008285,
      netConsumed: 8454680,
      date: "2017-03-27T00:00:00.000Z"
    }, {
      localDate: "2017-03-28T00:00:00.000Z",
      solarGenerated: 365340,
      gridConsumed: 7820230,
      solarReturned: 80,
      solarConsumption: 365260,
      co2Saved: 314140,
      co2Produced: 6724920,
      netConsumed: 8185490,
      date: "2017-03-28T00:00:00.000Z"
    }, {
      localDate: "2017-03-29T00:00:00.000Z",
      solarGenerated: 208900,
      gridConsumed: 8122645,
      solarReturned: 0,
      solarConsumption: 208900,
      co2Saved: 179360,
      co2Produced: 6985100,
      netConsumed: 8331545,
      date: "2017-03-29T00:00:00.000Z"
    }, {
      localDate: "2017-03-30T00:00:00.000Z",
      solarGenerated: 15360,
      gridConsumed: 3379170,
      solarReturned: 0,
      solarConsumption: 15360,
      co2Saved: 13100,
      co2Produced: 2905720,
      netConsumed: 3394530,
      date: "2017-03-30T00:00:00.000Z"
    }, {
      localDate: "2017-03-31T00:00:00.000Z",
      solarGenerated: 306820,
      gridConsumed: 3177175,
      solarReturned: 0,
      solarConsumption: 306820,
      co2Saved: 263580,
      co2Produced: 2731990,
      netConsumed: 3483995,
      date: "2017-03-31T00:00:00.000Z"
    }]
  }, {
    year: 2017,
    month: "Apr",
    dates: [{
      localDate: "2017-04-01T00:00:00.000Z",
      solarGenerated: 382320,
      gridConsumed: 2579795,
      solarReturned: 70,
      solarConsumption: 382250,
      co2Saved: 328560,
      co2Produced: 2218150,
      netConsumed: 2962045,
      date: "2017-04-01T00:00:00.000Z"
    }, {
      localDate: "2017-04-02T00:00:00.000Z",
      solarGenerated: 252620,
      gridConsumed: 2354600,
      solarReturned: 555,
      solarConsumption: 252065,
      co2Saved: 217060,
      co2Produced: 2024620,
      netConsumed: 2606665,
      date: "2017-04-02T00:00:00.000Z"
    }, {
      localDate: "2017-04-03T00:00:00.000Z",
      solarGenerated: 234600,
      gridConsumed: 3612730,
      solarReturned: 65,
      solarConsumption: 234535,
      co2Saved: 201480,
      co2Produced: 3106475,
      netConsumed: 3847265,
      date: "2017-04-03T00:00:00.000Z"
    }, {
      localDate: "2017-04-04T00:00:00.000Z",
      solarGenerated: 256920,
      gridConsumed: 3195880,
      solarReturned: 85,
      solarConsumption: 256835,
      co2Saved: 220720,
      co2Produced: 2748005,
      netConsumed: 3452715,
      date: "2017-04-04T00:00:00.000Z"
    }, {
      localDate: "2017-04-05T00:00:00.000Z",
      solarGenerated: 301600,
      gridConsumed: 2797750,
      solarReturned: 45,
      solarConsumption: 301555,
      co2Saved: 259280,
      co2Produced: 2405675,
      netConsumed: 3099305,
      date: "2017-04-05T00:00:00.000Z"
    }, {
      localDate: "2017-04-06T00:00:00.000Z",
      solarGenerated: 182780,
      gridConsumed: 2818410,
      solarReturned: 50,
      solarConsumption: 182730,
      co2Saved: 157000,
      co2Produced: 2423390,
      netConsumed: 3001140,
      date: "2017-04-06T00:00:00.000Z"
    }, {
      localDate: "2017-04-07T00:00:00.000Z",
      solarGenerated: 367900,
      gridConsumed: 2719860,
      solarReturned: 70,
      solarConsumption: 367830,
      co2Saved: 316040,
      co2Produced: 2338670,
      netConsumed: 3087690,
      date: "2017-04-07T00:00:00.000Z"
    }, {
      localDate: "2017-04-08T00:00:00.000Z",
      solarGenerated: 295200,
      gridConsumed: 1768205,
      solarReturned: 850,
      solarConsumption: 294350,
      co2Saved: 253700,
      co2Produced: 1520395,
      netConsumed: 2062555,
      date: "2017-04-08T00:00:00.000Z"
    }, {
      localDate: "2017-04-09T00:00:00.000Z",
      solarGenerated: 306200,
      gridConsumed: 1877490,
      solarReturned: 460,
      solarConsumption: 305740,
      co2Saved: 263040,
      co2Produced: 1614210,
      netConsumed: 2183230,
      date: "2017-04-09T00:00:00.000Z"
    }, {
      localDate: "2017-04-10T00:00:00.000Z",
      solarGenerated: 359380,
      gridConsumed: 2977155,
      solarReturned: 65,
      solarConsumption: 359315,
      co2Saved: 309080,
      co2Produced: 2559875,
      netConsumed: 3336470,
      date: "2017-04-10T00:00:00.000Z"
    }, {
      localDate: "2017-04-11T00:00:00.000Z",
      solarGenerated: 362940,
      gridConsumed: 3015965,
      solarReturned: 270,
      solarConsumption: 362670,
      co2Saved: 311880,
      co2Produced: 2593415,
      netConsumed: 3378635,
      date: "2017-04-11T00:00:00.000Z"
    }, {
      localDate: "2017-04-12T00:00:00.000Z",
      solarGenerated: 326820,
      gridConsumed: 3160025,
      solarReturned: 325,
      solarConsumption: 326495,
      co2Saved: 281040,
      co2Produced: 2717190,
      netConsumed: 3486520,
      date: "2017-04-12T00:00:00.000Z"
    }, {
      localDate: "2017-04-13T00:00:00.000Z",
      solarGenerated: 281520,
      gridConsumed: 3352780,
      solarReturned: 35,
      solarConsumption: 281485,
      co2Saved: 241760,
      co2Produced: 2882925,
      netConsumed: 3634265,
      date: "2017-04-13T00:00:00.000Z"
    }, {
      localDate: "2017-04-14T00:00:00.000Z",
      solarGenerated: 236200,
      gridConsumed: 2471610,
      solarReturned: 85,
      solarConsumption: 236115,
      co2Saved: 202880,
      co2Produced: 2125150,
      netConsumed: 2707725,
      date: "2017-04-14T00:00:00.000Z"
    }, {
      localDate: "2017-04-15T00:00:00.000Z",
      solarGenerated: 270860,
      gridConsumed: 2222825,
      solarReturned: 230,
      solarConsumption: 270630,
      co2Saved: 232720,
      co2Produced: 1911130,
      netConsumed: 2493455,
      date: "2017-04-15T00:00:00.000Z"
    }, {
      localDate: "2017-04-16T00:00:00.000Z",
      solarGenerated: 284020,
      gridConsumed: 2541655,
      solarReturned: 565,
      solarConsumption: 283455,
      co2Saved: 244080,
      co2Produced: 2185410,
      netConsumed: 2825110,
      date: "2017-04-16T00:00:00.000Z"
    }, {
      localDate: "2017-04-17T00:00:00.000Z",
      solarGenerated: 238780,
      gridConsumed: 2723360,
      solarReturned: 100,
      solarConsumption: 238680,
      co2Saved: 205260,
      co2Produced: 2341680,
      netConsumed: 2962040,
      date: "2017-04-17T00:00:00.000Z"
    }, {
      localDate: "2017-04-18T00:00:00.000Z",
      solarGenerated: 291880,
      gridConsumed: 4340620,
      solarReturned: 40,
      solarConsumption: 291840,
      co2Saved: 250820,
      co2Produced: 3732515,
      netConsumed: 4632460,
      date: "2017-04-18T00:00:00.000Z"
    }, {
      localDate: "2017-04-19T00:00:00.000Z",
      solarGenerated: 294860,
      gridConsumed: 6015590,
      solarReturned: 5,
      solarConsumption: 294855,
      co2Saved: 253340,
      co2Produced: 5173070,
      netConsumed: 6310445,
      date: "2017-04-19T00:00:00.000Z"
    }, {
      localDate: "2017-04-20T00:00:00.000Z",
      solarGenerated: 285640,
      gridConsumed: 5974985,
      solarReturned: 295,
      solarConsumption: 285345,
      co2Saved: 245460,
      co2Produced: 5138100,
      netConsumed: 6260330,
      date: "2017-04-20T00:00:00.000Z"
    }, {
      localDate: "2017-04-21T00:00:00.000Z",
      solarGenerated: 237820,
      gridConsumed: 5448415,
      solarReturned: 450,
      solarConsumption: 237370,
      co2Saved: 204500,
      co2Produced: 4685270,
      netConsumed: 5685785,
      date: "2017-04-21T00:00:00.000Z"
    }, {
      localDate: "2017-04-22T00:00:00.000Z",
      solarGenerated: 223200,
      gridConsumed: 3286025,
      solarReturned: 1060,
      solarConsumption: 222140,
      co2Saved: 191540,
      co2Produced: 2825675,
      netConsumed: 3508165,
      date: "2017-04-22T00:00:00.000Z"
    }, {
      localDate: "2017-04-23T00:00:00.000Z",
      solarGenerated: 294500,
      gridConsumed: 3319410,
      solarReturned: 115,
      solarConsumption: 294385,
      co2Saved: 253000,
      co2Produced: 2854315,
      netConsumed: 3613795,
      date: "2017-04-23T00:00:00.000Z"
    }, {
      localDate: "2017-04-24T00:00:00.000Z",
      solarGenerated: 243220,
      gridConsumed: 6092545,
      solarReturned: 405,
      solarConsumption: 242815,
      co2Saved: 208940,
      co2Produced: 5239145,
      netConsumed: 6335360,
      date: "2017-04-24T00:00:00.000Z"
    }, {
      localDate: "2017-04-25T00:00:00.000Z",
      solarGenerated: 270920,
      gridConsumed: 3114520,
      solarReturned: 390,
      solarConsumption: 270530,
      co2Saved: 232800,
      co2Produced: 2678115,
      netConsumed: 3385050,
      date: "2017-04-25T00:00:00.000Z"
    }, {
      localDate: "2017-04-26T00:00:00.000Z",
      solarGenerated: 96540,
      gridConsumed: 5387025,
      solarReturned: 415,
      solarConsumption: 96125,
      co2Saved: 82680,
      co2Produced: 4632390,
      netConsumed: 5483150,
      date: "2017-04-26T00:00:00.000Z"
    }, {
      localDate: "2017-04-27T00:00:00.000Z",
      solarGenerated: 337860,
      gridConsumed: 5183520,
      solarReturned: 260,
      solarConsumption: 337600,
      co2Saved: 290400,
      co2Produced: 4457440,
      netConsumed: 5521120,
      date: "2017-04-27T00:00:00.000Z"
    }, {
      localDate: "2017-04-28T00:00:00.000Z",
      solarGenerated: 283940,
      gridConsumed: 5118715,
      solarReturned: 905,
      solarConsumption: 283035,
      co2Saved: 243920,
      co2Produced: 4401685,
      netConsumed: 5401750,
      date: "2017-04-28T00:00:00.000Z"
    }, {
      localDate: "2017-04-29T00:00:00.000Z",
      solarGenerated: 320560,
      gridConsumed: 2788350,
      solarReturned: 1135,
      solarConsumption: 319425,
      co2Saved: 275400,
      co2Produced: 2397585,
      netConsumed: 3107775,
      date: "2017-04-29T00:00:00.000Z"
    }, {
      localDate: "2017-04-30T00:00:00.000Z",
      solarGenerated: 295580,
      gridConsumed: 2773125,
      solarReturned: 945,
      solarConsumption: 294635,
      co2Saved: 254060,
      co2Produced: 2384570,
      netConsumed: 3067760,
      date: "2017-04-30T00:00:00.000Z"
    }]
  }, {
    year: 2017,
    month: "May",
    dates: [{
      localDate: "2017-05-01T00:00:00.000Z",
      solarGenerated: 292400,
      gridConsumed: 2885955,
      solarReturned: 310,
      solarConsumption: 292090,
      co2Saved: 251300,
      co2Produced: 2481485,
      netConsumed: 3178045,
      date: "2017-05-01T00:00:00.000Z"
    }, {
      localDate: "2017-05-02T00:00:00.000Z",
      solarGenerated: 286800,
      gridConsumed: 5955910,
      solarReturned: 190,
      solarConsumption: 286610,
      co2Saved: 246440,
      co2Produced: 5121665,
      netConsumed: 6242520,
      date: "2017-05-02T00:00:00.000Z"
    }, {
      localDate: "2017-05-03T00:00:00.000Z",
      solarGenerated: 278120,
      gridConsumed: 6137965,
      solarReturned: 230,
      solarConsumption: 277890,
      co2Saved: 238940,
      co2Produced: 5278265,
      netConsumed: 6415855,
      date: "2017-05-03T00:00:00.000Z"
    }, {
      localDate: "2017-05-04T00:00:00.000Z",
      solarGenerated: 203320,
      gridConsumed: 5290670,
      solarReturned: 155,
      solarConsumption: 203165,
      co2Saved: 174660,
      co2Produced: 4549570,
      netConsumed: 5493835,
      date: "2017-05-04T00:00:00.000Z"
    }, {
      localDate: "2017-05-05T00:00:00.000Z",
      solarGenerated: 259840,
      gridConsumed: 5257315,
      solarReturned: 380,
      solarConsumption: 259460,
      co2Saved: 223120,
      co2Produced: 4520945,
      netConsumed: 5516775,
      date: "2017-05-05T00:00:00.000Z"
    }, {
      localDate: "2017-05-06T00:00:00.000Z",
      solarGenerated: 278900,
      gridConsumed: 2795740,
      solarReturned: 1180,
      solarConsumption: 277720,
      co2Saved: 239700,
      co2Produced: 2403935,
      netConsumed: 3073460,
      date: "2017-05-06T00:00:00.000Z"
    }, {
      localDate: "2017-05-07T00:00:00.000Z",
      solarGenerated: 251580,
      gridConsumed: 2681975,
      solarReturned: 910,
      solarConsumption: 250670,
      co2Saved: 216200,
      co2Produced: 2305970,
      netConsumed: 2932645,
      date: "2017-05-07T00:00:00.000Z"
    }, {
      localDate: "2017-05-08T00:00:00.000Z",
      solarGenerated: 126040,
      gridConsumed: 4816190,
      solarReturned: 260,
      solarConsumption: 125780,
      co2Saved: 108160,
      co2Produced: 4141460,
      netConsumed: 4941970,
      date: "2017-05-08T00:00:00.000Z"
    }, {
      localDate: "2017-05-09T00:00:00.000Z",
      solarGenerated: 244820,
      gridConsumed: 5214220,
      solarReturned: 495,
      solarConsumption: 244325,
      co2Saved: 210360,
      co2Produced: 4483830,
      netConsumed: 5458545,
      date: "2017-05-09T00:00:00.000Z"
    }, {
      localDate: "2017-05-10T00:00:00.000Z",
      solarGenerated: 41300,
      gridConsumed: 4596500,
      solarReturned: 305,
      solarConsumption: 40995,
      co2Saved: 35360,
      co2Produced: 3952545,
      netConsumed: 4637495,
      date: "2017-05-10T00:00:00.000Z"
    }, {
      localDate: "2017-05-11T00:00:00.000Z",
      solarGenerated: 249000,
      gridConsumed: 4951195,
      solarReturned: 30,
      solarConsumption: 248970,
      co2Saved: 214000,
      co2Produced: 4257630,
      netConsumed: 5200165,
      date: "2017-05-11T00:00:00.000Z"
    }, {
      localDate: "2017-05-12T00:00:00.000Z",
      solarGenerated: 210840,
      gridConsumed: 4854465,
      solarReturned: 180,
      solarConsumption: 210660,
      co2Saved: 181000,
      co2Produced: 4174440,
      netConsumed: 5065125,
      date: "2017-05-12T00:00:00.000Z"
    }, {
      localDate: "2017-05-13T00:00:00.000Z",
      solarGenerated: 160800,
      gridConsumed: 2844535,
      solarReturned: 530,
      solarConsumption: 160270,
      co2Saved: 138180,
      co2Produced: 2445925,
      netConsumed: 3004805,
      date: "2017-05-13T00:00:00.000Z"
    }, {
      localDate: "2017-05-14T00:00:00.000Z",
      solarGenerated: 119420,
      gridConsumed: 2298205,
      solarReturned: 1150,
      solarConsumption: 118270,
      co2Saved: 102480,
      co2Produced: 1976155,
      netConsumed: 2416475,
      date: "2017-05-14T00:00:00.000Z"
    }, {
      localDate: "2017-05-15T00:00:00.000Z",
      solarGenerated: 270780,
      gridConsumed: 5056625,
      solarReturned: 260,
      solarConsumption: 270520,
      co2Saved: 232700,
      co2Produced: 4348305,
      netConsumed: 5327145,
      date: "2017-05-15T00:00:00.000Z"
    }, {
      localDate: "2017-05-16T00:00:00.000Z",
      solarGenerated: 284080,
      gridConsumed: 4659015,
      solarReturned: 495,
      solarConsumption: 283585,
      co2Saved: 244200,
      co2Produced: 4006250,
      netConsumed: 4942600,
      date: "2017-05-16T00:00:00.000Z"
    }, {
      localDate: "2017-05-17T00:00:00.000Z",
      solarGenerated: 234660,
      gridConsumed: 5099780,
      solarReturned: 485,
      solarConsumption: 234175,
      co2Saved: 201720,
      co2Produced: 4385410,
      netConsumed: 5333955,
      date: "2017-05-17T00:00:00.000Z"
    }, {
      localDate: "2017-05-18T00:00:00.000Z",
      solarGenerated: 157600,
      gridConsumed: 5350070,
      solarReturned: 370,
      solarConsumption: 157230,
      co2Saved: 135320,
      co2Produced: 4600610,
      netConsumed: 5507300,
      date: "2017-05-18T00:00:00.000Z"
    }, {
      localDate: "2017-05-19T00:00:00.000Z",
      solarGenerated: 62980,
      gridConsumed: 4827965,
      solarReturned: 370,
      solarConsumption: 62610,
      co2Saved: 54140,
      co2Produced: 4151605,
      netConsumed: 4890575,
      date: "2017-05-19T00:00:00.000Z"
    }, {
      localDate: "2017-05-20T00:00:00.000Z",
      solarGenerated: 177000,
      gridConsumed: 2757600,
      solarReturned: 840,
      solarConsumption: 176160,
      co2Saved: 152000,
      co2Produced: 2371200,
      netConsumed: 2933760,
      date: "2017-05-20T00:00:00.000Z"
    }, {
      localDate: "2017-05-21T00:00:00.000Z",
      solarGenerated: 244440,
      gridConsumed: 2651060,
      solarReturned: 810,
      solarConsumption: 243630,
      co2Saved: 210000,
      co2Produced: 2279620,
      netConsumed: 2894690,
      date: "2017-05-21T00:00:00.000Z"
    }, {
      localDate: "2017-05-22T00:00:00.000Z",
      solarGenerated: 243360,
      gridConsumed: 5377785,
      solarReturned: 255,
      solarConsumption: 243105,
      co2Saved: 209000,
      co2Produced: 4624595,
      netConsumed: 5620890,
      date: "2017-05-22T00:00:00.000Z"
    }, {
      localDate: "2017-05-23T00:00:00.000Z",
      solarGenerated: 259520,
      gridConsumed: 5318895,
      solarReturned: 80,
      solarConsumption: 259440,
      co2Saved: 223000,
      co2Produced: 4573825,
      netConsumed: 5578335,
      date: "2017-05-23T00:00:00.000Z"
    }, {
      localDate: "2017-05-24T00:00:00.000Z",
      solarGenerated: 225040,
      gridConsumed: 5213320,
      solarReturned: 195,
      solarConsumption: 224845,
      co2Saved: 193460,
      co2Produced: 4483040,
      netConsumed: 5438165,
      date: "2017-05-24T00:00:00.000Z"
    }, {
      localDate: "2017-05-25T00:00:00.000Z",
      solarGenerated: 245520,
      gridConsumed: 5132560,
      solarReturned: 575,
      solarConsumption: 244945,
      co2Saved: 210860,
      co2Produced: 4413645,
      netConsumed: 5377505,
      date: "2017-05-25T00:00:00.000Z"
    }, {
      localDate: "2017-05-26T00:00:00.000Z",
      solarGenerated: 257740,
      gridConsumed: 4710395,
      solarReturned: 145,
      solarConsumption: 257595,
      co2Saved: 221440,
      co2Produced: 4050495,
      netConsumed: 4967990,
      date: "2017-05-26T00:00:00.000Z"
    }, {
      localDate: "2017-05-27T00:00:00.000Z",
      solarGenerated: 241560,
      gridConsumed: 2292850,
      solarReturned: 255,
      solarConsumption: 241305,
      co2Saved: 207600,
      co2Produced: 1971550,
      netConsumed: 2534155,
      date: "2017-05-27T00:00:00.000Z"
    }, {
      localDate: "2017-05-28T00:00:00.000Z",
      solarGenerated: 254740,
      gridConsumed: 2561430,
      solarReturned: 360,
      solarConsumption: 254380,
      co2Saved: 218900,
      co2Produced: 2202400,
      netConsumed: 2815810,
      date: "2017-05-28T00:00:00.000Z"
    }, {
      localDate: "2017-05-29T00:00:00.000Z",
      solarGenerated: 264600,
      gridConsumed: 5221450,
      solarReturned: 20,
      solarConsumption: 264580,
      co2Saved: 227340,
      co2Produced: 4489990,
      netConsumed: 5486030,
      date: "2017-05-29T00:00:00.000Z"
    }, {
      localDate: "2017-05-30T00:00:00.000Z",
      solarGenerated: 252740,
      gridConsumed: 5322595,
      solarReturned: 100,
      solarConsumption: 252640,
      co2Saved: 217320,
      co2Produced: 4576975,
      netConsumed: 5575235,
      date: "2017-05-30T00:00:00.000Z"
    }, {
      localDate: "2017-05-31T00:00:00.000Z",
      solarGenerated: 268040,
      gridConsumed: 4605235,
      solarReturned: 305,
      solarConsumption: 267735,
      co2Saved: 230400,
      co2Produced: 3960025,
      netConsumed: 4872970,
      date: "2017-05-31T00:00:00.000Z"
    }]
  }, {
    year: 2017,
    month: "Jun",
    dates: [{
      localDate: "2017-06-01T00:00:00.000Z",
      solarGenerated: 263660,
      gridConsumed: 4811265,
      solarReturned: 320,
      solarConsumption: 263340,
      co2Saved: 226480,
      co2Produced: 4137265,
      netConsumed: 5074605,
      date: "2017-06-01T00:00:00.000Z"
    }, {
      localDate: "2017-06-02T00:00:00.000Z",
      solarGenerated: 266580,
      gridConsumed: 5086860,
      solarReturned: 110,
      solarConsumption: 266470,
      co2Saved: 229200,
      co2Produced: 4374255,
      netConsumed: 5353330,
      date: "2017-06-02T00:00:00.000Z"
    }, {
      localDate: "2017-06-03T00:00:00.000Z",
      solarGenerated: 258400,
      gridConsumed: 2572815,
      solarReturned: 440,
      solarConsumption: 257960,
      co2Saved: 222120,
      co2Produced: 2212250,
      netConsumed: 2830775,
      date: "2017-06-03T00:00:00.000Z"
    }, {
      localDate: "2017-06-04T00:00:00.000Z",
      solarGenerated: 243480,
      gridConsumed: 2019305,
      solarReturned: 1635,
      solarConsumption: 241845,
      co2Saved: 209160,
      co2Produced: 1736215,
      netConsumed: 2261150,
      date: "2017-06-04T00:00:00.000Z"
    }, {
      localDate: "2017-06-05T00:00:00.000Z",
      solarGenerated: 260720,
      gridConsumed: 5153465,
      solarReturned: 400,
      solarConsumption: 260320,
      co2Saved: 224160,
      co2Produced: 4431535,
      netConsumed: 5413785,
      date: "2017-06-05T00:00:00.000Z"
    }, {
      localDate: "2017-06-06T00:00:00.000Z",
      solarGenerated: 235320,
      gridConsumed: 5138695,
      solarReturned: 95,
      solarConsumption: 235225,
      co2Saved: 202180,
      co2Produced: 4418910,
      netConsumed: 5373920,
      date: "2017-06-06T00:00:00.000Z"
    }, {
      localDate: "2017-06-07T00:00:00.000Z",
      solarGenerated: 264180,
      gridConsumed: 4959610,
      solarReturned: 65,
      solarConsumption: 264115,
      co2Saved: 227120,
      co2Produced: 4264845,
      netConsumed: 5223725,
      date: "2017-06-07T00:00:00.000Z"
    }, {
      localDate: "2017-06-08T00:00:00.000Z",
      solarGenerated: 259260,
      gridConsumed: 5056390,
      solarReturned: 0,
      solarConsumption: 259260,
      co2Saved: 222840,
      co2Produced: 4347965,
      netConsumed: 5315650,
      date: "2017-06-08T00:00:00.000Z"
    }, {
      localDate: "2017-06-09T00:00:00.000Z",
      solarGenerated: 189860,
      gridConsumed: 4987425,
      solarReturned: 0,
      solarConsumption: 189860,
      co2Saved: 163180,
      co2Produced: 4288730,
      netConsumed: 5177285,
      date: "2017-06-09T00:00:00.000Z"
    }, {
      localDate: "2017-06-10T00:00:00.000Z",
      solarGenerated: 189300,
      gridConsumed: 2659795,
      solarReturned: 20,
      solarConsumption: 189280,
      co2Saved: 162540,
      co2Produced: 2287030,
      netConsumed: 2849075,
      date: "2017-06-10T00:00:00.000Z"
    }, {
      localDate: "2017-06-11T00:00:00.000Z",
      solarGenerated: 84880,
      gridConsumed: 2760740,
      solarReturned: 5,
      solarConsumption: 84875,
      co2Saved: 72880,
      co2Produced: 2373910,
      netConsumed: 2845615,
      date: "2017-06-11T00:00:00.000Z"
    }, {
      localDate: "2017-06-12T00:00:00.000Z",
      solarGenerated: 182880,
      gridConsumed: 4824740,
      solarReturned: 0,
      solarConsumption: 182880,
      co2Saved: 157160,
      co2Produced: 4148880,
      netConsumed: 5007620,
      date: "2017-06-12T00:00:00.000Z"
    }, {
      localDate: "2017-06-13T00:00:00.000Z",
      solarGenerated: 38800,
      gridConsumed: 4732095,
      solarReturned: 0,
      solarConsumption: 38800,
      co2Saved: 33240,
      co2Produced: 4069255,
      netConsumed: 4770895,
      date: "2017-06-13T00:00:00.000Z"
    }, {
      localDate: "2017-06-14T00:00:00.000Z",
      solarGenerated: 101580,
      gridConsumed: 4429335,
      solarReturned: 0,
      solarConsumption: 101580,
      co2Saved: 87020,
      co2Produced: 3808790,
      netConsumed: 4530915,
      date: "2017-06-14T00:00:00.000Z"
    }, {
      localDate: "2017-06-15T00:00:00.000Z",
      solarGenerated: 179320,
      gridConsumed: 4811310,
      solarReturned: 0,
      solarConsumption: 179320,
      co2Saved: 153940,
      co2Produced: 4137355,
      netConsumed: 4990630,
      date: "2017-06-15T00:00:00.000Z"
    }, {
      localDate: "2017-06-16T00:00:00.000Z",
      solarGenerated: 194000,
      gridConsumed: 4989635,
      solarReturned: 10,
      solarConsumption: 193990,
      co2Saved: 166720,
      co2Produced: 4290700,
      netConsumed: 5183625,
      date: "2017-06-16T00:00:00.000Z"
    }, {
      localDate: "2017-06-17T00:00:00.000Z",
      solarGenerated: 181060,
      gridConsumed: 2943695,
      solarReturned: 310,
      solarConsumption: 180750,
      co2Saved: 155540,
      co2Produced: 2531190,
      netConsumed: 3124445,
      date: "2017-06-17T00:00:00.000Z"
    }, {
      localDate: "2017-06-18T00:00:00.000Z",
      solarGenerated: 247040,
      gridConsumed: 2866640,
      solarReturned: 960,
      solarConsumption: 246080,
      co2Saved: 212280,
      co2Produced: 2464940,
      netConsumed: 3112720,
      date: "2017-06-18T00:00:00.000Z"
    }, {
      localDate: "2017-06-19T00:00:00.000Z",
      solarGenerated: 179060,
      gridConsumed: 4933250,
      solarReturned: 95,
      solarConsumption: 178965,
      co2Saved: 153740,
      co2Produced: 4242165,
      netConsumed: 5112215,
      date: "2017-06-19T00:00:00.000Z"
    }, {
      localDate: "2017-06-20T00:00:00.000Z",
      solarGenerated: 132440,
      gridConsumed: 4516995,
      solarReturned: 85,
      solarConsumption: 132355,
      co2Saved: 113900,
      co2Produced: 3884225,
      netConsumed: 4649350,
      date: "2017-06-20T00:00:00.000Z"
    }, {
      localDate: "2017-06-21T00:00:00.000Z",
      solarGenerated: 237320,
      gridConsumed: 4813560,
      solarReturned: 135,
      solarConsumption: 237185,
      co2Saved: 203940,
      co2Produced: 4139230,
      netConsumed: 5050745,
      date: "2017-06-21T00:00:00.000Z"
    }, {
      localDate: "2017-06-22T00:00:00.000Z",
      solarGenerated: 193860,
      gridConsumed: 4552985,
      solarReturned: 120,
      solarConsumption: 193740,
      co2Saved: 166520,
      co2Produced: 3915000,
      netConsumed: 4746725,
      date: "2017-06-22T00:00:00.000Z"
    }, {
      localDate: "2017-06-23T00:00:00.000Z",
      solarGenerated: 252320,
      gridConsumed: 4705140,
      solarReturned: 90,
      solarConsumption: 252230,
      co2Saved: 216980,
      co2Produced: 4046105,
      netConsumed: 4957370,
      date: "2017-06-23T00:00:00.000Z"
    }, {
      localDate: "2017-06-24T00:00:00.000Z",
      solarGenerated: 241180,
      gridConsumed: 2641925,
      solarReturned: 450,
      solarConsumption: 240730,
      co2Saved: 207260,
      co2Produced: 2271565,
      netConsumed: 2882655,
      date: "2017-06-24T00:00:00.000Z"
    }, {
      localDate: "2017-06-25T00:00:00.000Z",
      solarGenerated: 243380,
      gridConsumed: 2269290,
      solarReturned: 740,
      solarConsumption: 242640,
      co2Saved: 209120,
      co2Produced: 1951040,
      netConsumed: 2511930,
      date: "2017-06-25T00:00:00.000Z"
    }, {
      localDate: "2017-06-26T00:00:00.000Z",
      solarGenerated: 245340,
      gridConsumed: 3560140,
      solarReturned: 65,
      solarConsumption: 245275,
      co2Saved: 210680,
      co2Produced: 3061365,
      netConsumed: 3805415,
      date: "2017-06-26T00:00:00.000Z"
    }, {
      localDate: "2017-06-27T00:00:00.000Z",
      solarGenerated: 156900,
      gridConsumed: 3296705,
      solarReturned: 115,
      solarConsumption: 156785,
      co2Saved: 134780,
      co2Produced: 2834720,
      netConsumed: 3453490,
      date: "2017-06-27T00:00:00.000Z"
    }, {
      localDate: "2017-06-28T00:00:00.000Z",
      solarGenerated: 225480,
      gridConsumed: 3174660,
      solarReturned: 150,
      solarConsumption: 225330,
      co2Saved: 193740,
      co2Produced: 2729850,
      netConsumed: 3399990,
      date: "2017-06-28T00:00:00.000Z"
    }, {
      localDate: "2017-06-29T00:00:00.000Z",
      solarGenerated: 240120,
      gridConsumed: 3164278,
      solarReturned: 125,
      solarConsumption: 239995,
      co2Saved: 206420,
      co2Produced: 2720913,
      netConsumed: 3404273,
      date: "2017-06-29T00:00:00.000Z"
    }, {
      localDate: "2017-06-30T00:00:00.000Z",
      solarGenerated: 229560,
      gridConsumed: 3651810,
      solarReturned: 440,
      solarConsumption: 229120,
      co2Saved: 197280,
      co2Produced: 3140265,
      netConsumed: 3880930,
      date: "2017-06-30T00:00:00.000Z"
    }]
  }, {
    year: 2017,
    month: "Jul",
    dates: [{
      localDate: "2017-07-01T00:00:00.000Z",
      solarGenerated: 268820,
      gridConsumed: 2744290,
      solarReturned: 1215,
      solarConsumption: 267605,
      co2Saved: 231060,
      co2Produced: 2359695,
      netConsumed: 3011895,
      date: "2017-07-01T00:00:00.000Z"
    }, {
      localDate: "2017-07-02T00:00:00.000Z",
      solarGenerated: 260220,
      gridConsumed: 2548065,
      solarReturned: 1000,
      solarConsumption: 259220,
      co2Saved: 223720,
      co2Produced: 2190960,
      netConsumed: 2807285,
      date: "2017-07-02T00:00:00.000Z"
    }, {
      localDate: "2017-07-03T00:00:00.000Z",
      solarGenerated: 216780,
      gridConsumed: 3401675,
      solarReturned: 60,
      solarConsumption: 216720,
      co2Saved: 186220,
      co2Produced: 2925100,
      netConsumed: 3618395,
      date: "2017-07-03T00:00:00.000Z"
    }, {
      localDate: "2017-07-04T00:00:00.000Z",
      solarGenerated: 240080,
      gridConsumed: 3211555,
      solarReturned: 190,
      solarConsumption: 239890,
      co2Saved: 206440,
      co2Produced: 2761440,
      netConsumed: 3451445,
      date: "2017-07-04T00:00:00.000Z"
    }, {
      localDate: "2017-07-05T00:00:00.000Z",
      solarGenerated: 251640,
      gridConsumed: 3283620,
      solarReturned: 110,
      solarConsumption: 251530,
      co2Saved: 216300,
      co2Produced: 2823525,
      netConsumed: 3535150,
      date: "2017-07-05T00:00:00.000Z"
    }, {
      localDate: "2017-07-06T00:00:00.000Z",
      solarGenerated: 259360,
      gridConsumed: 2802680,
      solarReturned: 315,
      solarConsumption: 259045,
      co2Saved: 222780,
      co2Produced: 2409900,
      netConsumed: 3061725,
      date: "2017-07-06T00:00:00.000Z"
    }, {
      localDate: "2017-07-07T00:00:00.000Z",
      solarGenerated: 52040,
      gridConsumed: 3200075,
      solarReturned: 245,
      solarConsumption: 51795,
      co2Saved: 44660,
      co2Produced: 2751595,
      netConsumed: 3251870,
      date: "2017-07-07T00:00:00.000Z"
    }, {
      localDate: "2017-07-08T00:00:00.000Z",
      solarGenerated: 266960,
      gridConsumed: 2475830,
      solarReturned: 1155,
      solarConsumption: 265805,
      co2Saved: 229560,
      co2Produced: 2128790,
      netConsumed: 2741635,
      date: "2017-07-08T00:00:00.000Z"
    }, {
      localDate: "2017-07-09T00:00:00.000Z",
      solarGenerated: 265200,
      gridConsumed: 2385420,
      solarReturned: 960,
      solarConsumption: 264240,
      co2Saved: 227960,
      co2Produced: 2051135,
      netConsumed: 2649660,
      date: "2017-07-09T00:00:00.000Z"
    }, {
      localDate: "2017-07-10T00:00:00.000Z",
      solarGenerated: 189820,
      gridConsumed: 3411470,
      solarReturned: 240,
      solarConsumption: 189580,
      co2Saved: 163060,
      co2Produced: 2933415,
      netConsumed: 3601050,
      date: "2017-07-10T00:00:00.000Z"
    }, {
      localDate: "2017-07-11T00:00:00.000Z",
      solarGenerated: 236780,
      gridConsumed: 4775525,
      solarReturned: 180,
      solarConsumption: 236600,
      co2Saved: 203520,
      co2Produced: 4106500,
      netConsumed: 5012125,
      date: "2017-07-11T00:00:00.000Z"
    }, {
      localDate: "2017-07-12T00:00:00.000Z",
      solarGenerated: 221120,
      gridConsumed: 5114730,
      solarReturned: 35,
      solarConsumption: 221085,
      co2Saved: 190060,
      co2Produced: 4398300,
      netConsumed: 5335815,
      date: "2017-07-12T00:00:00.000Z"
    }, {
      localDate: "2017-07-13T00:00:00.000Z",
      solarGenerated: 233320,
      gridConsumed: 5134670,
      solarReturned: 0,
      solarConsumption: 233320,
      co2Saved: 200620,
      co2Produced: 4415440,
      netConsumed: 5367990,
      date: "2017-07-13T00:00:00.000Z"
    }, {
      localDate: "2017-07-14T00:00:00.000Z",
      solarGenerated: 249040,
      gridConsumed: 5510475,
      solarReturned: 0,
      solarConsumption: 249040,
      co2Saved: 213960,
      co2Produced: 4738660,
      netConsumed: 5759515,
      date: "2017-07-14T00:00:00.000Z"
    }, {
      localDate: "2017-07-15T00:00:00.000Z",
      solarGenerated: 260600,
      gridConsumed: 3424210,
      solarReturned: 40,
      solarConsumption: 260560,
      co2Saved: 223820,
      co2Produced: 2944480,
      netConsumed: 3684770,
      date: "2017-07-15T00:00:00.000Z"
    }, {
      localDate: "2017-07-16T00:00:00.000Z",
      solarGenerated: 215640,
      gridConsumed: 2517385,
      solarReturned: 280,
      solarConsumption: 215360,
      co2Saved: 185200,
      co2Produced: 2164485,
      netConsumed: 2732745,
      date: "2017-07-16T00:00:00.000Z"
    }, {
      localDate: "2017-07-17T00:00:00.000Z",
      solarGenerated: 237520,
      gridConsumed: 5193065,
      solarReturned: 0,
      solarConsumption: 237520,
      co2Saved: 204100,
      co2Produced: 4465590,
      netConsumed: 5430585,
      date: "2017-07-17T00:00:00.000Z"
    }, {
      localDate: "2017-07-18T00:00:00.000Z",
      solarGenerated: 257800,
      gridConsumed: 5341845,
      solarReturned: 15,
      solarConsumption: 257785,
      co2Saved: 221560,
      co2Produced: 4593560,
      netConsumed: 5599630,
      date: "2017-07-18T00:00:00.000Z"
    }, {
      localDate: "2017-07-19T00:00:00.000Z",
      solarGenerated: 292200,
      gridConsumed: 4915080,
      solarReturned: 90,
      solarConsumption: 292110,
      co2Saved: 251280,
      co2Produced: 4226585,
      netConsumed: 5207190,
      date: "2017-07-19T00:00:00.000Z"
    }, {
      localDate: "2017-07-20T00:00:00.000Z",
      solarGenerated: 285900,
      gridConsumed: 5265505,
      solarReturned: 740,
      solarConsumption: 285160,
      co2Saved: 245680,
      co2Produced: 4527865,
      netConsumed: 5550665,
      date: "2017-07-20T00:00:00.000Z"
    }, {
      localDate: "2017-07-21T00:00:00.000Z",
      solarGenerated: 289940,
      gridConsumed: 5203120,
      solarReturned: 545,
      solarConsumption: 289395,
      co2Saved: 249040,
      co2Produced: 4474225,
      netConsumed: 5492515,
      date: "2017-07-21T00:00:00.000Z"
    }, {
      localDate: "2017-07-22T00:00:00.000Z",
      solarGenerated: 280180,
      gridConsumed: 3036705,
      solarReturned: 435,
      solarConsumption: 279745,
      co2Saved: 240740,
      co2Produced: 2611195,
      netConsumed: 3316450,
      date: "2017-07-22T00:00:00.000Z"
    }, {
      localDate: "2017-07-23T00:00:00.000Z",
      solarGenerated: 285260,
      gridConsumed: 2847065,
      solarReturned: 820,
      solarConsumption: 284440,
      co2Saved: 245200,
      co2Produced: 2448090,
      netConsumed: 3131505,
      date: "2017-07-23T00:00:00.000Z"
    }, {
      localDate: "2017-07-24T00:00:00.000Z",
      solarGenerated: 284100,
      gridConsumed: 5425630,
      solarReturned: 0,
      solarConsumption: 284100,
      co2Saved: 244200,
      co2Produced: 4665665,
      netConsumed: 5709730,
      date: "2017-07-24T00:00:00.000Z"
    }, {
      localDate: "2017-07-25T00:00:00.000Z",
      solarGenerated: 289960,
      gridConsumed: 5499995,
      solarReturned: 220,
      solarConsumption: 289740,
      co2Saved: 249220,
      co2Produced: 4729570,
      netConsumed: 5789735,
      date: "2017-07-25T00:00:00.000Z"
    }, {
      localDate: "2017-07-26T00:00:00.000Z",
      solarGenerated: 284980,
      gridConsumed: 5334355,
      solarReturned: 1320,
      solarConsumption: 283660,
      co2Saved: 244840,
      co2Produced: 4587140,
      netConsumed: 5618015,
      date: "2017-07-26T00:00:00.000Z"
    }, {
      localDate: "2017-07-27T00:00:00.000Z",
      solarGenerated: 286820,
      gridConsumed: 5195425,
      solarReturned: 1195,
      solarConsumption: 285625,
      co2Saved: 246400,
      co2Produced: 4467640,
      netConsumed: 5481050,
      date: "2017-07-27T00:00:00.000Z"
    }, {
      localDate: "2017-07-28T00:00:00.000Z",
      solarGenerated: 269780,
      gridConsumed: 5427355,
      solarReturned: 575,
      solarConsumption: 269205,
      co2Saved: 231740,
      co2Produced: 4667160,
      netConsumed: 5696560,
      date: "2017-07-28T00:00:00.000Z"
    }, {
      localDate: "2017-07-29T00:00:00.000Z",
      solarGenerated: 290620,
      gridConsumed: 3207300,
      solarReturned: 1075,
      solarConsumption: 289545,
      co2Saved: 249780,
      co2Produced: 2757915,
      netConsumed: 3496845,
      date: "2017-07-29T00:00:00.000Z"
    }, {
      localDate: "2017-07-30T00:00:00.000Z",
      solarGenerated: 290920,
      gridConsumed: 3021540,
      solarReturned: 1775,
      solarConsumption: 289145,
      co2Saved: 250120,
      co2Produced: 2598210,
      netConsumed: 3310685,
      date: "2017-07-30T00:00:00.000Z"
    }, {
      localDate: "2017-07-31T00:00:00.000Z",
      solarGenerated: 274880,
      gridConsumed: 4967230,
      solarReturned: 645,
      solarConsumption: 274235,
      co2Saved: 236240,
      co2Produced: 4271455,
      netConsumed: 5241465,
      date: "2017-07-31T00:00:00.000Z"
    }]
  }, {
    year: 2017,
    month: "Aug",
    dates: [{
      localDate: "2017-08-01T00:00:00.000Z",
      solarGenerated: 302320,
      gridConsumed: 5603165,
      solarReturned: 465,
      solarConsumption: 301855,
      co2Saved: 259900,
      co2Produced: 4818325,
      netConsumed: 5905020,
      date: "2017-08-01T00:00:00.000Z"
    }, {
      localDate: "2017-08-02T00:00:00.000Z",
      solarGenerated: 285080,
      gridConsumed: 5317930,
      solarReturned: 915,
      solarConsumption: 284165,
      co2Saved: 244980,
      co2Produced: 4573135,
      netConsumed: 5602095,
      date: "2017-08-02T00:00:00.000Z"
    }, {
      localDate: "2017-08-03T00:00:00.000Z",
      solarGenerated: 227340,
      gridConsumed: 4882295,
      solarReturned: 685,
      solarConsumption: 226655,
      co2Saved: 195340,
      co2Produced: 4198340,
      netConsumed: 5108950,
      date: "2017-08-03T00:00:00.000Z"
    }, {
      localDate: "2017-08-04T00:00:00.000Z",
      solarGenerated: 303560,
      gridConsumed: 5260535,
      solarReturned: 60,
      solarConsumption: 303500,
      co2Saved: 260920,
      co2Produced: 4523685,
      netConsumed: 5564035,
      date: "2017-08-04T00:00:00.000Z"
    }, {
      localDate: "2017-08-05T00:00:00.000Z",
      solarGenerated: 308500,
      gridConsumed: 3059265,
      solarReturned: 990,
      solarConsumption: 307510,
      co2Saved: 265300,
      co2Produced: 2630585,
      netConsumed: 3366775,
      date: "2017-08-05T00:00:00.000Z"
    }, {
      localDate: "2017-08-06T00:00:00.000Z",
      solarGenerated: 250660,
      gridConsumed: 2804275,
      solarReturned: 990,
      solarConsumption: 249670,
      co2Saved: 215340,
      co2Produced: 2411315,
      netConsumed: 3053945,
      date: "2017-08-06T00:00:00.000Z"
    }, {
      localDate: "2017-08-07T00:00:00.000Z",
      solarGenerated: 272980,
      gridConsumed: 5251655,
      solarReturned: 25,
      solarConsumption: 272955,
      co2Saved: 234740,
      co2Produced: 4516005,
      netConsumed: 5524610,
      date: "2017-08-07T00:00:00.000Z"
    }, {
      localDate: "2017-08-08T00:00:00.000Z",
      solarGenerated: 322820,
      gridConsumed: 5415235,
      solarReturned: 45,
      solarConsumption: 322775,
      co2Saved: 277300,
      co2Produced: 4656695,
      netConsumed: 5738010,
      date: "2017-08-08T00:00:00.000Z"
    }, {
      localDate: "2017-08-09T00:00:00.000Z",
      solarGenerated: 316300,
      gridConsumed: 5144410,
      solarReturned: 560,
      solarConsumption: 315740,
      co2Saved: 271740,
      co2Produced: 4423830,
      netConsumed: 5460150,
      date: "2017-08-09T00:00:00.000Z"
    }, {
      localDate: "2017-08-10T00:00:00.000Z",
      solarGenerated: 310840,
      gridConsumed: 5639845,
      solarReturned: 15,
      solarConsumption: 310825,
      co2Saved: 267180,
      co2Produced: 4849925,
      netConsumed: 5950670,
      date: "2017-08-10T00:00:00.000Z"
    }, {
      localDate: "2017-08-11T00:00:00.000Z",
      solarGenerated: 308700,
      gridConsumed: 5685345,
      solarReturned: 35,
      solarConsumption: 308665,
      co2Saved: 265380,
      co2Produced: 4888890,
      netConsumed: 5994010,
      date: "2017-08-11T00:00:00.000Z"
    }, {
      localDate: "2017-08-12T00:00:00.000Z",
      solarGenerated: 248520,
      gridConsumed: 2911065,
      solarReturned: 730,
      solarConsumption: 247790,
      co2Saved: 213600,
      co2Produced: 2503170,
      netConsumed: 3158855,
      date: "2017-08-12T00:00:00.000Z"
    }, {
      localDate: "2017-08-13T00:00:00.000Z",
      solarGenerated: 309900,
      gridConsumed: 2322700,
      solarReturned: 3665,
      solarConsumption: 306235,
      co2Saved: 266440,
      co2Produced: 1997180,
      netConsumed: 2628935,
      date: "2017-08-13T00:00:00.000Z"
    }, {
      localDate: "2017-08-14T00:00:00.000Z",
      solarGenerated: 275620,
      gridConsumed: 5221300,
      solarReturned: 1020,
      solarConsumption: 274600,
      co2Saved: 236780,
      co2Produced: 4489895,
      netConsumed: 5495900,
      date: "2017-08-14T00:00:00.000Z"
    }, {
      localDate: "2017-08-15T00:00:00.000Z",
      solarGenerated: 307140,
      gridConsumed: 5094105,
      solarReturned: 750,
      solarConsumption: 306390,
      co2Saved: 263900,
      co2Produced: 4380545,
      netConsumed: 5400495,
      date: "2017-08-15T00:00:00.000Z"
    }, {
      localDate: "2017-08-16T00:00:00.000Z",
      solarGenerated: 309480,
      gridConsumed: 2691475,
      solarReturned: 785,
      solarConsumption: 308695,
      co2Saved: 265980,
      co2Produced: 2314225,
      netConsumed: 3000170,
      date: "2017-08-16T00:00:00.000Z"
    }, {
      localDate: "2017-08-17T00:00:00.000Z",
      solarGenerated: 303800,
      gridConsumed: 6304365,
      solarReturned: 905,
      solarConsumption: 302895,
      co2Saved: 261140,
      co2Produced: 5421390,
      netConsumed: 6607260,
      date: "2017-08-17T00:00:00.000Z"
    }, {
      localDate: "2017-08-18T00:00:00.000Z",
      solarGenerated: 332200,
      gridConsumed: 5515075,
      solarReturned: 655,
      solarConsumption: 331545,
      co2Saved: 285520,
      co2Produced: 4742540,
      netConsumed: 5846620,
      date: "2017-08-18T00:00:00.000Z"
    }, {
      localDate: "2017-08-19T00:00:00.000Z",
      solarGenerated: 346260,
      gridConsumed: 2832105,
      solarReturned: 2990,
      solarConsumption: 343270,
      co2Saved: 297640,
      co2Produced: 2435210,
      netConsumed: 3175375,
      date: "2017-08-19T00:00:00.000Z"
    }, {
      localDate: "2017-08-20T00:00:00.000Z",
      solarGenerated: 336540,
      gridConsumed: 2613605,
      solarReturned: 4745,
      solarConsumption: 331795,
      co2Saved: 289240,
      co2Produced: 2247315,
      netConsumed: 2945400,
      date: "2017-08-20T00:00:00.000Z"
    }, {
      localDate: "2017-08-21T00:00:00.000Z",
      solarGenerated: 288040,
      gridConsumed: 4926780,
      solarReturned: 1010,
      solarConsumption: 287030,
      co2Saved: 247540,
      co2Produced: 4236585,
      netConsumed: 5213810,
      date: "2017-08-21T00:00:00.000Z"
    }, {
      localDate: "2017-08-22T00:00:00.000Z",
      solarGenerated: 271780,
      gridConsumed: 5324330,
      solarReturned: 0,
      solarConsumption: 271780,
      co2Saved: 233520,
      co2Produced: 4578470,
      netConsumed: 5596110,
      date: "2017-08-22T00:00:00.000Z"
    }, {
      localDate: "2017-08-23T00:00:00.000Z",
      solarGenerated: 283860,
      gridConsumed: 4972105,
      solarReturned: 550,
      solarConsumption: 283310,
      co2Saved: 243880,
      co2Produced: 4275680,
      netConsumed: 5255415,
      date: "2017-08-23T00:00:00.000Z"
    }, {
      localDate: "2017-08-24T00:00:00.000Z",
      solarGenerated: 206940,
      gridConsumed: 4979145,
      solarReturned: 575,
      solarConsumption: 206365,
      co2Saved: 177820,
      co2Produced: 4281610,
      netConsumed: 5185510,
      date: "2017-08-24T00:00:00.000Z"
    }, {
      localDate: "2017-08-25T00:00:00.000Z",
      solarGenerated: 307100,
      gridConsumed: 5061895,
      solarReturned: 970,
      solarConsumption: 306130,
      co2Saved: 263840,
      co2Produced: 4352865,
      netConsumed: 5368025,
      date: "2017-08-25T00:00:00.000Z"
    }, {
      localDate: "2017-08-26T00:00:00.000Z",
      solarGenerated: 324940,
      gridConsumed: 2947760,
      solarReturned: 2615,
      solarConsumption: 322325,
      co2Saved: 279180,
      co2Produced: 2534585,
      netConsumed: 3270085,
      date: "2017-08-26T00:00:00.000Z"
    }, {
      localDate: "2017-08-27T00:00:00.000Z",
      solarGenerated: 262340,
      gridConsumed: 2564005,
      solarReturned: 3930,
      solarConsumption: 258410,
      co2Saved: 225380,
      co2Produced: 2204585,
      netConsumed: 2822415,
      date: "2017-08-27T00:00:00.000Z"
    }, {
      localDate: "2017-08-28T00:00:00.000Z",
      solarGenerated: 357700,
      gridConsumed: 5080155,
      solarReturned: 925,
      solarConsumption: 356775,
      co2Saved: 307640,
      co2Produced: 4368575,
      netConsumed: 5436930,
      date: "2017-08-28T00:00:00.000Z"
    }, {
      localDate: "2017-08-29T00:00:00.000Z",
      solarGenerated: 344460,
      gridConsumed: 5222345,
      solarReturned: 355,
      solarConsumption: 344105,
      co2Saved: 296180,
      co2Produced: 4490870,
      netConsumed: 5566450,
      date: "2017-08-29T00:00:00.000Z"
    }, {
      localDate: "2017-08-30T00:00:00.000Z",
      solarGenerated: 353660,
      gridConsumed: 4953070,
      solarReturned: 455,
      solarConsumption: 353205,
      co2Saved: 304000,
      co2Produced: 4259265,
      netConsumed: 5306275,
      date: "2017-08-30T00:00:00.000Z"
    }, {
      localDate: "2017-08-31T00:00:00.000Z",
      solarGenerated: 290140,
      gridConsumed: 5002630,
      solarReturned: 1020,
      solarConsumption: 289120,
      co2Saved: 249260,
      co2Produced: 4301905,
      netConsumed: 5291750,
      date: "2017-08-31T00:00:00.000Z"
    }]
  }, {
    year: 2017,
    month: "Sep",
    dates: [{
      localDate: "2017-09-01T00:00:00.000Z",
      solarGenerated: 326920,
      gridConsumed: 4883955,
      solarReturned: 655,
      solarConsumption: 326265,
      co2Saved: 280980,
      co2Produced: 4199880,
      netConsumed: 5210220,
      date: "2017-09-01T00:00:00.000Z"
    }, {
      localDate: "2017-09-02T00:00:00.000Z",
      solarGenerated: 341220,
      gridConsumed: 2779850,
      solarReturned: 1505,
      solarConsumption: 339715,
      co2Saved: 293240,
      co2Produced: 2390305,
      netConsumed: 3119565,
      date: "2017-09-02T00:00:00.000Z"
    }, {
      localDate: "2017-09-03T00:00:00.000Z",
      solarGenerated: 338040,
      gridConsumed: 2271830,
      solarReturned: 2095,
      solarConsumption: 335945,
      co2Saved: 290720,
      co2Produced: 1953345,
      netConsumed: 2607775,
      date: "2017-09-03T00:00:00.000Z"
    }, {
      localDate: "2017-09-04T00:00:00.000Z",
      solarGenerated: 339700,
      gridConsumed: 5347740,
      solarReturned: 1010,
      solarConsumption: 338690,
      co2Saved: 292000,
      co2Produced: 4598680,
      netConsumed: 5686430,
      date: "2017-09-04T00:00:00.000Z"
    }, {
      localDate: "2017-09-05T00:00:00.000Z",
      solarGenerated: 367180,
      gridConsumed: 5212570,
      solarReturned: 2025,
      solarConsumption: 365155,
      co2Saved: 315620,
      co2Produced: 4482440,
      netConsumed: 5577725,
      date: "2017-09-05T00:00:00.000Z"
    }, {
      localDate: "2017-09-06T00:00:00.000Z",
      solarGenerated: 374480,
      gridConsumed: 4891760,
      solarReturned: 1720,
      solarConsumption: 372760,
      co2Saved: 321780,
      co2Produced: 4206495,
      netConsumed: 5264520,
      date: "2017-09-06T00:00:00.000Z"
    }, {
      localDate: "2017-09-07T00:00:00.000Z",
      solarGenerated: 371340,
      gridConsumed: 5073860,
      solarReturned: 2190,
      solarConsumption: 369150,
      co2Saved: 319240,
      co2Produced: 4363215,
      netConsumed: 5443010,
      date: "2017-09-07T00:00:00.000Z"
    }, {
      localDate: "2017-09-08T00:00:00.000Z",
      solarGenerated: 378040,
      gridConsumed: 5167125,
      solarReturned: 1270,
      solarConsumption: 376770,
      co2Saved: 324860,
      co2Produced: 4443315,
      netConsumed: 5543895,
      date: "2017-09-08T00:00:00.000Z"
    }, {
      localDate: "2017-09-09T00:00:00.000Z",
      solarGenerated: 377060,
      gridConsumed: 3327800,
      solarReturned: 3655,
      solarConsumption: 373405,
      co2Saved: 324160,
      co2Produced: 2861475,
      netConsumed: 3701205,
      date: "2017-09-09T00:00:00.000Z"
    }, {
      localDate: "2017-09-10T00:00:00.000Z",
      solarGenerated: 363720,
      gridConsumed: 2663410,
      solarReturned: 6145,
      solarConsumption: 357575,
      co2Saved: 312540,
      co2Produced: 2290245,
      netConsumed: 3020985,
      date: "2017-09-10T00:00:00.000Z"
    }, {
      localDate: "2017-09-11T00:00:00.000Z",
      solarGenerated: 369420,
      gridConsumed: 4987000,
      solarReturned: 2070,
      solarConsumption: 367350,
      co2Saved: 317640,
      co2Produced: 4288310,
      netConsumed: 5354350,
      date: "2017-09-11T00:00:00.000Z"
    }, {
      localDate: "2017-09-12T00:00:00.000Z",
      solarGenerated: 361320,
      gridConsumed: 5382970,
      solarReturned: 510,
      solarConsumption: 360810,
      co2Saved: 310620,
      co2Produced: 4629005,
      netConsumed: 5743780,
      date: "2017-09-12T00:00:00.000Z"
    }, {
      localDate: "2017-09-13T00:00:00.000Z",
      solarGenerated: 374020,
      gridConsumed: 5523075,
      solarReturned: 35,
      solarConsumption: 373985,
      co2Saved: 321380,
      co2Produced: 4749485,
      netConsumed: 5897060,
      date: "2017-09-13T00:00:00.000Z"
    }, {
      localDate: "2017-09-14T00:00:00.000Z",
      solarGenerated: 337080,
      gridConsumed: 4984090,
      solarReturned: 930,
      solarConsumption: 336150,
      co2Saved: 289620,
      co2Produced: 4285930,
      netConsumed: 5320240,
      date: "2017-09-14T00:00:00.000Z"
    }, {
      localDate: "2017-09-15T00:00:00.000Z",
      solarGenerated: 391220,
      gridConsumed: 4982040,
      solarReturned: 2075,
      solarConsumption: 389145,
      co2Saved: 336360,
      co2Produced: 4284225,
      netConsumed: 5371185,
      date: "2017-09-15T00:00:00.000Z"
    }, {
      localDate: "2017-09-16T00:00:00.000Z",
      solarGenerated: 389440,
      gridConsumed: 2934935,
      solarReturned: 1315,
      solarConsumption: 388125,
      co2Saved: 334740,
      co2Produced: 2523660,
      netConsumed: 3323060,
      date: "2017-09-16T00:00:00.000Z"
    }, {
      localDate: "2017-09-17T00:00:00.000Z",
      solarGenerated: 311660,
      gridConsumed: 2196120,
      solarReturned: 1545,
      solarConsumption: 310115,
      co2Saved: 267800,
      co2Produced: 1888200,
      netConsumed: 2506235,
      date: "2017-09-17T00:00:00.000Z"
    }, {
      localDate: "2017-09-18T00:00:00.000Z",
      solarGenerated: 362260,
      gridConsumed: 3195365,
      solarReturned: 500,
      solarConsumption: 361760,
      co2Saved: 311540,
      co2Produced: 2747675,
      netConsumed: 3557125,
      date: "2017-09-18T00:00:00.000Z"
    }, {
      localDate: "2017-09-19T00:00:00.000Z",
      solarGenerated: 376100,
      gridConsumed: 3925815,
      solarReturned: 360,
      solarConsumption: 375740,
      co2Saved: 323240,
      co2Produced: 3375675,
      netConsumed: 4301555,
      date: "2017-09-19T00:00:00.000Z"
    }, {
      localDate: "2017-09-20T00:00:00.000Z",
      solarGenerated: 366260,
      gridConsumed: 3519340,
      solarReturned: 510,
      solarConsumption: 365750,
      co2Saved: 314620,
      co2Produced: 3026140,
      netConsumed: 3885090,
      date: "2017-09-20T00:00:00.000Z"
    }, {
      localDate: "2017-09-21T00:00:00.000Z",
      solarGenerated: 309220,
      gridConsumed: 3637615,
      solarReturned: 560,
      solarConsumption: 308660,
      co2Saved: 265860,
      co2Produced: 3127890,
      netConsumed: 3946275,
      date: "2017-09-21T00:00:00.000Z"
    }, {
      localDate: "2017-09-22T00:00:00.000Z",
      solarGenerated: 348400,
      gridConsumed: 3256850,
      solarReturned: 125,
      solarConsumption: 348275,
      co2Saved: 299440,
      co2Produced: 2800565,
      netConsumed: 3605125,
      date: "2017-09-22T00:00:00.000Z"
    }, {
      localDate: "2017-09-23T00:00:00.000Z",
      solarGenerated: 371540,
      gridConsumed: 2747150,
      solarReturned: 1970,
      solarConsumption: 369570,
      co2Saved: 319340,
      co2Produced: 2362120,
      netConsumed: 3116720,
      date: "2017-09-23T00:00:00.000Z"
    }, {
      localDate: "2017-09-24T00:00:00.000Z",
      solarGenerated: 376460,
      gridConsumed: 2826510,
      solarReturned: 1525,
      solarConsumption: 374935,
      co2Saved: 323540,
      co2Produced: 2430310,
      netConsumed: 3201445,
      date: "2017-09-24T00:00:00.000Z"
    }, {
      localDate: "2017-09-25T00:00:00.000Z",
      solarGenerated: 362900,
      gridConsumed: 3741185,
      solarReturned: 1155,
      solarConsumption: 361745,
      co2Saved: 311980,
      co2Produced: 3217095,
      netConsumed: 4102930,
      date: "2017-09-25T00:00:00.000Z"
    }, {
      localDate: "2017-09-26T00:00:00.000Z",
      solarGenerated: 288360,
      gridConsumed: 3566950,
      solarReturned: 660,
      solarConsumption: 287700,
      co2Saved: 247680,
      co2Produced: 3067180,
      netConsumed: 3854650,
      date: "2017-09-26T00:00:00.000Z"
    }, {
      localDate: "2017-09-27T00:00:00.000Z",
      solarGenerated: 134360,
      gridConsumed: 3522215,
      solarReturned: 850,
      solarConsumption: 133510,
      co2Saved: 115400,
      co2Produced: 3028755,
      netConsumed: 3655725,
      date: "2017-09-27T00:00:00.000Z"
    }, {
      localDate: "2017-09-28T00:00:00.000Z",
      solarGenerated: 371820,
      gridConsumed: 3643975,
      solarReturned: 1030,
      solarConsumption: 370790,
      co2Saved: 319740,
      co2Produced: 3133350,
      netConsumed: 4014765,
      date: "2017-09-28T00:00:00.000Z"
    }, {
      localDate: "2017-09-29T00:00:00.000Z",
      solarGenerated: 344580,
      gridConsumed: 3989390,
      solarReturned: 340,
      solarConsumption: 344240,
      co2Saved: 296060,
      co2Produced: 3430470,
      netConsumed: 4333630,
      date: "2017-09-29T00:00:00.000Z"
    }, {
      localDate: "2017-09-30T00:00:00.000Z",
      solarGenerated: 360000,
      gridConsumed: 2550410,
      solarReturned: 815,
      solarConsumption: 359185,
      co2Saved: 309360,
      co2Produced: 2192990,
      netConsumed: 2909595,
      date: "2017-09-30T00:00:00.000Z"
    }]
  }, {
    year: 2017,
    month: "Oct",
    dates: [{
      localDate: "2017-10-01T00:00:00.000Z",
      solarGenerated: 140800,
      gridConsumed: 2668080,
      solarReturned: 4830,
      solarConsumption: 135970,
      co2Saved: 120900,
      co2Produced: 2294125,
      netConsumed: 2804050,
      date: "2017-10-01T00:00:00.000Z"
    }, {
      localDate: "2017-10-02T00:00:00.000Z",
      solarGenerated: 85020,
      gridConsumed: 3109920,
      solarReturned: 2775,
      solarConsumption: 82245,
      co2Saved: 72940,
      co2Produced: 2674200,
      netConsumed: 3192165,
      date: "2017-10-02T00:00:00.000Z"
    }, {
      localDate: "2017-10-03T00:00:00.000Z",
      solarGenerated: 286500,
      gridConsumed: 5258125,
      solarReturned: 985,
      solarConsumption: 285515,
      co2Saved: 246040,
      co2Produced: 4521660,
      netConsumed: 5543640,
      date: "2017-10-03T00:00:00.000Z"
    }, {
      localDate: "2017-10-04T00:00:00.000Z",
      solarGenerated: 298440,
      gridConsumed: 5689865,
      solarReturned: 715,
      solarConsumption: 297725,
      co2Saved: 256340,
      co2Produced: 4892885,
      netConsumed: 5987590,
      date: "2017-10-04T00:00:00.000Z"
    }, {
      localDate: "2017-10-05T00:00:00.000Z",
      solarGenerated: 394080,
      gridConsumed: 7205500,
      solarReturned: 80,
      solarConsumption: 394000,
      co2Saved: 338660,
      co2Produced: 6196390,
      netConsumed: 7599500,
      date: "2017-10-05T00:00:00.000Z"
    }, {
      localDate: "2017-10-06T00:00:00.000Z",
      solarGenerated: 360560,
      gridConsumed: 7918765,
      solarReturned: 30,
      solarConsumption: 360530,
      co2Saved: 309940,
      co2Produced: 6809825,
      netConsumed: 8279295,
      date: "2017-10-06T00:00:00.000Z"
    }, {
      localDate: "2017-10-07T00:00:00.000Z",
      solarGenerated: 163640,
      gridConsumed: 2970865,
      solarReturned: 2090,
      solarConsumption: 161550,
      co2Saved: 140520,
      co2Produced: 2554660,
      netConsumed: 3132415,
      date: "2017-10-07T00:00:00.000Z"
    }, {
      localDate: "2017-10-08T00:00:00.000Z",
      solarGenerated: 252460,
      gridConsumed: 2860610,
      solarReturned: 1965,
      solarConsumption: 250495,
      co2Saved: 216800,
      co2Produced: 2459815,
      netConsumed: 3111105,
      date: "2017-10-08T00:00:00.000Z"
    }, {
      localDate: "2017-10-09T00:00:00.000Z",
      solarGenerated: 296880,
      gridConsumed: 7017490,
      solarReturned: 700,
      solarConsumption: 296180,
      co2Saved: 255080,
      co2Produced: 6034605,
      netConsumed: 7313670,
      date: "2017-10-09T00:00:00.000Z"
    }, {
      localDate: "2017-10-10T00:00:00.000Z",
      solarGenerated: 355100,
      gridConsumed: 8646005,
      solarReturned: 0,
      solarConsumption: 355100,
      co2Saved: 305080,
      co2Produced: 7435175,
      netConsumed: 9001105,
      date: "2017-10-10T00:00:00.000Z"
    }, {
      localDate: "2017-10-11T00:00:00.000Z",
      solarGenerated: 228760,
      gridConsumed: 7039840,
      solarReturned: 15,
      solarConsumption: 228745,
      co2Saved: 196640,
      co2Produced: 6054010,
      netConsumed: 7268585,
      date: "2017-10-11T00:00:00.000Z"
    }, {
      localDate: "2017-10-12T00:00:00.000Z",
      solarGenerated: 108440,
      gridConsumed: 6362170,
      solarReturned: 50,
      solarConsumption: 108390,
      co2Saved: 93000,
      co2Produced: 5470990,
      netConsumed: 6470560,
      date: "2017-10-12T00:00:00.000Z"
    }, {
      localDate: "2017-10-13T00:00:00.000Z",
      solarGenerated: 337020,
      gridConsumed: 7903520,
      solarReturned: 1065,
      solarConsumption: 335955,
      co2Saved: 289620,
      co2Produced: 6796605,
      netConsumed: 8239475,
      date: "2017-10-13T00:00:00.000Z"
    }, {
      localDate: "2017-10-14T00:00:00.000Z",
      solarGenerated: 187460,
      gridConsumed: 2917450,
      solarReturned: 0,
      solarConsumption: 187460,
      co2Saved: 161000,
      co2Produced: 2508670,
      netConsumed: 3104910,
      date: "2017-10-14T00:00:00.000Z"
    }, {
      localDate: "2017-10-15T00:00:00.000Z",
      solarGenerated: 139020,
      gridConsumed: 3129670,
      solarReturned: 5595,
      solarConsumption: 133425,
      co2Saved: 119460,
      co2Produced: 2691140,
      netConsumed: 3263095,
      date: "2017-10-15T00:00:00.000Z"
    }, {
      localDate: "2017-10-16T00:00:00.000Z",
      solarGenerated: 129220,
      gridConsumed: 4270025,
      solarReturned: 2530,
      solarConsumption: 126690,
      co2Saved: 110980,
      co2Produced: 3671950,
      netConsumed: 4396715,
      date: "2017-10-16T00:00:00.000Z"
    }, {
      localDate: "2017-10-17T00:00:00.000Z",
      solarGenerated: 118760,
      gridConsumed: 5081955,
      solarReturned: 1355,
      solarConsumption: 117405,
      co2Saved: 102100,
      co2Produced: 4370125,
      netConsumed: 5199360,
      date: "2017-10-17T00:00:00.000Z"
    }, {
      localDate: "2017-10-18T00:00:00.000Z",
      solarGenerated: 241800,
      gridConsumed: 5209000,
      solarReturned: 760,
      solarConsumption: 241040,
      co2Saved: 207740,
      co2Produced: 4479290,
      netConsumed: 5450040,
      date: "2017-10-18T00:00:00.000Z"
    }, {
      localDate: "2017-10-19T00:00:00.000Z",
      solarGenerated: 307820,
      gridConsumed: 5583630,
      solarReturned: 350,
      solarConsumption: 307470,
      co2Saved: 264340,
      co2Produced: 4801500,
      netConsumed: 5891100,
      date: "2017-10-19T00:00:00.000Z"
    }, {
      localDate: "2017-10-20T00:00:00.000Z",
      solarGenerated: 352000,
      gridConsumed: 5547070,
      solarReturned: 220,
      solarConsumption: 351780,
      co2Saved: 302400,
      co2Produced: 4770220,
      netConsumed: 5898850,
      date: "2017-10-20T00:00:00.000Z"
    }, {
      localDate: "2017-10-21T00:00:00.000Z",
      solarGenerated: 66300,
      gridConsumed: 2593845,
      solarReturned: 2095,
      solarConsumption: 64205,
      co2Saved: 56700,
      co2Produced: 2230340,
      netConsumed: 2658050,
      date: "2017-10-21T00:00:00.000Z"
    }, {
      localDate: "2017-10-22T00:00:00.000Z",
      solarGenerated: 408500,
      gridConsumed: 2564935,
      solarReturned: 3495,
      solarConsumption: 405005,
      co2Saved: 351180,
      co2Produced: 2205545,
      netConsumed: 2969940,
      date: "2017-10-22T00:00:00.000Z"
    }, {
      localDate: "2017-10-23T00:00:00.000Z",
      solarGenerated: 219540,
      gridConsumed: 4890190,
      solarReturned: 1355,
      solarConsumption: 218185,
      co2Saved: 188700,
      co2Produced: 4205140,
      netConsumed: 5108375,
      date: "2017-10-23T00:00:00.000Z"
    }, {
      localDate: "2017-10-24T00:00:00.000Z",
      solarGenerated: 365480,
      gridConsumed: 5197310,
      solarReturned: 1350,
      solarConsumption: 364130,
      co2Saved: 314140,
      co2Produced: 4469365,
      netConsumed: 5561440,
      date: "2017-10-24T00:00:00.000Z"
    }, {
      localDate: "2017-10-25T00:00:00.000Z",
      solarGenerated: 457880,
      gridConsumed: 6115815,
      solarReturned: 940,
      solarConsumption: 456940,
      co2Saved: 393500,
      co2Produced: 5259260,
      netConsumed: 6572755,
      date: "2017-10-25T00:00:00.000Z"
    }, {
      localDate: "2017-10-26T00:00:00.000Z",
      solarGenerated: 453340,
      gridConsumed: 7215170,
      solarReturned: 30,
      solarConsumption: 453310,
      co2Saved: 389660,
      co2Produced: 6204695,
      netConsumed: 7668480,
      date: "2017-10-26T00:00:00.000Z"
    }, {
      localDate: "2017-10-27T00:00:00.000Z",
      solarGenerated: 482640,
      gridConsumed: 6523600,
      solarReturned: 10,
      solarConsumption: 482630,
      co2Saved: 414900,
      co2Produced: 5609910,
      netConsumed: 7006230,
      date: "2017-10-27T00:00:00.000Z"
    }, {
      localDate: "2017-10-28T00:00:00.000Z",
      solarGenerated: 460440,
      gridConsumed: 2653685,
      solarReturned: 50,
      solarConsumption: 460390,
      co2Saved: 395660,
      co2Produced: 2281660,
      netConsumed: 3114075,
      date: "2017-10-28T00:00:00.000Z"
    }, {
      localDate: "2017-10-29T00:00:00.000Z",
      solarGenerated: 452400,
      gridConsumed: 3011370,
      solarReturned: 15,
      solarConsumption: 452385,
      co2Saved: 388620,
      co2Produced: 2589370,
      netConsumed: 3463755,
      date: "2017-10-29T00:00:00.000Z"
    }, {
      localDate: "2017-10-30T00:00:00.000Z",
      solarGenerated: 380060,
      gridConsumed: 8840100,
      solarReturned: 0,
      solarConsumption: 380060,
      co2Saved: 326480,
      co2Produced: 7602120,
      netConsumed: 9220160,
      date: "2017-10-30T00:00:00.000Z"
    }, {
      localDate: "2017-10-31T00:00:00.000Z",
      solarGenerated: 435340,
      gridConsumed: 6889900,
      solarReturned: 50,
      solarConsumption: 435290,
      co2Saved: 374340,
      co2Produced: 5924815,
      netConsumed: 7325190,
      date: "2017-10-31T00:00:00.000Z"
    }]
  }, {
    year: 2017,
    month: "Nov",
    dates: [{
      localDate: "2017-11-01T00:00:00.000Z",
      solarGenerated: 355640,
      gridConsumed: 5930970,
      solarReturned: 115,
      solarConsumption: 355525,
      co2Saved: 305560,
      co2Produced: 5100160,
      netConsumed: 6286495,
      date: "2017-11-01T00:00:00.000Z"
    }, {
      localDate: "2017-11-02T00:00:00.000Z",
      solarGenerated: 419080,
      gridConsumed: 6663955,
      solarReturned: 285,
      solarConsumption: 418795,
      co2Saved: 360200,
      co2Produced: 5730595,
      netConsumed: 7082750,
      date: "2017-11-02T00:00:00.000Z"
    }, {
      localDate: "2017-11-03T00:00:00.000Z",
      solarGenerated: 467380,
      gridConsumed: 7028075,
      solarReturned: 105,
      solarConsumption: 467275,
      co2Saved: 401840,
      co2Produced: 6043690,
      netConsumed: 7495350,
      date: "2017-11-03T00:00:00.000Z"
    }, {
      localDate: "2017-11-04T00:00:00.000Z",
      solarGenerated: 478760,
      gridConsumed: 2781950,
      solarReturned: 5,
      solarConsumption: 478755,
      co2Saved: 411540,
      co2Produced: 2392090,
      netConsumed: 3260705,
      date: "2017-11-04T00:00:00.000Z"
    }, {
      localDate: "2017-11-05T00:00:00.000Z",
      solarGenerated: 364280,
      gridConsumed: 2679955,
      solarReturned: 1105,
      solarConsumption: 363175,
      co2Saved: 313160,
      co2Produced: 2304355,
      netConsumed: 3043130,
      date: "2017-11-05T00:00:00.000Z"
    }, {
      localDate: "2017-11-06T00:00:00.000Z",
      solarGenerated: 289260,
      gridConsumed: 6858650,
      solarReturned: 260,
      solarConsumption: 289000,
      co2Saved: 248480,
      co2Produced: 5897880,
      netConsumed: 7147650,
      date: "2017-11-06T00:00:00.000Z"
    }, {
      localDate: "2017-11-07T00:00:00.000Z",
      solarGenerated: 388480,
      gridConsumed: 6578530,
      solarReturned: 0,
      solarConsumption: 388480,
      co2Saved: 333940,
      co2Produced: 5657135,
      netConsumed: 6967010,
      date: "2017-11-07T00:00:00.000Z"
    }, {
      localDate: "2017-11-08T00:00:00.000Z",
      solarGenerated: 343900,
      gridConsumed: 5901975,
      solarReturned: 410,
      solarConsumption: 343490,
      co2Saved: 295540,
      co2Produced: 5075260,
      netConsumed: 6245465,
      date: "2017-11-08T00:00:00.000Z"
    }, {
      localDate: "2017-11-09T00:00:00.000Z",
      solarGenerated: 411760,
      gridConsumed: 5740485,
      solarReturned: 1010,
      solarConsumption: 410750,
      co2Saved: 353900,
      co2Produced: 4936360,
      netConsumed: 6151235,
      date: "2017-11-09T00:00:00.000Z"
    }, {
      localDate: "2017-11-10T00:00:00.000Z",
      solarGenerated: 359180,
      gridConsumed: 5588940,
      solarReturned: 1120,
      solarConsumption: 358060,
      co2Saved: 308740,
      co2Produced: 4806015,
      netConsumed: 5947000,
      date: "2017-11-10T00:00:00.000Z"
    }, {
      localDate: "2017-11-11T00:00:00.000Z",
      solarGenerated: 297700,
      gridConsumed: 2612145,
      solarReturned: 3500,
      solarConsumption: 294200,
      co2Saved: 255800,
      co2Produced: 2246005,
      netConsumed: 2906345,
      date: "2017-11-11T00:00:00.000Z"
    }, {
      localDate: "2017-11-12T00:00:00.000Z",
      solarGenerated: 467380,
      gridConsumed: 2506495,
      solarReturned: 7035,
      solarConsumption: 460345,
      co2Saved: 401820,
      co2Produced: 2155255,
      netConsumed: 2966840,
      date: "2017-11-12T00:00:00.000Z"
    }, {
      localDate: "2017-11-13T00:00:00.000Z",
      solarGenerated: 450440,
      gridConsumed: 5466915,
      solarReturned: 2330,
      solarConsumption: 448110,
      co2Saved: 387160,
      co2Produced: 4701215,
      netConsumed: 5915025,
      date: "2017-11-13T00:00:00.000Z"
    }, {
      localDate: "2017-11-14T00:00:00.000Z",
      solarGenerated: 491140,
      gridConsumed: 5807740,
      solarReturned: 1415,
      solarConsumption: 489725,
      co2Saved: 422320,
      co2Produced: 4994330,
      netConsumed: 6297465,
      date: "2017-11-14T00:00:00.000Z"
    }, {
      localDate: "2017-11-15T00:00:00.000Z",
      solarGenerated: 300620,
      gridConsumed: 5657780,
      solarReturned: 3350,
      solarConsumption: 297270,
      co2Saved: 258280,
      co2Produced: 4865250,
      netConsumed: 5955050,
      date: "2017-11-15T00:00:00.000Z"
    }, {
      localDate: "2017-11-16T00:00:00.000Z",
      solarGenerated: 378040,
      gridConsumed: 6684830,
      solarReturned: 220,
      solarConsumption: 377820,
      co2Saved: 324820,
      co2Produced: 5748470,
      netConsumed: 7062650,
      date: "2017-11-16T00:00:00.000Z"
    }, {
      localDate: "2017-11-17T00:00:00.000Z",
      solarGenerated: 378600,
      gridConsumed: 5920575,
      solarReturned: 290,
      solarConsumption: 378310,
      co2Saved: 325280,
      co2Produced: 5091135,
      netConsumed: 6298885,
      date: "2017-11-17T00:00:00.000Z"
    }, {
      localDate: "2017-11-18T00:00:00.000Z",
      solarGenerated: 104620,
      gridConsumed: 2807040,
      solarReturned: 12080,
      solarConsumption: 92540,
      co2Saved: 89800,
      co2Produced: 2413650,
      netConsumed: 2899580,
      date: "2017-11-18T00:00:00.000Z"
    }, {
      localDate: "2017-11-19T00:00:00.000Z",
      solarGenerated: 290500,
      gridConsumed: 2485320,
      solarReturned: 15645,
      solarConsumption: 274855,
      co2Saved: 249640,
      co2Produced: 2137075,
      netConsumed: 2760175,
      date: "2017-11-19T00:00:00.000Z"
    }, {
      localDate: "2017-11-20T00:00:00.000Z",
      solarGenerated: 407100,
      gridConsumed: 5831330,
      solarReturned: 4770,
      solarConsumption: 402330,
      co2Saved: 349880,
      co2Produced: 5014585,
      netConsumed: 6233660,
      date: "2017-11-20T00:00:00.000Z"
    }, {
      localDate: "2017-11-21T00:00:00.000Z",
      solarGenerated: 409080,
      gridConsumed: 5409830,
      solarReturned: 905,
      solarConsumption: 408175,
      co2Saved: 351520,
      co2Produced: 4652100,
      netConsumed: 5818005,
      date: "2017-11-21T00:00:00.000Z"
    }, {
      localDate: "2017-11-22T00:00:00.000Z",
      solarGenerated: 396800,
      gridConsumed: 6128950,
      solarReturned: 1175,
      solarConsumption: 395625,
      co2Saved: 340880,
      co2Produced: 5270565,
      netConsumed: 6524575,
      date: "2017-11-22T00:00:00.000Z"
    }, {
      localDate: "2017-11-23T00:00:00.000Z",
      solarGenerated: 367500,
      gridConsumed: 5937530,
      solarReturned: 470,
      solarConsumption: 367030,
      co2Saved: 315820,
      co2Produced: 5105840,
      netConsumed: 6304560,
      date: "2017-11-23T00:00:00.000Z"
    }, {
      localDate: "2017-11-24T00:00:00.000Z",
      solarGenerated: 485140,
      gridConsumed: 6466400,
      solarReturned: 105,
      solarConsumption: 485035,
      co2Saved: 416960,
      co2Produced: 5560650,
      netConsumed: 6951435,
      date: "2017-11-24T00:00:00.000Z"
    }, {
      localDate: "2017-11-25T00:00:00.000Z",
      solarGenerated: 431440,
      gridConsumed: 2590695,
      solarReturned: 75,
      solarConsumption: 431365,
      co2Saved: 370920,
      co2Produced: 2227570,
      netConsumed: 3022060,
      date: "2017-11-25T00:00:00.000Z"
    }, {
      localDate: "2017-11-26T00:00:00.000Z",
      solarGenerated: 413440,
      gridConsumed: 2731425,
      solarReturned: 1890,
      solarConsumption: 411550,
      co2Saved: 355160,
      co2Produced: 2348680,
      netConsumed: 3142975,
      date: "2017-11-26T00:00:00.000Z"
    }, {
      localDate: "2017-11-27T00:00:00.000Z",
      solarGenerated: 414980,
      gridConsumed: 7462230,
      solarReturned: 1500,
      solarConsumption: 413480,
      co2Saved: 356800,
      co2Produced: 6417160,
      netConsumed: 7875710,
      date: "2017-11-27T00:00:00.000Z"
    }, {
      localDate: "2017-11-28T00:00:00.000Z",
      solarGenerated: 379380,
      gridConsumed: 6801495,
      solarReturned: 0,
      solarConsumption: 379380,
      co2Saved: 326120,
      co2Produced: 5848830,
      netConsumed: 7180875,
      date: "2017-11-28T00:00:00.000Z"
    }, {
      localDate: "2017-11-29T00:00:00.000Z",
      solarGenerated: 107300,
      gridConsumed: 4292350,
      solarReturned: 5,
      solarConsumption: 107295,
      co2Saved: 92100,
      co2Produced: 3691145,
      netConsumed: 4399645,
      date: "2017-11-29T00:00:00.000Z"
    }, {
      localDate: "2017-11-30T00:00:00.000Z",
      solarGenerated: 264980,
      gridConsumed: 4666045,
      solarReturned: 65,
      solarConsumption: 264915,
      co2Saved: 227580,
      co2Produced: 4012375,
      netConsumed: 4930960,
      date: "2017-11-30T00:00:00.000Z"
    }]
  }, {
    year: 2017,
    month: "Dec",
    dates: [{
      localDate: "2017-12-01T00:00:00.000Z",
      solarGenerated: 383940,
      gridConsumed: 4391135,
      solarReturned: 35,
      solarConsumption: 383905,
      co2Saved: 329840,
      co2Produced: 3776000,
      netConsumed: 4775040,
      date: "2017-12-01T00:00:00.000Z"
    }, {
      localDate: "2017-12-02T00:00:00.000Z",
      solarGenerated: 439220,
      gridConsumed: 3150150,
      solarReturned: 5,
      solarConsumption: 439215,
      co2Saved: 377500,
      co2Produced: 2708695,
      netConsumed: 3589365,
      date: "2017-12-02T00:00:00.000Z"
    }, {
      localDate: "2017-12-03T00:00:00.000Z",
      solarGenerated: 318980,
      gridConsumed: 2959840,
      solarReturned: 430,
      solarConsumption: 318550,
      co2Saved: 274160,
      co2Produced: 2545180,
      netConsumed: 3278390,
      date: "2017-12-03T00:00:00.000Z"
    }, {
      localDate: "2017-12-04T00:00:00.000Z",
      solarGenerated: 187820,
      gridConsumed: 3498345,
      solarReturned: 995,
      solarConsumption: 186825,
      co2Saved: 161480,
      co2Produced: 3008235,
      netConsumed: 3685170,
      date: "2017-12-04T00:00:00.000Z"
    }, {
      localDate: "2017-12-05T00:00:00.000Z",
      solarGenerated: 359300,
      gridConsumed: 3436335,
      solarReturned: 575,
      solarConsumption: 358725,
      co2Saved: 308780,
      co2Produced: 2954900,
      netConsumed: 3795060,
      date: "2017-12-05T00:00:00.000Z"
    }, {
      localDate: "2017-12-06T00:00:00.000Z",
      solarGenerated: 520740,
      gridConsumed: 3342555,
      solarReturned: 940,
      solarConsumption: 519800,
      co2Saved: 447840,
      co2Produced: 2874350,
      netConsumed: 3862355,
      date: "2017-12-06T00:00:00.000Z"
    }, {
      localDate: "2017-12-07T00:00:00.000Z",
      solarGenerated: 515020,
      gridConsumed: 3354985,
      solarReturned: 1415,
      solarConsumption: 513605,
      co2Saved: 442700,
      co2Produced: 2884945,
      netConsumed: 3868590,
      date: "2017-12-07T00:00:00.000Z"
    }, {
      localDate: "2017-12-08T00:00:00.000Z",
      solarGenerated: 288140,
      gridConsumed: 3617910,
      solarReturned: 850,
      solarConsumption: 287290,
      co2Saved: 247640,
      co2Produced: 3111025,
      netConsumed: 3905200,
      date: "2017-12-08T00:00:00.000Z"
    }, {
      localDate: "2017-12-09T00:00:00.000Z",
      solarGenerated: 447060,
      gridConsumed: 2689235,
      solarReturned: 0,
      solarConsumption: 447060,
      co2Saved: 384240,
      co2Produced: 2312350,
      netConsumed: 3136295,
      date: "2017-12-09T00:00:00.000Z"
    }, {
      localDate: "2017-12-10T00:00:00.000Z",
      solarGenerated: 435540,
      gridConsumed: 2422885,
      solarReturned: 940,
      solarConsumption: 434600,
      co2Saved: 374320,
      co2Produced: 2083255,
      netConsumed: 2857485,
      date: "2017-12-10T00:00:00.000Z"
    }, {
      localDate: "2017-12-11T00:00:00.000Z",
      solarGenerated: 438160,
      gridConsumed: 3566490,
      solarReturned: 1960,
      solarConsumption: 436200,
      co2Saved: 376640,
      co2Produced: 3066770,
      netConsumed: 4002690,
      date: "2017-12-11T00:00:00.000Z"
    }, {
      localDate: "2017-12-12T00:00:00.000Z",
      solarGenerated: 450320,
      gridConsumed: 3796400,
      solarReturned: 1315,
      solarConsumption: 449005,
      co2Saved: 386880,
      co2Produced: 3264620,
      netConsumed: 4245405,
      date: "2017-12-12T00:00:00.000Z"
    }, {
      localDate: "2017-12-13T00:00:00.000Z",
      solarGenerated: 408140,
      gridConsumed: 3851975,
      solarReturned: 15,
      solarConsumption: 408125,
      co2Saved: 350740,
      co2Produced: 3312340,
      netConsumed: 4260100,
      date: "2017-12-13T00:00:00.000Z"
    }, {
      localDate: "2017-12-14T00:00:00.000Z",
      solarGenerated: 472220,
      gridConsumed: 3484720,
      solarReturned: 0,
      solarConsumption: 472220,
      co2Saved: 405680,
      co2Produced: 2996455,
      netConsumed: 3956940,
      date: "2017-12-14T00:00:00.000Z"
    }, {
      localDate: "2017-12-15T00:00:00.000Z",
      solarGenerated: 478020,
      gridConsumed: 3728010,
      solarReturned: 290,
      solarConsumption: 477730,
      co2Saved: 410760,
      co2Produced: 3205720,
      netConsumed: 4205740,
      date: "2017-12-15T00:00:00.000Z"
    }, {
      localDate: "2017-12-16T00:00:00.000Z",
      solarGenerated: 534040,
      gridConsumed: 2793300,
      solarReturned: 0,
      solarConsumption: 534040,
      co2Saved: 459060,
      co2Produced: 2401935,
      netConsumed: 3327340,
      date: "2017-12-16T00:00:00.000Z"
    }, {
      localDate: "2017-12-17T00:00:00.000Z",
      solarGenerated: 397340,
      gridConsumed: 2541905,
      solarReturned: 60,
      solarConsumption: 397280,
      co2Saved: 341600,
      co2Produced: 2185705,
      netConsumed: 2939185,
      date: "2017-12-17T00:00:00.000Z"
    }, {
      localDate: "2017-12-18T00:00:00.000Z",
      solarGenerated: 435160,
      gridConsumed: 3869805,
      solarReturned: 25,
      solarConsumption: 435135,
      co2Saved: 374020,
      co2Produced: 3327770,
      netConsumed: 4304940,
      date: "2017-12-18T00:00:00.000Z"
    }, {
      localDate: "2017-12-19T00:00:00.000Z",
      solarGenerated: 489220,
      gridConsumed: 3757475,
      solarReturned: 0,
      solarConsumption: 489220,
      co2Saved: 420360,
      co2Produced: 3230960,
      netConsumed: 4246695,
      date: "2017-12-19T00:00:00.000Z"
    }, {
      localDate: "2017-12-20T00:00:00.000Z",
      solarGenerated: 533700,
      gridConsumed: 5114640,
      solarReturned: 0,
      solarConsumption: 533700,
      co2Saved: 458600,
      co2Produced: 4398110,
      netConsumed: 5648340,
      date: "2017-12-20T00:00:00.000Z"
    }, {
      localDate: "2017-12-21T00:00:00.000Z",
      solarGenerated: 471820,
      gridConsumed: 4573160,
      solarReturned: 0,
      solarConsumption: 471820,
      co2Saved: 405640,
      co2Produced: 3932595,
      netConsumed: 5044980,
      date: "2017-12-21T00:00:00.000Z"
    }, {
      localDate: "2017-12-22T00:00:00.000Z",
      solarGenerated: 276260,
      gridConsumed: 3907005,
      solarReturned: 0,
      solarConsumption: 276260,
      co2Saved: 237360,
      co2Produced: 3359500,
      netConsumed: 4183265,
      date: "2017-12-22T00:00:00.000Z"
    }, {
      localDate: "2017-12-23T00:00:00.000Z",
      solarGenerated: 383520,
      gridConsumed: 3115640,
      solarReturned: 0,
      solarConsumption: 383520,
      co2Saved: 329620,
      co2Produced: 2679040,
      netConsumed: 3499160,
      date: "2017-12-23T00:00:00.000Z"
    }, {
      localDate: "2017-12-24T00:00:00.000Z",
      solarGenerated: 513900,
      gridConsumed: 3340300,
      solarReturned: 0,
      solarConsumption: 513900,
      co2Saved: 441460,
      co2Produced: 2872230,
      netConsumed: 3854200,
      date: "2017-12-24T00:00:00.000Z"
    }, {
      localDate: "2017-12-25T00:00:00.000Z",
      solarGenerated: 478880,
      gridConsumed: 4190865,
      solarReturned: 0,
      solarConsumption: 478880,
      co2Saved: 411680,
      co2Produced: 3603870,
      netConsumed: 4669745,
      date: "2017-12-25T00:00:00.000Z"
    }, {
      localDate: "2017-12-26T00:00:00.000Z",
      solarGenerated: 348700,
      gridConsumed: 3358780,
      solarReturned: 0,
      solarConsumption: 348700,
      co2Saved: 299540,
      co2Produced: 2888085,
      netConsumed: 3707480,
      date: "2017-12-26T00:00:00.000Z"
    }, {
      localDate: "2017-12-27T00:00:00.000Z",
      solarGenerated: 334640,
      gridConsumed: 3449160,
      solarReturned: 0,
      solarConsumption: 334640,
      co2Saved: 287700,
      co2Produced: 2965775,
      netConsumed: 3783800,
      date: "2017-12-27T00:00:00.000Z"
    }, {
      localDate: "2017-12-28T00:00:00.000Z",
      solarGenerated: 380180,
      gridConsumed: 3377540,
      solarReturned: 0,
      solarConsumption: 380180,
      co2Saved: 326820,
      co2Produced: 2904175,
      netConsumed: 3757720,
      date: "2017-12-28T00:00:00.000Z"
    }, {
      localDate: "2017-12-29T00:00:00.000Z",
      solarGenerated: 460300,
      gridConsumed: 3744725,
      solarReturned: 0,
      solarConsumption: 460300,
      co2Saved: 395460,
      co2Produced: 3220070,
      netConsumed: 4205025,
      date: "2017-12-29T00:00:00.000Z"
    }, {
      localDate: "2017-12-30T00:00:00.000Z",
      solarGenerated: 380380,
      gridConsumed: 3072475,
      solarReturned: 0,
      solarConsumption: 380380,
      co2Saved: 326880,
      co2Produced: 2641895,
      netConsumed: 3452855,
      date: "2017-12-30T00:00:00.000Z"
    }, {
      localDate: "2017-12-31T00:00:00.000Z",
      solarGenerated: 261840,
      gridConsumed: 3284260,
      solarReturned: 0,
      solarConsumption: 261840,
      co2Saved: 224880,
      co2Produced: 2824095,
      netConsumed: 3546100,
      date: "2017-12-31T00:00:00.000Z"
    }]
  }, {
    year: 2018,
    month: "Jan",
    dates: [{
      localDate: "2018-01-01T00:00:00.000Z",
      solarGenerated: 289460,
      gridConsumed: 3996905,
      solarReturned: 0,
      solarConsumption: 289460,
      co2Saved: 248800,
      co2Produced: 3437100,
      netConsumed: 4286365,
      date: "2018-01-01T00:00:00.000Z"
    }, {
      localDate: "2018-01-02T00:00:00.000Z",
      solarGenerated: 282260,
      gridConsumed: 4111835,
      solarReturned: 0,
      solarConsumption: 282260,
      co2Saved: 242540,
      co2Produced: 3535770,
      netConsumed: 4394095,
      date: "2018-01-02T00:00:00.000Z"
    }, {
      localDate: "2018-01-03T00:00:00.000Z",
      solarGenerated: 392020,
      gridConsumed: 3715185,
      solarReturned: 0,
      solarConsumption: 392020,
      co2Saved: 336980,
      co2Produced: 3194730,
      netConsumed: 4107205,
      date: "2018-01-03T00:00:00.000Z"
    }, {
      localDate: "2018-01-04T00:00:00.000Z",
      solarGenerated: 391960,
      gridConsumed: 3518175,
      solarReturned: 0,
      solarConsumption: 391960,
      co2Saved: 336920,
      co2Produced: 3025275,
      netConsumed: 3910135,
      date: "2018-01-04T00:00:00.000Z"
    }, {
      localDate: "2018-01-05T00:00:00.000Z",
      solarGenerated: 352740,
      gridConsumed: 3429635,
      solarReturned: 0,
      solarConsumption: 352740,
      co2Saved: 303060,
      co2Produced: 2949000,
      netConsumed: 3782375,
      date: "2018-01-05T00:00:00.000Z"
    }, {
      localDate: "2018-01-06T00:00:00.000Z",
      solarGenerated: 489320,
      gridConsumed: 2805205,
      solarReturned: 0,
      solarConsumption: 489320,
      co2Saved: 420600,
      co2Produced: 2411980,
      netConsumed: 3294525,
      date: "2018-01-06T00:00:00.000Z"
    }, {
      localDate: "2018-01-07T00:00:00.000Z",
      solarGenerated: 507640,
      gridConsumed: 2871410,
      solarReturned: 150,
      solarConsumption: 507490,
      co2Saved: 436440,
      co2Produced: 2469070,
      netConsumed: 3378900,
      date: "2018-01-07T00:00:00.000Z"
    }, {
      localDate: "2018-01-08T00:00:00.000Z",
      solarGenerated: 519960,
      gridConsumed: 4662670,
      solarReturned: 35,
      solarConsumption: 519925,
      co2Saved: 446800,
      co2Produced: 4009540,
      netConsumed: 5182595,
      date: "2018-01-08T00:00:00.000Z"
    }, {
      localDate: "2018-01-09T00:00:00.000Z",
      solarGenerated: 518300,
      gridConsumed: 4870660,
      solarReturned: 0,
      solarConsumption: 518300,
      co2Saved: 445520,
      co2Produced: 4188320,
      netConsumed: 5388960,
      date: "2018-01-09T00:00:00.000Z"
    }, {
      localDate: "2018-01-10T00:00:00.000Z",
      solarGenerated: 472280,
      gridConsumed: 4317125,
      solarReturned: 10,
      solarConsumption: 472270,
      co2Saved: 405940,
      co2Produced: 3712345,
      netConsumed: 4789395,
      date: "2018-01-10T00:00:00.000Z"
    }, {
      localDate: "2018-01-11T00:00:00.000Z",
      solarGenerated: 409160,
      gridConsumed: 5449830,
      solarReturned: 0,
      solarConsumption: 409160,
      co2Saved: 351800,
      co2Produced: 4686540,
      netConsumed: 5858990,
      date: "2018-01-11T00:00:00.000Z"
    }, {
      localDate: "2018-01-12T00:00:00.000Z",
      solarGenerated: 400360,
      gridConsumed: 4728815,
      solarReturned: 0,
      solarConsumption: 400360,
      co2Saved: 344080,
      co2Produced: 4066410,
      netConsumed: 5129175,
      date: "2018-01-12T00:00:00.000Z"
    }, {
      localDate: "2018-01-13T00:00:00.000Z",
      solarGenerated: 469680,
      gridConsumed: 3052845,
      solarReturned: 0,
      solarConsumption: 469680,
      co2Saved: 403840,
      co2Produced: 2625010,
      netConsumed: 3522525,
      date: "2018-01-13T00:00:00.000Z"
    }, {
      localDate: "2018-01-14T00:00:00.000Z",
      solarGenerated: 436260,
      gridConsumed: 3087585,
      solarReturned: 0,
      solarConsumption: 436260,
      co2Saved: 374940,
      co2Produced: 2654950,
      netConsumed: 3523845,
      date: "2018-01-14T00:00:00.000Z"
    }, {
      localDate: "2018-01-15T00:00:00.000Z",
      solarGenerated: 487840,
      gridConsumed: 5788085,
      solarReturned: 705,
      solarConsumption: 487135,
      co2Saved: 419340,
      co2Produced: 4977270,
      netConsumed: 6275220,
      date: "2018-01-15T00:00:00.000Z"
    }, {
      localDate: "2018-01-16T00:00:00.000Z",
      solarGenerated: 512860,
      gridConsumed: 6066035,
      solarReturned: 0,
      solarConsumption: 512860,
      co2Saved: 440880,
      co2Produced: 5216350,
      netConsumed: 6578895,
      date: "2018-01-16T00:00:00.000Z"
    }, {
      localDate: "2018-01-17T00:00:00.000Z",
      solarGenerated: 519560,
      gridConsumed: 5554490,
      solarReturned: 0,
      solarConsumption: 519560,
      co2Saved: 446320,
      co2Produced: 4776385,
      netConsumed: 6074050,
      date: "2018-01-17T00:00:00.000Z"
    }, {
      localDate: "2018-01-18T00:00:00.000Z",
      solarGenerated: 495940,
      gridConsumed: 6223335,
      solarReturned: 0,
      solarConsumption: 495940,
      co2Saved: 426160,
      co2Produced: 5351515,
      netConsumed: 6719275,
      date: "2018-01-18T00:00:00.000Z"
    }, {
      localDate: "2018-01-19T00:00:00.000Z",
      solarGenerated: 511300,
      gridConsumed: 5578905,
      solarReturned: 15,
      solarConsumption: 511285,
      co2Saved: 439540,
      co2Produced: 4797465,
      netConsumed: 6090190,
      date: "2018-01-19T00:00:00.000Z"
    }, {
      localDate: "2018-01-20T00:00:00.000Z",
      solarGenerated: 473320,
      gridConsumed: 2454355,
      solarReturned: 5,
      solarConsumption: 473315,
      co2Saved: 406860,
      co2Produced: 2110355,
      netConsumed: 2927670,
      date: "2018-01-20T00:00:00.000Z"
    }, {
      localDate: "2018-01-21T00:00:00.000Z",
      solarGenerated: 383180,
      gridConsumed: 2988580,
      solarReturned: 70,
      solarConsumption: 383110,
      co2Saved: 329300,
      co2Produced: 2569715,
      netConsumed: 3371690,
      date: "2018-01-21T00:00:00.000Z"
    }, {
      localDate: "2018-01-22T00:00:00.000Z",
      solarGenerated: 365780,
      gridConsumed: 7151560,
      solarReturned: 5,
      solarConsumption: 365775,
      co2Saved: 314320,
      co2Produced: 6150090,
      netConsumed: 7517335,
      date: "2018-01-22T00:00:00.000Z"
    }, {
      localDate: "2018-01-23T00:00:00.000Z",
      solarGenerated: 456460,
      gridConsumed: 8550785,
      solarReturned: 0,
      solarConsumption: 456460,
      co2Saved: 392300,
      co2Produced: 7353300,
      netConsumed: 9007245,
      date: "2018-01-23T00:00:00.000Z"
    }, {
      localDate: "2018-01-24T00:00:00.000Z",
      solarGenerated: 420720,
      gridConsumed: 9882060,
      solarReturned: 0,
      solarConsumption: 420720,
      co2Saved: 361680,
      co2Produced: 8498030,
      netConsumed: 10302780,
      date: "2018-01-24T00:00:00.000Z"
    }, {
      localDate: "2018-01-25T00:00:00.000Z",
      solarGenerated: 452500,
      gridConsumed: 10236545,
      solarReturned: 0,
      solarConsumption: 452500,
      co2Saved: 388840,
      co2Produced: 8802915,
      netConsumed: 10689045,
      date: "2018-01-25T00:00:00.000Z"
    }, {
      localDate: "2018-01-26T00:00:00.000Z",
      solarGenerated: 460740,
      gridConsumed: 3907810,
      solarReturned: 0,
      solarConsumption: 460740,
      co2Saved: 395800,
      co2Produced: 3360305,
      netConsumed: 4368550,
      date: "2018-01-26T00:00:00.000Z"
    }, {
      localDate: "2018-01-27T00:00:00.000Z",
      solarGenerated: 372680,
      gridConsumed: 3386160,
      solarReturned: 0,
      solarConsumption: 372680,
      co2Saved: 320240,
      co2Produced: 2911695,
      netConsumed: 3758840,
      date: "2018-01-27T00:00:00.000Z"
    }, {
      localDate: "2018-01-28T00:00:00.000Z",
      solarGenerated: 335000,
      gridConsumed: 2974285,
      solarReturned: 0,
      solarConsumption: 335000,
      co2Saved: 287860,
      co2Produced: 2557570,
      netConsumed: 3309285,
      date: "2018-01-28T00:00:00.000Z"
    }, {
      localDate: "2018-01-29T00:00:00.000Z",
      solarGenerated: 400540,
      gridConsumed: 9295885,
      solarReturned: 0,
      solarConsumption: 400540,
      co2Saved: 344260,
      co2Produced: 7994145,
      netConsumed: 9696425,
      date: "2018-01-29T00:00:00.000Z"
    }, {
      localDate: "2018-01-30T00:00:00.000Z",
      solarGenerated: 354040,
      gridConsumed: 9776635,
      solarReturned: 0,
      solarConsumption: 354040,
      co2Saved: 304360,
      co2Produced: 8407470,
      netConsumed: 10130675,
      date: "2018-01-30T00:00:00.000Z"
    }, {
      localDate: "2018-01-31T00:00:00.000Z",
      solarGenerated: 424240,
      gridConsumed: 9974620,
      solarReturned: 0,
      solarConsumption: 424240,
      co2Saved: 364620,
      co2Produced: 8577805,
      netConsumed: 10398860,
      date: "2018-01-31T00:00:00.000Z"
    }]
  }, {
    year: 2018,
    month: "Feb",
    dates: [{
      localDate: "2018-02-01T00:00:00.000Z",
      solarGenerated: 164460,
      gridConsumed: 5694420,
      solarReturned: 535,
      solarConsumption: 163925,
      co2Saved: 141200,
      co2Produced: 4896720,
      netConsumed: 5858345,
      date: "2018-02-01T00:00:00.000Z"
    }, {
      localDate: "2018-02-02T00:00:00.000Z",
      solarGenerated: 136020,
      gridConsumed: 5018050,
      solarReturned: 0,
      solarConsumption: 136020,
      co2Saved: 116560,
      co2Produced: 4315015,
      netConsumed: 5154070,
      date: "2018-02-02T00:00:00.000Z"
    }, {
      localDate: "2018-02-03T00:00:00.000Z",
      solarGenerated: 103800,
      gridConsumed: 2412710,
      solarReturned: 460,
      solarConsumption: 103340,
      co2Saved: 88980,
      co2Produced: 2074515,
      netConsumed: 2516050,
      date: "2018-02-03T00:00:00.000Z"
    }, {
      localDate: "2018-02-04T00:00:00.000Z",
      solarGenerated: 416840,
      gridConsumed: 2653200,
      solarReturned: 435,
      solarConsumption: 416405,
      co2Saved: 358400,
      co2Produced: 2281295,
      netConsumed: 3069605,
      date: "2018-02-04T00:00:00.000Z"
    }, {
      localDate: "2018-02-05T00:00:00.000Z",
      solarGenerated: 488420,
      gridConsumed: 7056865,
      solarReturned: 125,
      solarConsumption: 488295,
      co2Saved: 419900,
      co2Produced: 6068465,
      netConsumed: 7545160,
      date: "2018-02-05T00:00:00.000Z"
    }, {
      localDate: "2018-02-06T00:00:00.000Z",
      solarGenerated: 450000,
      gridConsumed: 7868390,
      solarReturned: 0,
      solarConsumption: 450000,
      co2Saved: 386960,
      co2Produced: 6766405,
      netConsumed: 8318390,
      date: "2018-02-06T00:00:00.000Z"
    }, {
      localDate: "2018-02-07T00:00:00.000Z",
      solarGenerated: 465580,
      gridConsumed: 7013075,
      solarReturned: 5,
      solarConsumption: 465575,
      co2Saved: 400300,
      co2Produced: 6030880,
      netConsumed: 7478650,
      date: "2018-02-07T00:00:00.000Z"
    }, {
      localDate: "2018-02-08T00:00:00.000Z",
      solarGenerated: 372840,
      gridConsumed: 7041470,
      solarReturned: 1245,
      solarConsumption: 371595,
      co2Saved: 320500,
      co2Produced: 6055350,
      netConsumed: 7413065,
      date: "2018-02-08T00:00:00.000Z"
    }, {
      localDate: "2018-02-09T00:00:00.000Z",
      solarGenerated: 463840,
      gridConsumed: 7649385,
      solarReturned: 0,
      solarConsumption: 463840,
      co2Saved: 398580,
      co2Produced: 6578005,
      netConsumed: 8113225,
      date: "2018-02-09T00:00:00.000Z"
    }, {
      localDate: "2018-02-10T00:00:00.000Z",
      solarGenerated: 465160,
      gridConsumed: 2646635,
      solarReturned: 1685,
      solarConsumption: 463475,
      co2Saved: 399880,
      co2Produced: 2275610,
      netConsumed: 3110110,
      date: "2018-02-10T00:00:00.000Z"
    }, {
      localDate: "2018-02-11T00:00:00.000Z",
      solarGenerated: 456360,
      gridConsumed: 2330810,
      solarReturned: 3080,
      solarConsumption: 453280,
      co2Saved: 392260,
      co2Produced: 2004200,
      netConsumed: 2784090,
      date: "2018-02-11T00:00:00.000Z"
    }, {
      localDate: "2018-02-12T00:00:00.000Z",
      solarGenerated: 460140,
      gridConsumed: 9666420,
      solarReturned: 0,
      solarConsumption: 460140,
      co2Saved: 395560,
      co2Produced: 8312718,
      netConsumed: 10126560,
      date: "2018-02-12T00:00:00.000Z"
    }, {
      localDate: "2018-02-13T00:00:00.000Z",
      solarGenerated: 338800,
      gridConsumed: 10765680,
      solarReturned: 0,
      solarConsumption: 338800,
      co2Saved: 291260,
      co2Produced: 9258080,
      netConsumed: 11104480,
      date: "2018-02-13T00:00:00.000Z"
    }, {
      localDate: "2018-02-14T00:00:00.000Z",
      solarGenerated: 454820,
      gridConsumed: 10402080,
      solarReturned: 0,
      solarConsumption: 454820,
      co2Saved: 390800,
      co2Produced: 8945370,
      netConsumed: 10856900,
      date: "2018-02-14T00:00:00.000Z"
    }, {
      localDate: "2018-02-15T00:00:00.000Z",
      solarGenerated: 349500,
      gridConsumed: 10826900,
      solarReturned: 0,
      solarConsumption: 349500,
      co2Saved: 300320,
      co2Produced: 9310720,
      netConsumed: 11176400,
      date: "2018-02-15T00:00:00.000Z"
    }, {
      localDate: "2018-02-16T00:00:00.000Z",
      solarGenerated: 305320,
      gridConsumed: 9955300,
      solarReturned: 0,
      solarConsumption: 305320,
      co2Saved: 262340,
      co2Produced: 8561220,
      netConsumed: 10260620,
      date: "2018-02-16T00:00:00.000Z"
    }, {
      localDate: "2018-02-17T00:00:00.000Z",
      solarGenerated: 388060,
      gridConsumed: 3673585,
      solarReturned: 0,
      solarConsumption: 388060,
      co2Saved: 333520,
      co2Produced: 3158840,
      netConsumed: 4061645,
      date: "2018-02-17T00:00:00.000Z"
    }, {
      localDate: "2018-02-18T00:00:00.000Z",
      solarGenerated: 366780,
      gridConsumed: 3437220,
      solarReturned: 0,
      solarConsumption: 366780,
      co2Saved: 315100,
      co2Produced: 2955525,
      netConsumed: 3804000,
      date: "2018-02-18T00:00:00.000Z"
    }, {
      localDate: "2018-02-19T00:00:00.000Z",
      solarGenerated: 434800,
      gridConsumed: 9058340,
      solarReturned: 0,
      solarConsumption: 434800,
      co2Saved: 373640,
      co2Produced: 7789835,
      netConsumed: 9493140,
      date: "2018-02-19T00:00:00.000Z"
    }, {
      localDate: "2018-02-20T00:00:00.000Z",
      solarGenerated: 333100,
      gridConsumed: 8860930,
      solarReturned: 0,
      solarConsumption: 333100,
      co2Saved: 286300,
      co2Produced: 7619960,
      netConsumed: 9194030,
      date: "2018-02-20T00:00:00.000Z"
    }, {
      localDate: "2018-02-21T00:00:00.000Z",
      solarGenerated: 212820,
      gridConsumed: 7307610,
      solarReturned: 385,
      solarConsumption: 212435,
      co2Saved: 182880,
      co2Produced: 6284170,
      netConsumed: 7520045,
      date: "2018-02-21T00:00:00.000Z"
    }, {
      localDate: "2018-02-22T00:00:00.000Z",
      solarGenerated: 200600,
      gridConsumed: 7205790,
      solarReturned: 0,
      solarConsumption: 200600,
      co2Saved: 172280,
      co2Produced: 6196580,
      netConsumed: 7406390,
      date: "2018-02-22T00:00:00.000Z"
    }, {
      localDate: "2018-02-23T00:00:00.000Z",
      solarGenerated: 90040,
      gridConsumed: 6805375,
      solarReturned: 0,
      solarConsumption: 90040,
      co2Saved: 77160,
      co2Produced: 5852240,
      netConsumed: 6895415,
      date: "2018-02-23T00:00:00.000Z"
    }, {
      localDate: "2018-02-24T00:00:00.000Z",
      solarGenerated: 230740,
      gridConsumed: 2581210,
      solarReturned: 3250,
      solarConsumption: 227490,
      co2Saved: 198200,
      co2Produced: 2219450,
      netConsumed: 2808700,
      date: "2018-02-24T00:00:00.000Z"
    }, {
      localDate: "2018-02-25T00:00:00.000Z",
      solarGenerated: 303320,
      gridConsumed: 2515285,
      solarReturned: 1535,
      solarConsumption: 301785,
      co2Saved: 260420,
      co2Produced: 2162675,
      netConsumed: 2817070,
      date: "2018-02-25T00:00:00.000Z"
    }, {
      localDate: "2018-02-26T00:00:00.000Z",
      solarGenerated: 353260,
      gridConsumed: 9842635,
      solarReturned: 325,
      solarConsumption: 352935,
      co2Saved: 303500,
      co2Produced: 8464260,
      netConsumed: 10195570,
      date: "2018-02-26T00:00:00.000Z"
    }, {
      localDate: "2018-02-27T00:00:00.000Z",
      solarGenerated: 226200,
      gridConsumed: 7603680,
      solarReturned: 0,
      solarConsumption: 226200,
      co2Saved: 194420,
      co2Produced: 6538710,
      netConsumed: 7829880,
      date: "2018-02-27T00:00:00.000Z"
    }, {
      localDate: "2018-02-28T00:00:00.000Z",
      solarGenerated: 359420,
      gridConsumed: 7605590,
      solarReturned: 0,
      solarConsumption: 359420,
      co2Saved: 308960,
      co2Produced: 6540435,
      netConsumed: 7965010,
      date: "2018-02-28T00:00:00.000Z"
    }]
  }, {
    year: 2018,
    month: "Mar",
    dates: [{
      localDate: "2018-03-01T00:00:00.000Z",
      solarGenerated: 382160,
      gridConsumed: 9398175,
      solarReturned: 0,
      solarConsumption: 382160,
      co2Saved: 328540,
      co2Produced: 8082150,
      netConsumed: 9780335,
      date: "2018-03-01T00:00:00.000Z"
    }, {
      localDate: "2018-03-02T00:00:00.000Z",
      solarGenerated: 228600,
      gridConsumed: 8618905,
      solarReturned: 15,
      solarConsumption: 228585,
      co2Saved: 196320,
      co2Produced: 7411865,
      netConsumed: 8847490,
      date: "2018-03-02T00:00:00.000Z"
    }, {
      localDate: "2018-03-03T00:00:00.000Z",
      solarGenerated: 224720,
      gridConsumed: 3635220,
      solarReturned: 2405,
      solarConsumption: 222315,
      co2Saved: 193200,
      co2Produced: 3125800,
      netConsumed: 3857535,
      date: "2018-03-03T00:00:00.000Z"
    }, {
      localDate: "2018-03-04T00:00:00.000Z",
      solarGenerated: 380520,
      gridConsumed: 4086910,
      solarReturned: 0,
      solarConsumption: 380520,
      co2Saved: 327100,
      co2Produced: 3514370,
      netConsumed: 4467430,
      date: "2018-03-04T00:00:00.000Z"
    }, {
      localDate: "2018-03-05T00:00:00.000Z",
      solarGenerated: 208620,
      gridConsumed: 7766090,
      solarReturned: 0,
      solarConsumption: 208620,
      co2Saved: 179300,
      co2Produced: 6678565,
      netConsumed: 7974710,
      date: "2018-03-05T00:00:00.000Z"
    }, {
      localDate: "2018-03-06T00:00:00.000Z",
      solarGenerated: 112700,
      gridConsumed: 6334940,
      solarReturned: 25,
      solarConsumption: 112675,
      co2Saved: 96840,
      co2Produced: 5447640,
      netConsumed: 6447615,
      date: "2018-03-06T00:00:00.000Z"
    }, {
      localDate: "2018-03-07T00:00:00.000Z",
      solarGenerated: 225260,
      gridConsumed: 6269285,
      solarReturned: 30,
      solarConsumption: 225230,
      co2Saved: 193460,
      co2Produced: 5391215,
      netConsumed: 6494515,
      date: "2018-03-07T00:00:00.000Z"
    }, {
      localDate: "2018-03-08T00:00:00.000Z",
      solarGenerated: 280200,
      gridConsumed: 6361365,
      solarReturned: 65,
      solarConsumption: 280135,
      co2Saved: 240800,
      co2Produced: 5470355,
      netConsumed: 6641500,
      date: "2018-03-08T00:00:00.000Z"
    }, {
      localDate: "2018-03-09T00:00:00.000Z",
      solarGenerated: 338640,
      gridConsumed: 6385435,
      solarReturned: 180,
      solarConsumption: 338460,
      co2Saved: 290940,
      co2Produced: 5491095,
      netConsumed: 6723895,
      date: "2018-03-09T00:00:00.000Z"
    }, {
      localDate: "2018-03-10T00:00:00.000Z",
      solarGenerated: 296520,
      gridConsumed: 2777205,
      solarReturned: 100,
      solarConsumption: 296420,
      co2Saved: 254980,
      co2Produced: 2388025,
      netConsumed: 3073625,
      date: "2018-03-10T00:00:00.000Z"
    }, {
      localDate: "2018-03-11T00:00:00.000Z",
      solarGenerated: 268160,
      gridConsumed: 2739920,
      solarReturned: 130,
      solarConsumption: 268030,
      co2Saved: 230420,
      co2Produced: 2355940,
      netConsumed: 3007950,
      date: "2018-03-11T00:00:00.000Z"
    }, {
      localDate: "2018-03-12T00:00:00.000Z",
      solarGenerated: 368140,
      gridConsumed: 6569580,
      solarReturned: 90,
      solarConsumption: 368050,
      co2Saved: 316400,
      co2Produced: 5649415,
      netConsumed: 6937630,
      date: "2018-03-12T00:00:00.000Z"
    }, {
      localDate: "2018-03-13T00:00:00.000Z",
      solarGenerated: 247980,
      gridConsumed: 6533585,
      solarReturned: 0,
      solarConsumption: 247980,
      co2Saved: 213080,
      co2Produced: 5618520,
      netConsumed: 6781565,
      date: "2018-03-13T00:00:00.000Z"
    }, {
      localDate: "2018-03-14T00:00:00.000Z",
      solarGenerated: 359620,
      gridConsumed: 7348990,
      solarReturned: 150,
      solarConsumption: 359470,
      co2Saved: 309160,
      co2Produced: 6319690,
      netConsumed: 7708460,
      date: "2018-03-14T00:00:00.000Z"
    }, {
      localDate: "2018-03-15T00:00:00.000Z",
      solarGenerated: 347400,
      gridConsumed: 7299205,
      solarReturned: 670,
      solarConsumption: 346730,
      co2Saved: 298560,
      co2Produced: 6276885,
      netConsumed: 7645935,
      date: "2018-03-15T00:00:00.000Z"
    }, {
      localDate: "2018-03-16T00:00:00.000Z",
      solarGenerated: 403960,
      gridConsumed: 7591895,
      solarReturned: 735,
      solarConsumption: 403225,
      co2Saved: 347300,
      co2Produced: 6528650,
      netConsumed: 7995120,
      date: "2018-03-16T00:00:00.000Z"
    }, {
      localDate: "2018-03-17T00:00:00.000Z",
      solarGenerated: 394040,
      gridConsumed: 3142520,
      solarReturned: 135,
      solarConsumption: 393905,
      co2Saved: 338720,
      co2Produced: 2702205,
      netConsumed: 3536425,
      date: "2018-03-17T00:00:00.000Z"
    }, {
      localDate: "2018-03-18T00:00:00.000Z",
      solarGenerated: 348900,
      gridConsumed: 2995400,
      solarReturned: 130,
      solarConsumption: 348770,
      co2Saved: 299880,
      co2Produced: 2575580,
      netConsumed: 3344170,
      date: "2018-03-18T00:00:00.000Z"
    }, {
      localDate: "2018-03-19T00:00:00.000Z",
      solarGenerated: 363000,
      gridConsumed: 8401895,
      solarReturned: 0,
      solarConsumption: 363000,
      co2Saved: 311960,
      co2Produced: 7225355,
      netConsumed: 8764895,
      date: "2018-03-19T00:00:00.000Z"
    }, {
      localDate: "2018-03-20T00:00:00.000Z",
      solarGenerated: 347260,
      gridConsumed: 8444185,
      solarReturned: 270,
      solarConsumption: 346990,
      co2Saved: 298420,
      co2Produced: 7261660,
      netConsumed: 8791175,
      date: "2018-03-20T00:00:00.000Z"
    }, {
      localDate: "2018-03-21T00:00:00.000Z",
      solarGenerated: 226760,
      gridConsumed: 7699100,
      solarReturned: 575,
      solarConsumption: 226185,
      co2Saved: 194800,
      co2Produced: 6620925,
      netConsumed: 7925285,
      date: "2018-03-21T00:00:00.000Z"
    }, {
      localDate: "2018-03-22T00:00:00.000Z",
      solarGenerated: 328500,
      gridConsumed: 7771850,
      solarReturned: 0,
      solarConsumption: 328500,
      co2Saved: 282300,
      co2Produced: 6683365,
      netConsumed: 8100350,
      date: "2018-03-22T00:00:00.000Z"
    }, {
      localDate: "2018-03-23T00:00:00.000Z",
      solarGenerated: 306700,
      gridConsumed: 7057345,
      solarReturned: 0,
      solarConsumption: 306700,
      co2Saved: 263560,
      co2Produced: 6068855,
      netConsumed: 7364045,
      date: "2018-03-23T00:00:00.000Z"
    }, {
      localDate: "2018-03-24T00:00:00.000Z",
      solarGenerated: 305560,
      gridConsumed: 2783680,
      solarReturned: 0,
      solarConsumption: 305560,
      co2Saved: 262720,
      co2Produced: 2393670,
      netConsumed: 3089240,
      date: "2018-03-24T00:00:00.000Z"
    }, {
      localDate: "2018-03-25T00:00:00.000Z",
      solarGenerated: 233660,
      gridConsumed: 3111810,
      solarReturned: 0,
      solarConsumption: 233660,
      co2Saved: 200740,
      co2Produced: 2675650,
      netConsumed: 3345470,
      date: "2018-03-25T00:00:00.000Z"
    }, {
      localDate: "2018-03-26T00:00:00.000Z",
      solarGenerated: 260220,
      gridConsumed: 7977780,
      solarReturned: 0,
      solarConsumption: 260220,
      co2Saved: 223600,
      co2Produced: 6860460,
      netConsumed: 8238000,
      date: "2018-03-26T00:00:00.000Z"
    }, {
      localDate: "2018-03-27T00:00:00.000Z",
      solarGenerated: 155960,
      gridConsumed: 7534710,
      solarReturned: 0,
      solarConsumption: 155960,
      co2Saved: 133980,
      co2Produced: 6479440,
      netConsumed: 7690670,
      date: "2018-03-27T00:00:00.000Z"
    }, {
      localDate: "2018-03-28T00:00:00.000Z",
      solarGenerated: 338660,
      gridConsumed: 8224560,
      solarReturned: 245,
      solarConsumption: 338415,
      co2Saved: 291200,
      co2Produced: 7072585,
      netConsumed: 8562975,
      date: "2018-03-28T00:00:00.000Z"
    }, {
      localDate: "2018-03-29T00:00:00.000Z",
      solarGenerated: 251940,
      gridConsumed: 7624975,
      solarReturned: 1810,
      solarConsumption: 250130,
      co2Saved: 216280,
      co2Produced: 6557160,
      netConsumed: 7875105,
      date: "2018-03-29T00:00:00.000Z"
    }, {
      localDate: "2018-03-30T00:00:00.000Z",
      solarGenerated: 249600,
      gridConsumed: 3017625,
      solarReturned: 0,
      solarConsumption: 249600,
      co2Saved: 214580,
      co2Produced: 2594735,
      netConsumed: 3267225,
      date: "2018-03-30T00:00:00.000Z"
    }, {
      localDate: "2018-03-31T00:00:00.000Z",
      solarGenerated: 337620,
      gridConsumed: 2233965,
      solarReturned: 5,
      solarConsumption: 337615,
      co2Saved: 290080,
      co2Produced: 1920770,
      netConsumed: 2571580,
      date: "2018-03-31T00:00:00.000Z"
    }]
  }, {
    year: 2018,
    month: "Apr",
    dates: [{
      localDate: "2018-04-01T00:00:00.000Z",
      solarGenerated: 286580,
      gridConsumed: 2507080,
      solarReturned: 410,
      solarConsumption: 286170,
      co2Saved: 246300,
      co2Produced: 2155695,
      netConsumed: 2793250,
      date: "2018-04-01T00:00:00.000Z"
    }, {
      localDate: "2018-04-02T00:00:00.000Z",
      solarGenerated: 259040,
      gridConsumed: 2796075,
      solarReturned: 135,
      solarConsumption: 258905,
      co2Saved: 222760,
      co2Produced: 2404205,
      netConsumed: 3054980,
      date: "2018-04-02T00:00:00.000Z"
    }, {
      localDate: "2018-04-03T00:00:00.000Z",
      solarGenerated: 325080,
      gridConsumed: 3804005,
      solarReturned: 95,
      solarConsumption: 324985,
      co2Saved: 279260,
      co2Produced: 3271175,
      netConsumed: 4128990,
      date: "2018-04-03T00:00:00.000Z"
    }, {
      localDate: "2018-04-04T00:00:00.000Z",
      solarGenerated: 183160,
      gridConsumed: 3460700,
      solarReturned: 100,
      solarConsumption: 183060,
      co2Saved: 157360,
      co2Produced: 2975740,
      netConsumed: 3643760,
      date: "2018-04-04T00:00:00.000Z"
    }, {
      localDate: "2018-04-05T00:00:00.000Z",
      solarGenerated: 272900,
      gridConsumed: 3679640,
      solarReturned: 0,
      solarConsumption: 272900,
      co2Saved: 234580,
      co2Produced: 3164140,
      netConsumed: 3952540,
      date: "2018-04-05T00:00:00.000Z"
    }, {
      localDate: "2018-04-06T00:00:00.000Z",
      solarGenerated: 349020,
      gridConsumed: 3664765,
      solarReturned: 85,
      solarConsumption: 348935,
      co2Saved: 299840,
      co2Produced: 3151265,
      netConsumed: 4013700,
      date: "2018-04-06T00:00:00.000Z"
    }, {
      localDate: "2018-04-07T00:00:00.000Z",
      solarGenerated: 330220,
      gridConsumed: 2470725,
      solarReturned: 145,
      solarConsumption: 330075,
      co2Saved: 283740,
      co2Produced: 2124465,
      netConsumed: 2800800,
      date: "2018-04-07T00:00:00.000Z"
    }, {
      localDate: "2018-04-08T00:00:00.000Z",
      solarGenerated: 300860,
      gridConsumed: 2502925,
      solarReturned: 400,
      solarConsumption: 300460,
      co2Saved: 258600,
      co2Produced: 2152080,
      netConsumed: 2803385,
      date: "2018-04-08T00:00:00.000Z"
    }, {
      localDate: "2018-04-09T00:00:00.000Z",
      solarGenerated: 349820,
      gridConsumed: 3254230,
      solarReturned: 95,
      solarConsumption: 349725,
      co2Saved: 300640,
      co2Produced: 2798185,
      netConsumed: 3603955,
      date: "2018-04-09T00:00:00.000Z"
    }, {
      localDate: "2018-04-10T00:00:00.000Z",
      solarGenerated: 322240,
      gridConsumed: 3146600,
      solarReturned: 70,
      solarConsumption: 322170,
      co2Saved: 276940,
      co2Produced: 2705795,
      netConsumed: 3468770,
      date: "2018-04-10T00:00:00.000Z"
    }, {
      localDate: "2018-04-11T00:00:00.000Z",
      solarGenerated: 303300,
      gridConsumed: 3161305,
      solarReturned: 50,
      solarConsumption: 303250,
      co2Saved: 260600,
      co2Produced: 2718415,
      netConsumed: 3464555,
      date: "2018-04-11T00:00:00.000Z"
    }, {
      localDate: "2018-04-12T00:00:00.000Z",
      solarGenerated: 223680,
      gridConsumed: 3479770,
      solarReturned: 110,
      solarConsumption: 223570,
      co2Saved: 192160,
      co2Produced: 2992160,
      netConsumed: 3703340,
      date: "2018-04-12T00:00:00.000Z"
    }, {
      localDate: "2018-04-13T00:00:00.000Z",
      solarGenerated: 282320,
      gridConsumed: 3392465,
      solarReturned: 280,
      solarConsumption: 282040,
      co2Saved: 242500,
      co2Produced: 2917220,
      netConsumed: 3674505,
      date: "2018-04-13T00:00:00.000Z"
    }, {
      localDate: "2018-04-14T00:00:00.000Z",
      solarGenerated: 172960,
      gridConsumed: 2630645,
      solarReturned: 375,
      solarConsumption: 172585,
      co2Saved: 148540,
      co2Produced: 2261945,
      netConsumed: 2803230,
      date: "2018-04-14T00:00:00.000Z"
    }, {
      localDate: "2018-04-15T00:00:00.000Z",
      solarGenerated: 328480,
      gridConsumed: 2653330,
      solarReturned: 250,
      solarConsumption: 328230,
      co2Saved: 282360,
      co2Produced: 2281325,
      netConsumed: 2981560,
      date: "2018-04-15T00:00:00.000Z"
    }, {
      localDate: "2018-04-16T00:00:00.000Z",
      solarGenerated: 331500,
      gridConsumed: 5507145,
      solarReturned: 75,
      solarConsumption: 331425,
      co2Saved: 284940,
      co2Produced: 4735715,
      netConsumed: 5838570,
      date: "2018-04-16T00:00:00.000Z"
    }, {
      localDate: "2018-04-17T00:00:00.000Z",
      solarGenerated: 305000,
      gridConsumed: 7760760,
      solarReturned: 105,
      solarConsumption: 304895,
      co2Saved: 262140,
      co2Produced: 6673935,
      netConsumed: 8065655,
      date: "2018-04-17T00:00:00.000Z"
    }, {
      localDate: "2018-04-18T00:00:00.000Z",
      solarGenerated: 155800,
      gridConsumed: 6462020,
      solarReturned: 775,
      solarConsumption: 155025,
      co2Saved: 133880,
      co2Produced: 5557030,
      netConsumed: 6617045,
      date: "2018-04-18T00:00:00.000Z"
    }, {
      localDate: "2018-04-19T00:00:00.000Z",
      solarGenerated: 256080,
      gridConsumed: 6505230,
      solarReturned: 925,
      solarConsumption: 255155,
      co2Saved: 220000,
      co2Produced: 5594055,
      netConsumed: 6760385,
      date: "2018-04-19T00:00:00.000Z"
    }, {
      localDate: "2018-04-20T00:00:00.000Z",
      solarGenerated: 157500,
      gridConsumed: 5823030,
      solarReturned: 190,
      solarConsumption: 157310,
      co2Saved: 135360,
      co2Produced: 5007495,
      netConsumed: 5980340,
      date: "2018-04-20T00:00:00.000Z"
    }, {
      localDate: "2018-04-21T00:00:00.000Z",
      solarGenerated: 237440,
      gridConsumed: 2837900,
      solarReturned: 4385,
      solarConsumption: 233055,
      co2Saved: 204060,
      co2Produced: 2440225,
      netConsumed: 3070955,
      date: "2018-04-21T00:00:00.000Z"
    }, {
      localDate: "2018-04-22T00:00:00.000Z",
      solarGenerated: 240640,
      gridConsumed: 2137430,
      solarReturned: 6210,
      solarConsumption: 234430,
      co2Saved: 206720,
      co2Produced: 1837740,
      netConsumed: 2371860,
      date: "2018-04-22T00:00:00.000Z"
    }, {
      localDate: "2018-04-23T00:00:00.000Z",
      solarGenerated: 242680,
      gridConsumed: 5962885,
      solarReturned: 430,
      solarConsumption: 242250,
      co2Saved: 208520,
      co2Produced: 5127570,
      netConsumed: 6205135,
      date: "2018-04-23T00:00:00.000Z"
    }, {
      localDate: "2018-04-24T00:00:00.000Z",
      solarGenerated: 294760,
      gridConsumed: 6101300,
      solarReturned: 100,
      solarConsumption: 294660,
      co2Saved: 253320,
      co2Produced: 5246765,
      netConsumed: 6395960,
      date: "2018-04-24T00:00:00.000Z"
    }, {
      localDate: "2018-04-25T00:00:00.000Z",
      solarGenerated: 293640,
      gridConsumed: 2351385,
      solarReturned: 40,
      solarConsumption: 293600,
      co2Saved: 252420,
      co2Produced: 2021885,
      netConsumed: 2644985,
      date: "2018-04-25T00:00:00.000Z"
    }, {
      localDate: "2018-04-26T00:00:00.000Z",
      solarGenerated: 304500,
      gridConsumed: 6670585,
      solarReturned: 40,
      solarConsumption: 304460,
      co2Saved: 261740,
      co2Produced: 5736320,
      netConsumed: 6975045,
      date: "2018-04-26T00:00:00.000Z"
    }, {
      localDate: "2018-04-27T00:00:00.000Z",
      solarGenerated: 277800,
      gridConsumed: 5766070,
      solarReturned: 30,
      solarConsumption: 277770,
      co2Saved: 238700,
      co2Produced: 4958355,
      netConsumed: 6043840,
      date: "2018-04-27T00:00:00.000Z"
    }, {
      localDate: "2018-04-28T00:00:00.000Z",
      solarGenerated: 236400,
      gridConsumed: 2795475,
      solarReturned: 470,
      solarConsumption: 235930,
      co2Saved: 203180,
      co2Produced: 2403715,
      netConsumed: 3031405,
      date: "2018-04-28T00:00:00.000Z"
    }, {
      localDate: "2018-04-29T00:00:00.000Z",
      solarGenerated: 249080,
      gridConsumed: 2471990,
      solarReturned: 405,
      solarConsumption: 248675,
      co2Saved: 214000,
      co2Produced: 2125590,
      netConsumed: 2720665,
      date: "2018-04-29T00:00:00.000Z"
    }, {
      localDate: "2018-04-30T00:00:00.000Z",
      solarGenerated: 251300,
      gridConsumed: 5613035,
      solarReturned: 300,
      solarConsumption: 251000,
      co2Saved: 215840,
      co2Produced: 4826810,
      netConsumed: 5864035,
      date: "2018-04-30T00:00:00.000Z"
    }]
  }, {
    year: 2018,
    month: "May",
    dates: [{
      localDate: "2018-05-01T00:00:00.000Z",
      solarGenerated: 272680,
      gridConsumed: 5343110,
      solarReturned: 390,
      solarConsumption: 272290,
      co2Saved: 234240,
      co2Produced: 4594770,
      netConsumed: 5615400,
      date: "2018-05-01T00:00:00.000Z"
    }, {
      localDate: "2018-05-02T00:00:00.000Z",
      solarGenerated: 249480,
      gridConsumed: 5532620,
      solarReturned: 15,
      solarConsumption: 249465,
      co2Saved: 214320,
      co2Produced: 4757650,
      netConsumed: 5782085,
      date: "2018-05-02T00:00:00.000Z"
    }, {
      localDate: "2018-05-03T00:00:00.000Z",
      solarGenerated: 197960,
      gridConsumed: 5623320,
      solarReturned: 25,
      solarConsumption: 197935,
      co2Saved: 169980,
      co2Produced: 4835720,
      netConsumed: 5821255,
      date: "2018-05-03T00:00:00.000Z"
    }, {
      localDate: "2018-05-04T00:00:00.000Z",
      solarGenerated: 279900,
      gridConsumed: 6561060,
      solarReturned: 0,
      solarConsumption: 279900,
      co2Saved: 240480,
      co2Produced: 5642130,
      netConsumed: 6840960,
      date: "2018-05-04T00:00:00.000Z"
    }, {
      localDate: "2018-05-05T00:00:00.000Z",
      solarGenerated: 283780,
      gridConsumed: 3346940,
      solarReturned: 5,
      solarConsumption: 283775,
      co2Saved: 243960,
      co2Produced: 2877835,
      netConsumed: 3630715,
      date: "2018-05-05T00:00:00.000Z"
    }, {
      localDate: "2018-05-06T00:00:00.000Z",
      solarGenerated: 298600,
      gridConsumed: 2485310,
      solarReturned: 155,
      solarConsumption: 298445,
      co2Saved: 256440,
      co2Produced: 2136870,
      netConsumed: 2783755,
      date: "2018-05-06T00:00:00.000Z"
    }, {
      localDate: "2018-05-07T00:00:00.000Z",
      solarGenerated: 153460,
      gridConsumed: 2820655,
      solarReturned: 35,
      solarConsumption: 153425,
      co2Saved: 131740,
      co2Produced: 2425340,
      netConsumed: 2974080,
      date: "2018-05-07T00:00:00.000Z"
    }, {
      localDate: "2018-05-08T00:00:00.000Z",
      solarGenerated: 124560,
      gridConsumed: 5951905,
      solarReturned: 10,
      solarConsumption: 124550,
      co2Saved: 106880,
      co2Produced: 5118065,
      netConsumed: 6076455,
      date: "2018-05-08T00:00:00.000Z"
    }, {
      localDate: "2018-05-09T00:00:00.000Z",
      solarGenerated: 279580,
      gridConsumed: 5579040,
      solarReturned: 0,
      solarConsumption: 279580,
      co2Saved: 240080,
      co2Produced: 4797590,
      netConsumed: 5858620,
      date: "2018-05-09T00:00:00.000Z"
    }, {
      localDate: "2018-05-10T00:00:00.000Z",
      solarGenerated: 294340,
      gridConsumed: 6165640,
      solarReturned: 0,
      solarConsumption: 294340,
      co2Saved: 253000,
      co2Produced: 5302035,
      netConsumed: 6459980,
      date: "2018-05-10T00:00:00.000Z"
    }, {
      localDate: "2018-05-11T00:00:00.000Z",
      solarGenerated: 309340,
      gridConsumed: 5150910,
      solarReturned: 65,
      solarConsumption: 309275,
      co2Saved: 265880,
      co2Produced: 4429260,
      netConsumed: 5460185,
      date: "2018-05-11T00:00:00.000Z"
    }, {
      localDate: "2018-05-12T00:00:00.000Z",
      solarGenerated: 303880,
      gridConsumed: 3066450,
      solarReturned: 190,
      solarConsumption: 303690,
      co2Saved: 261140,
      co2Produced: 2636765,
      netConsumed: 3370140,
      date: "2018-05-12T00:00:00.000Z"
    }, {
      localDate: "2018-05-13T00:00:00.000Z",
      solarGenerated: 292780,
      gridConsumed: 2804980,
      solarReturned: 0,
      solarConsumption: 292780,
      co2Saved: 251660,
      co2Produced: 2411910,
      netConsumed: 3097760,
      date: "2018-05-13T00:00:00.000Z"
    }, {
      localDate: "2018-05-14T00:00:00.000Z",
      solarGenerated: 277580,
      gridConsumed: 5038545,
      solarReturned: 0,
      solarConsumption: 277580,
      co2Saved: 238660,
      co2Produced: 4332840,
      netConsumed: 5316125,
      date: "2018-05-14T00:00:00.000Z"
    }, {
      localDate: "2018-05-15T00:00:00.000Z",
      solarGenerated: 285440,
      gridConsumed: 5334720,
      solarReturned: 525,
      solarConsumption: 284915,
      co2Saved: 245340,
      co2Produced: 4587475,
      netConsumed: 5619635,
      date: "2018-05-15T00:00:00.000Z"
    }, {
      localDate: "2018-05-16T00:00:00.000Z",
      solarGenerated: 284660,
      gridConsumed: 5306955,
      solarReturned: 185,
      solarConsumption: 284475,
      co2Saved: 244740,
      co2Produced: 4563465,
      netConsumed: 5591430,
      date: "2018-05-16T00:00:00.000Z"
    }, {
      localDate: "2018-05-17T00:00:00.000Z",
      solarGenerated: 227400,
      gridConsumed: 5514925,
      solarReturned: 405,
      solarConsumption: 226995,
      co2Saved: 195560,
      co2Produced: 4742395,
      netConsumed: 5741920,
      date: "2018-05-17T00:00:00.000Z"
    }, {
      localDate: "2018-05-18T00:00:00.000Z",
      solarGenerated: 263480,
      gridConsumed: 5278685,
      solarReturned: 370,
      solarConsumption: 263110,
      co2Saved: 226500,
      co2Produced: 4539345,
      netConsumed: 5541795,
      date: "2018-05-18T00:00:00.000Z"
    }, {
      localDate: "2018-05-19T00:00:00.000Z",
      solarGenerated: 280880,
      gridConsumed: 2794960,
      solarReturned: 1440,
      solarConsumption: 279440,
      co2Saved: 241200,
      co2Produced: 2403245,
      netConsumed: 3074400,
      date: "2018-05-19T00:00:00.000Z"
    }, {
      localDate: "2018-05-20T00:00:00.000Z",
      solarGenerated: 279300,
      gridConsumed: 2124705,
      solarReturned: 7575,
      solarConsumption: 271725,
      co2Saved: 239860,
      co2Produced: 1826820,
      netConsumed: 2396430,
      date: "2018-05-20T00:00:00.000Z"
    }, {
      localDate: "2018-05-21T00:00:00.000Z",
      solarGenerated: 275080,
      gridConsumed: 5076620,
      solarReturned: 370,
      solarConsumption: 274710,
      co2Saved: 236260,
      co2Produced: 4365390,
      netConsumed: 5351330,
      date: "2018-05-21T00:00:00.000Z"
    }, {
      localDate: "2018-05-22T00:00:00.000Z",
      solarGenerated: 280400,
      gridConsumed: 5519815,
      solarReturned: 2485,
      solarConsumption: 277915,
      co2Saved: 240980,
      co2Produced: 4746725,
      netConsumed: 5797730,
      date: "2018-05-22T00:00:00.000Z"
    }, {
      localDate: "2018-05-23T00:00:00.000Z",
      solarGenerated: 249080,
      gridConsumed: 5493440,
      solarReturned: 305,
      solarConsumption: 248775,
      co2Saved: 214240,
      co2Produced: 4723875,
      netConsumed: 5742215,
      date: "2018-05-23T00:00:00.000Z"
    }, {
      localDate: "2018-05-24T00:00:00.000Z",
      solarGenerated: 219940,
      gridConsumed: 5202420,
      solarReturned: 1860,
      solarConsumption: 218080,
      co2Saved: 189020,
      co2Produced: 4473605,
      netConsumed: 5420500,
      date: "2018-05-24T00:00:00.000Z"
    }, {
      localDate: "2018-05-25T00:00:00.000Z",
      solarGenerated: 189140,
      gridConsumed: 5137590,
      solarReturned: 205,
      solarConsumption: 188935,
      co2Saved: 162420,
      co2Produced: 4417885,
      netConsumed: 5326525,
      date: "2018-05-25T00:00:00.000Z"
    }, {
      localDate: "2018-05-26T00:00:00.000Z",
      solarGenerated: 204020,
      gridConsumed: 2300865,
      solarReturned: 8760,
      solarConsumption: 195260,
      co2Saved: 175140,
      co2Produced: 1978300,
      netConsumed: 2496125,
      date: "2018-05-26T00:00:00.000Z"
    }, {
      localDate: "2018-05-27T00:00:00.000Z",
      solarGenerated: 196400,
      gridConsumed: 2316645,
      solarReturned: 12750,
      solarConsumption: 183650,
      co2Saved: 168640,
      co2Produced: 1992005,
      netConsumed: 2500295,
      date: "2018-05-27T00:00:00.000Z"
    }, {
      localDate: "2018-05-28T00:00:00.000Z",
      solarGenerated: 188500,
      gridConsumed: 4653475,
      solarReturned: 1935,
      solarConsumption: 186565,
      co2Saved: 161760,
      co2Produced: 4001460,
      netConsumed: 4840040,
      date: "2018-05-28T00:00:00.000Z"
    }, {
      localDate: "2018-05-29T00:00:00.000Z",
      solarGenerated: 176980,
      gridConsumed: 4487875,
      solarReturned: 245,
      solarConsumption: 176735,
      co2Saved: 152160,
      co2Produced: 3859155,
      netConsumed: 4664610,
      date: "2018-05-29T00:00:00.000Z"
    }, {
      localDate: "2018-05-30T00:00:00.000Z",
      solarGenerated: 253000,
      gridConsumed: 5088145,
      solarReturned: 385,
      solarConsumption: 252615,
      co2Saved: 217280,
      co2Produced: 4375370,
      netConsumed: 5340760,
      date: "2018-05-30T00:00:00.000Z"
    }, {
      localDate: "2018-05-31T00:00:00.000Z",
      solarGenerated: 268620,
      gridConsumed: 4587400,
      solarReturned: 3960,
      solarConsumption: 264660,
      co2Saved: 230780,
      co2Produced: 3944745,
      netConsumed: 4852060,
      date: "2018-05-31T00:00:00.000Z"
    }]
  }, {
    year: 2018,
    month: "Jun",
    dates: [{
      localDate: "2018-06-01T00:00:00.000Z",
      solarGenerated: 263580,
      gridConsumed: 4739390,
      solarReturned: 4805,
      solarConsumption: 258775,
      co2Saved: 226420,
      co2Produced: 4075610,
      netConsumed: 4998165,
      date: "2018-06-01T00:00:00.000Z"
    }, {
      localDate: "2018-06-02T00:00:00.000Z",
      solarGenerated: 260640,
      gridConsumed: 2688625,
      solarReturned: 10310,
      solarConsumption: 250330,
      co2Saved: 223880,
      co2Produced: 2311820,
      netConsumed: 2938955,
      date: "2018-06-02T00:00:00.000Z"
    }, {
      localDate: "2018-06-03T00:00:00.000Z",
      solarGenerated: 243800,
      gridConsumed: 2675535,
      solarReturned: 540,
      solarConsumption: 243260,
      co2Saved: 209500,
      co2Produced: 2300335,
      netConsumed: 2918795,
      date: "2018-06-03T00:00:00.000Z"
    }, {
      localDate: "2018-06-04T00:00:00.000Z",
      solarGenerated: 218180,
      gridConsumed: 4614535,
      solarReturned: 1735,
      solarConsumption: 216445,
      co2Saved: 187480,
      co2Produced: 3968290,
      netConsumed: 4830980,
      date: "2018-06-04T00:00:00.000Z"
    }, {
      localDate: "2018-06-05T00:00:00.000Z",
      solarGenerated: 246740,
      gridConsumed: 4316090,
      solarReturned: 4105,
      solarConsumption: 242635,
      co2Saved: 211980,
      co2Produced: 3711405,
      netConsumed: 4558725,
      date: "2018-06-05T00:00:00.000Z"
    }, {
      localDate: "2018-06-06T00:00:00.000Z",
      solarGenerated: 210620,
      gridConsumed: 4645945,
      solarReturned: 665,
      solarConsumption: 209955,
      co2Saved: 181120,
      co2Produced: 3995060,
      netConsumed: 4855900,
      date: "2018-06-06T00:00:00.000Z"
    }, {
      localDate: "2018-06-07T00:00:00.000Z",
      solarGenerated: 127280,
      gridConsumed: 4199215,
      solarReturned: 1125,
      solarConsumption: 126155,
      co2Saved: 109200,
      co2Produced: 3610925,
      netConsumed: 4325370,
      date: "2018-06-07T00:00:00.000Z"
    }, {
      localDate: "2018-06-08T00:00:00.000Z",
      solarGenerated: 137440,
      gridConsumed: 4276590,
      solarReturned: 515,
      solarConsumption: 136925,
      co2Saved: 118020,
      co2Produced: 3677505,
      netConsumed: 4413515,
      date: "2018-06-08T00:00:00.000Z"
    }, {
      localDate: "2018-06-09T00:00:00.000Z",
      solarGenerated: 152580,
      gridConsumed: 2236270,
      solarReturned: 3310,
      solarConsumption: 149270,
      co2Saved: 131040,
      co2Produced: 1922810,
      netConsumed: 2385540,
      date: "2018-06-09T00:00:00.000Z"
    }, {
      localDate: "2018-06-10T00:00:00.000Z",
      solarGenerated: 210660,
      gridConsumed: 2038895,
      solarReturned: 1440,
      solarConsumption: 209220,
      co2Saved: 181020,
      co2Produced: 1752985,
      netConsumed: 2248115,
      date: "2018-06-10T00:00:00.000Z"
    }, {
      localDate: "2018-06-11T00:00:00.000Z",
      solarGenerated: 250780,
      gridConsumed: 4127700,
      solarReturned: 300,
      solarConsumption: 250480,
      co2Saved: 215500,
      co2Produced: 3549380,
      netConsumed: 4378180,
      date: "2018-06-11T00:00:00.000Z"
    }, {
      localDate: "2018-06-12T00:00:00.000Z",
      solarGenerated: 221820,
      gridConsumed: 4392955,
      solarReturned: 3130,
      solarConsumption: 218690,
      co2Saved: 190620,
      co2Produced: 3777545,
      netConsumed: 4611645,
      date: "2018-06-12T00:00:00.000Z"
    }, {
      localDate: "2018-06-13T00:00:00.000Z",
      solarGenerated: 192720,
      gridConsumed: 4336365,
      solarReturned: 4835,
      solarConsumption: 187885,
      co2Saved: 165580,
      co2Produced: 3728860,
      netConsumed: 4524250,
      date: "2018-06-13T00:00:00.000Z"
    }, {
      localDate: "2018-06-14T00:00:00.000Z",
      solarGenerated: 173420,
      gridConsumed: 4429130,
      solarReturned: 255,
      solarConsumption: 173165,
      co2Saved: 149000,
      co2Produced: 3808675,
      netConsumed: 4602295,
      date: "2018-06-14T00:00:00.000Z"
    }, {
      localDate: "2018-06-15T00:00:00.000Z",
      solarGenerated: 246260,
      gridConsumed: 4478130,
      solarReturned: 170,
      solarConsumption: 246090,
      co2Saved: 211560,
      co2Produced: 3850845,
      netConsumed: 4724220,
      date: "2018-06-15T00:00:00.000Z"
    }, {
      localDate: "2018-06-16T00:00:00.000Z",
      solarGenerated: 254700,
      gridConsumed: 2411210,
      solarReturned: 460,
      solarConsumption: 254240,
      co2Saved: 218840,
      co2Produced: 2073220,
      netConsumed: 2665450,
      date: "2018-06-16T00:00:00.000Z"
    }, {
      localDate: "2018-06-17T00:00:00.000Z",
      solarGenerated: 262180,
      gridConsumed: 2762860,
      solarReturned: 1040,
      solarConsumption: 261140,
      co2Saved: 225300,
      co2Produced: 2375700,
      netConsumed: 3024000,
      date: "2018-06-17T00:00:00.000Z"
    }, {
      localDate: "2018-06-18T00:00:00.000Z",
      solarGenerated: 261340,
      gridConsumed: 4682875,
      solarReturned: 75,
      solarConsumption: 261265,
      co2Saved: 224520,
      co2Produced: 4026880,
      netConsumed: 4944140,
      date: "2018-06-18T00:00:00.000Z"
    }, {
      localDate: "2018-06-19T00:00:00.000Z",
      solarGenerated: 250260,
      gridConsumed: 4393500,
      solarReturned: 330,
      solarConsumption: 249930,
      co2Saved: 214960,
      co2Produced: 3777955,
      netConsumed: 4643430,
      date: "2018-06-19T00:00:00.000Z"
    }, {
      localDate: "2018-06-20T00:00:00.000Z",
      solarGenerated: 217420,
      gridConsumed: 4616065,
      solarReturned: 375,
      solarConsumption: 217045,
      co2Saved: 186780,
      co2Produced: 3969220,
      netConsumed: 4833110,
      date: "2018-06-20T00:00:00.000Z"
    }, {
      localDate: "2018-06-21T00:00:00.000Z",
      solarGenerated: 193720,
      gridConsumed: 4604465,
      solarReturned: 110,
      solarConsumption: 193610,
      co2Saved: 166280,
      co2Produced: 3959410,
      netConsumed: 4798075,
      date: "2018-06-21T00:00:00.000Z"
    }, {
      localDate: "2018-06-22T00:00:00.000Z",
      solarGenerated: 245420,
      gridConsumed: 4590690,
      solarReturned: 1705,
      solarConsumption: 243715,
      co2Saved: 210880,
      co2Produced: 3947680,
      netConsumed: 4834405,
      date: "2018-06-22T00:00:00.000Z"
    }, {
      localDate: "2018-06-23T00:00:00.000Z",
      solarGenerated: 235280,
      gridConsumed: 2493500,
      solarReturned: 16260,
      solarConsumption: 219020,
      co2Saved: 202200,
      co2Produced: 2144105,
      netConsumed: 2712520,
      date: "2018-06-23T00:00:00.000Z"
    }, {
      localDate: "2018-06-24T00:00:00.000Z",
      solarGenerated: 246860,
      gridConsumed: 2566160,
      solarReturned: 17695,
      solarConsumption: 229165,
      co2Saved: 212220,
      co2Produced: 2206570,
      netConsumed: 2795325,
      date: "2018-06-24T00:00:00.000Z"
    }, {
      localDate: "2018-06-25T00:00:00.000Z",
      solarGenerated: 197240,
      gridConsumed: 3510545,
      solarReturned: 5385,
      solarConsumption: 191855,
      co2Saved: 169360,
      co2Produced: 3018725,
      netConsumed: 3702400,
      date: "2018-06-25T00:00:00.000Z"
    }, {
      localDate: "2018-06-26T00:00:00.000Z",
      solarGenerated: 187900,
      gridConsumed: 3257850,
      solarReturned: 4210,
      solarConsumption: 183690,
      co2Saved: 161380,
      co2Produced: 2801255,
      netConsumed: 3441540,
      date: "2018-06-26T00:00:00.000Z"
    }, {
      localDate: "2018-06-27T00:00:00.000Z",
      solarGenerated: 53980,
      gridConsumed: 3239120,
      solarReturned: 5095,
      solarConsumption: 48885,
      co2Saved: 46360,
      co2Produced: 2785130,
      netConsumed: 3288005,
      date: "2018-06-27T00:00:00.000Z"
    }, {
      localDate: "2018-06-28T00:00:00.000Z",
      solarGenerated: 141040,
      gridConsumed: 3337860,
      solarReturned: 4795,
      solarConsumption: 136245,
      co2Saved: 121140,
      co2Produced: 2870210,
      netConsumed: 3474105,
      date: "2018-06-28T00:00:00.000Z"
    }, {
      localDate: "2018-06-29T00:00:00.000Z",
      solarGenerated: 217920,
      gridConsumed: 3183975,
      solarReturned: 3465,
      solarConsumption: 214455,
      co2Saved: 187320,
      co2Produced: 2737790,
      netConsumed: 3398430,
      date: "2018-06-29T00:00:00.000Z"
    }, {
      localDate: "2018-06-30T00:00:00.000Z",
      solarGenerated: 206880,
      gridConsumed: 2210965,
      solarReturned: 645,
      solarConsumption: 206235,
      co2Saved: 177720,
      co2Produced: 1900930,
      netConsumed: 2417200,
      date: "2018-06-30T00:00:00.000Z"
    }]
  }, {
    year: 2018,
    month: "Jul",
    dates: [{
      localDate: "2018-07-01T00:00:00.000Z",
      solarGenerated: 110980,
      gridConsumed: 1998370,
      solarReturned: 595,
      solarConsumption: 110385,
      co2Saved: 95320,
      co2Produced: 1718095,
      netConsumed: 2108755,
      date: "2018-07-01T00:00:00.000Z"
    }, {
      localDate: "2018-07-02T00:00:00.000Z",
      solarGenerated: 189260,
      gridConsumed: 3069120,
      solarReturned: 280,
      solarConsumption: 188980,
      co2Saved: 162640,
      co2Produced: 2639135,
      netConsumed: 3258100,
      date: "2018-07-02T00:00:00.000Z"
    }, {
      localDate: "2018-07-03T00:00:00.000Z",
      solarGenerated: 254500,
      gridConsumed: 3140515,
      solarReturned: 425,
      solarConsumption: 254075,
      co2Saved: 218700,
      co2Produced: 2700460,
      netConsumed: 3394590,
      date: "2018-07-03T00:00:00.000Z"
    }, {
      localDate: "2018-07-04T00:00:00.000Z",
      solarGenerated: 204000,
      gridConsumed: 2488500,
      solarReturned: 425,
      solarConsumption: 203575,
      co2Saved: 175260,
      co2Produced: 2139630,
      netConsumed: 2692075,
      date: "2018-07-04T00:00:00.000Z"
    }, {
      localDate: "2018-07-05T00:00:00.000Z",
      solarGenerated: 161200,
      gridConsumed: 2759250,
      solarReturned: 280,
      solarConsumption: 160920,
      co2Saved: 138500,
      co2Produced: 2372535,
      netConsumed: 2920170,
      date: "2018-07-05T00:00:00.000Z"
    }, {
      localDate: "2018-07-06T00:00:00.000Z",
      solarGenerated: 140740,
      gridConsumed: 2665870,
      solarReturned: 195,
      solarConsumption: 140545,
      co2Saved: 120860,
      co2Produced: 2292115,
      netConsumed: 2806415,
      date: "2018-07-06T00:00:00.000Z"
    }, {
      localDate: "2018-07-07T00:00:00.000Z",
      solarGenerated: 109360,
      gridConsumed: 2065230,
      solarReturned: 370,
      solarConsumption: 108990,
      co2Saved: 93780,
      co2Produced: 1775630,
      netConsumed: 2174220,
      date: "2018-07-07T00:00:00.000Z"
    }, {
      localDate: "2018-07-08T00:00:00.000Z",
      solarGenerated: 275640,
      gridConsumed: 2414120,
      solarReturned: 1065,
      solarConsumption: 274575,
      co2Saved: 236920,
      co2Produced: 2075855,
      netConsumed: 2688695,
      date: "2018-07-08T00:00:00.000Z"
    }, {
      localDate: "2018-07-09T00:00:00.000Z",
      solarGenerated: 265720,
      gridConsumed: 2947520,
      solarReturned: 1870,
      solarConsumption: 263850,
      co2Saved: 228380,
      co2Produced: 2534465,
      netConsumed: 3211370,
      date: "2018-07-09T00:00:00.000Z"
    }, {
      localDate: "2018-07-10T00:00:00.000Z",
      solarGenerated: 215880,
      gridConsumed: 3019010,
      solarReturned: 4145,
      solarConsumption: 211735,
      co2Saved: 185600,
      co2Produced: 2595905,
      netConsumed: 3230745,
      date: "2018-07-10T00:00:00.000Z"
    }, {
      localDate: "2018-07-11T00:00:00.000Z",
      solarGenerated: 192620,
      gridConsumed: 3044710,
      solarReturned: 3675,
      solarConsumption: 188945,
      co2Saved: 165440,
      co2Produced: 2618030,
      netConsumed: 3233655,
      date: "2018-07-11T00:00:00.000Z"
    }, {
      localDate: "2018-07-12T00:00:00.000Z",
      solarGenerated: 165200,
      gridConsumed: 3293255,
      solarReturned: 1965,
      solarConsumption: 163235,
      co2Saved: 141940,
      co2Produced: 2831760,
      netConsumed: 3456490,
      date: "2018-07-12T00:00:00.000Z"
    }, {
      localDate: "2018-07-13T00:00:00.000Z",
      solarGenerated: 274980,
      gridConsumed: 3891095,
      solarReturned: 5,
      solarConsumption: 274975,
      co2Saved: 236300,
      co2Produced: 3345860,
      netConsumed: 4166070,
      date: "2018-07-13T00:00:00.000Z"
    }, {
      localDate: "2018-07-14T00:00:00.000Z",
      solarGenerated: 273100,
      gridConsumed: 2603810,
      solarReturned: 0,
      solarConsumption: 273100,
      co2Saved: 234820,
      co2Produced: 2238885,
      netConsumed: 2876910,
      date: "2018-07-14T00:00:00.000Z"
    }, {
      localDate: "2018-07-15T00:00:00.000Z",
      solarGenerated: 275340,
      gridConsumed: 2753250,
      solarReturned: 0,
      solarConsumption: 275340,
      co2Saved: 236520,
      co2Produced: 2367305,
      netConsumed: 3028590,
      date: "2018-07-15T00:00:00.000Z"
    }, {
      localDate: "2018-07-16T00:00:00.000Z",
      solarGenerated: 271540,
      gridConsumed: 5042890,
      solarReturned: 810,
      solarConsumption: 270730,
      co2Saved: 233460,
      co2Produced: 4336500,
      netConsumed: 5313620,
      date: "2018-07-16T00:00:00.000Z"
    }, {
      localDate: "2018-07-17T00:00:00.000Z",
      solarGenerated: 273620,
      gridConsumed: 5120075,
      solarReturned: 3980,
      solarConsumption: 269640,
      co2Saved: 235060,
      co2Produced: 4402880,
      netConsumed: 5389715,
      date: "2018-07-17T00:00:00.000Z"
    }, {
      localDate: "2018-07-18T00:00:00.000Z",
      solarGenerated: 272820,
      gridConsumed: 5164520,
      solarReturned: 3450,
      solarConsumption: 269370,
      co2Saved: 234340,
      co2Produced: 4441130,
      netConsumed: 5433890,
      date: "2018-07-18T00:00:00.000Z"
    }, {
      localDate: "2018-07-19T00:00:00.000Z",
      solarGenerated: 272060,
      gridConsumed: 5424930,
      solarReturned: 0,
      solarConsumption: 272060,
      co2Saved: 233800,
      co2Produced: 4665155,
      netConsumed: 5696990,
      date: "2018-07-19T00:00:00.000Z"
    }, {
      localDate: "2018-07-20T00:00:00.000Z",
      solarGenerated: 200540,
      gridConsumed: 5240385,
      solarReturned: 0,
      solarConsumption: 200540,
      co2Saved: 172360,
      co2Produced: 4506320,
      netConsumed: 5440925,
      date: "2018-07-20T00:00:00.000Z"
    }, {
      localDate: "2018-07-21T00:00:00.000Z",
      solarGenerated: 282180,
      gridConsumed: 2856265,
      solarReturned: 2995,
      solarConsumption: 279185,
      co2Saved: 242440,
      co2Produced: 2455960,
      netConsumed: 3135450,
      date: "2018-07-21T00:00:00.000Z"
    }, {
      localDate: "2018-07-22T00:00:00.000Z",
      solarGenerated: 243560,
      gridConsumed: 2283105,
      solarReturned: 16050,
      solarConsumption: 227510,
      co2Saved: 209280,
      co2Produced: 1963205,
      netConsumed: 2510615,
      date: "2018-07-22T00:00:00.000Z"
    }, {
      localDate: "2018-07-23T00:00:00.000Z",
      solarGenerated: 267460,
      gridConsumed: 4930245,
      solarReturned: 4160,
      solarConsumption: 263300,
      co2Saved: 229820,
      co2Produced: 4239670,
      netConsumed: 5193545,
      date: "2018-07-23T00:00:00.000Z"
    }, {
      localDate: "2018-07-24T00:00:00.000Z",
      solarGenerated: 265220,
      gridConsumed: 5371940,
      solarReturned: 0,
      solarConsumption: 265220,
      co2Saved: 227860,
      co2Produced: 4619520,
      netConsumed: 5637160,
      date: "2018-07-24T00:00:00.000Z"
    }, {
      localDate: "2018-07-25T00:00:00.000Z",
      solarGenerated: 180700,
      gridConsumed: 5059200,
      solarReturned: 5,
      solarConsumption: 180695,
      co2Saved: 155180,
      co2Produced: 4350545,
      netConsumed: 5239895,
      date: "2018-07-25T00:00:00.000Z"
    }, {
      localDate: "2018-07-26T00:00:00.000Z",
      solarGenerated: 256420,
      gridConsumed: 4736125,
      solarReturned: 5,
      solarConsumption: 256415,
      co2Saved: 220360,
      co2Produced: 4072645,
      netConsumed: 4992540,
      date: "2018-07-26T00:00:00.000Z"
    }, {
      localDate: "2018-07-27T00:00:00.000Z",
      solarGenerated: 271660,
      gridConsumed: 5054985,
      solarReturned: 75,
      solarConsumption: 271585,
      co2Saved: 233480,
      co2Produced: 4346945,
      netConsumed: 5326570,
      date: "2018-07-27T00:00:00.000Z"
    }, {
      localDate: "2018-07-28T00:00:00.000Z",
      solarGenerated: 262900,
      gridConsumed: 2712065,
      solarReturned: 1395,
      solarConsumption: 261505,
      co2Saved: 226000,
      co2Produced: 2331930,
      netConsumed: 2973570,
      date: "2018-07-28T00:00:00.000Z"
    }, {
      localDate: "2018-07-29T00:00:00.000Z",
      solarGenerated: 265180,
      gridConsumed: 2608245,
      solarReturned: 55,
      solarConsumption: 265125,
      co2Saved: 227820,
      co2Produced: 2242730,
      netConsumed: 2873370,
      date: "2018-07-29T00:00:00.000Z"
    }, {
      localDate: "2018-07-30T00:00:00.000Z",
      solarGenerated: 289520,
      gridConsumed: 4892070,
      solarReturned: 0,
      solarConsumption: 289520,
      co2Saved: 248840,
      co2Produced: 4206730,
      netConsumed: 5181590,
      date: "2018-07-30T00:00:00.000Z"
    }, {
      localDate: "2018-07-31T00:00:00.000Z",
      solarGenerated: 291680,
      gridConsumed: 5370045,
      solarReturned: 80,
      solarConsumption: 291600,
      co2Saved: 250680,
      co2Produced: 4617865,
      netConsumed: 5661645,
      date: "2018-07-31T00:00:00.000Z"
    }]
  }, {
    year: 2018,
    month: "Aug",
    dates: [{
      localDate: "2018-08-01T00:00:00.000Z",
      solarGenerated: 293680,
      gridConsumed: 4925965,
      solarReturned: 45,
      solarConsumption: 293635,
      co2Saved: 252320,
      co2Produced: 4235970,
      netConsumed: 5219600,
      date: "2018-08-01T00:00:00.000Z"
    }, {
      localDate: "2018-08-02T00:00:00.000Z",
      solarGenerated: 281820,
      gridConsumed: 4794320,
      solarReturned: 150,
      solarConsumption: 281670,
      co2Saved: 242060,
      co2Produced: 4122800,
      netConsumed: 5075990,
      date: "2018-08-02T00:00:00.000Z"
    }, {
      localDate: "2018-08-03T00:00:00.000Z",
      solarGenerated: 269900,
      gridConsumed: 4897770,
      solarReturned: 295,
      solarConsumption: 269605,
      co2Saved: 231980,
      co2Produced: 4211655,
      netConsumed: 5167375,
      date: "2018-08-03T00:00:00.000Z"
    }, {
      localDate: "2018-08-04T00:00:00.000Z",
      solarGenerated: 281220,
      gridConsumed: 2183405,
      solarReturned: 560,
      solarConsumption: 280660,
      co2Saved: 241600,
      co2Produced: 1877305,
      netConsumed: 2464065,
      date: "2018-08-04T00:00:00.000Z"
    }, {
      localDate: "2018-08-05T00:00:00.000Z",
      solarGenerated: 286980,
      gridConsumed: 2207615,
      solarReturned: 1040,
      solarConsumption: 285940,
      co2Saved: 246600,
      co2Produced: 1898225,
      netConsumed: 2493555,
      date: "2018-08-05T00:00:00.000Z"
    }, {
      localDate: "2018-08-06T00:00:00.000Z",
      solarGenerated: 285620,
      gridConsumed: 4392205,
      solarReturned: 570,
      solarConsumption: 285050,
      co2Saved: 245500,
      co2Produced: 3776765,
      netConsumed: 4677255,
      date: "2018-08-06T00:00:00.000Z"
    }, {
      localDate: "2018-08-07T00:00:00.000Z",
      solarGenerated: 232040,
      gridConsumed: 5007655,
      solarReturned: 115,
      solarConsumption: 231925,
      co2Saved: 199460,
      co2Produced: 4306235,
      netConsumed: 5239580,
      date: "2018-08-07T00:00:00.000Z"
    }, {
      localDate: "2018-08-08T00:00:00.000Z",
      solarGenerated: 305460,
      gridConsumed: 4659595,
      solarReturned: 155,
      solarConsumption: 305305,
      co2Saved: 262440,
      co2Produced: 4006865,
      netConsumed: 4964900,
      date: "2018-08-08T00:00:00.000Z"
    }, {
      localDate: "2018-08-09T00:00:00.000Z",
      solarGenerated: 302760,
      gridConsumed: 4972845,
      solarReturned: 45,
      solarConsumption: 302715,
      co2Saved: 260100,
      co2Produced: 4276360,
      netConsumed: 5275560,
      date: "2018-08-09T00:00:00.000Z"
    }, {
      localDate: "2018-08-10T00:00:00.000Z",
      solarGenerated: 285120,
      gridConsumed: 4831165,
      solarReturned: 270,
      solarConsumption: 284850,
      co2Saved: 244960,
      co2Produced: 4154385,
      netConsumed: 5116015,
      date: "2018-08-10T00:00:00.000Z"
    }, {
      localDate: "2018-08-11T00:00:00.000Z",
      solarGenerated: 259080,
      gridConsumed: 2386440,
      solarReturned: 745,
      solarConsumption: 258335,
      co2Saved: 222560,
      co2Produced: 2051995,
      netConsumed: 2644775,
      date: "2018-08-11T00:00:00.000Z"
    }, {
      localDate: "2018-08-12T00:00:00.000Z",
      solarGenerated: 304240,
      gridConsumed: 2078960,
      solarReturned: 17205,
      solarConsumption: 287035,
      co2Saved: 261240,
      co2Produced: 1787585,
      netConsumed: 2365995,
      date: "2018-08-12T00:00:00.000Z"
    }, {
      localDate: "2018-08-13T00:00:00.000Z",
      solarGenerated: 315240,
      gridConsumed: 5167525,
      solarReturned: 3930,
      solarConsumption: 311310,
      co2Saved: 271040,
      co2Produced: 4443650,
      netConsumed: 5478835,
      date: "2018-08-13T00:00:00.000Z"
    }, {
      localDate: "2018-08-14T00:00:00.000Z",
      solarGenerated: 302460,
      gridConsumed: 5406820,
      solarReturned: 2030,
      solarConsumption: 300430,
      co2Saved: 260100,
      co2Produced: 4649490,
      netConsumed: 5707250,
      date: "2018-08-14T00:00:00.000Z"
    }, {
      localDate: "2018-08-15T00:00:00.000Z",
      solarGenerated: 311660,
      gridConsumed: 2498725,
      solarReturned: 14230,
      solarConsumption: 297430,
      co2Saved: 267800,
      co2Produced: 2148560,
      netConsumed: 2796155,
      date: "2018-08-15T00:00:00.000Z"
    }, {
      localDate: "2018-08-16T00:00:00.000Z",
      solarGenerated: 309560,
      gridConsumed: 5332635,
      solarReturned: 2810,
      solarConsumption: 306750,
      co2Saved: 265980,
      co2Produced: 4585730,
      netConsumed: 5639385,
      date: "2018-08-16T00:00:00.000Z"
    }, {
      localDate: "2018-08-17T00:00:00.000Z",
      solarGenerated: 306980,
      gridConsumed: 5275920,
      solarReturned: 0,
      solarConsumption: 306980,
      co2Saved: 263860,
      co2Produced: 4536730,
      netConsumed: 5582900,
      date: "2018-08-17T00:00:00.000Z"
    }, {
      localDate: "2018-08-18T00:00:00.000Z",
      solarGenerated: 312140,
      gridConsumed: 2313930,
      solarReturned: 8855,
      solarConsumption: 303285,
      co2Saved: 268200,
      co2Produced: 1989690,
      netConsumed: 2617215,
      date: "2018-08-18T00:00:00.000Z"
    }, {
      localDate: "2018-08-19T00:00:00.000Z",
      solarGenerated: 328340,
      gridConsumed: 2146850,
      solarReturned: 15940,
      solarConsumption: 312400,
      co2Saved: 282240,
      co2Produced: 1846045,
      netConsumed: 2459250,
      date: "2018-08-19T00:00:00.000Z"
    }, {
      localDate: "2018-08-20T00:00:00.000Z",
      solarGenerated: 339700,
      gridConsumed: 4850825,
      solarReturned: 7930,
      solarConsumption: 331770,
      co2Saved: 292060,
      co2Produced: 4171200,
      netConsumed: 5182595,
      date: "2018-08-20T00:00:00.000Z"
    }, {
      localDate: "2018-08-21T00:00:00.000Z",
      solarGenerated: 331440,
      gridConsumed: 5151385,
      solarReturned: 2155,
      solarConsumption: 329285,
      co2Saved: 284780,
      co2Produced: 4429830,
      netConsumed: 5480670,
      date: "2018-08-21T00:00:00.000Z"
    }, {
      localDate: "2018-08-22T00:00:00.000Z",
      solarGenerated: 330780,
      gridConsumed: 4862400,
      solarReturned: 165,
      solarConsumption: 330615,
      co2Saved: 284280,
      co2Produced: 4181265,
      netConsumed: 5193015,
      date: "2018-08-22T00:00:00.000Z"
    }, {
      localDate: "2018-08-23T00:00:00.000Z",
      solarGenerated: 311720,
      gridConsumed: 5025735,
      solarReturned: 65,
      solarConsumption: 311655,
      co2Saved: 268060,
      co2Produced: 4321690,
      netConsumed: 5337390,
      date: "2018-08-23T00:00:00.000Z"
    }, {
      localDate: "2018-08-24T00:00:00.000Z",
      solarGenerated: 214820,
      gridConsumed: 4681925,
      solarReturned: 60,
      solarConsumption: 214760,
      co2Saved: 184480,
      co2Produced: 4026095,
      netConsumed: 4896685,
      date: "2018-08-24T00:00:00.000Z"
    }, {
      localDate: "2018-08-25T00:00:00.000Z",
      solarGenerated: 277480,
      gridConsumed: 2861235,
      solarReturned: 0,
      solarConsumption: 277480,
      co2Saved: 238400,
      co2Produced: 2460255,
      netConsumed: 3138715,
      date: "2018-08-25T00:00:00.000Z"
    }, {
      localDate: "2018-08-26T00:00:00.000Z",
      solarGenerated: 126480,
      gridConsumed: 2686637,
      solarReturned: 0,
      solarConsumption: 126480,
      co2Saved: 108580,
      co2Produced: 2310110,
      netConsumed: 2813117,
      date: "2018-08-26T00:00:00.000Z"
    }, {
      localDate: "2018-08-27T00:00:00.000Z",
      solarGenerated: 336940,
      gridConsumed: 5033900,
      solarReturned: 0,
      solarConsumption: 336940,
      co2Saved: 289640,
      co2Produced: 4328790,
      netConsumed: 5370840,
      date: "2018-08-27T00:00:00.000Z"
    }, {
      localDate: "2018-08-28T00:00:00.000Z",
      solarGenerated: 292980,
      gridConsumed: 5298320,
      solarReturned: 10,
      solarConsumption: 292970,
      co2Saved: 251740,
      co2Produced: 4556270,
      netConsumed: 5591290,
      date: "2018-08-28T00:00:00.000Z"
    }, {
      localDate: "2018-08-29T00:00:00.000Z",
      solarGenerated: 353980,
      gridConsumed: 5114310,
      solarReturned: 225,
      solarConsumption: 353755,
      co2Saved: 304240,
      co2Produced: 4398040,
      netConsumed: 5468065,
      date: "2018-08-29T00:00:00.000Z"
    }, {
      localDate: "2018-08-30T00:00:00.000Z",
      solarGenerated: 352140,
      gridConsumed: 4878230,
      solarReturned: 5125,
      solarConsumption: 347015,
      co2Saved: 302740,
      co2Produced: 4194885,
      netConsumed: 5225245,
      date: "2018-08-30T00:00:00.000Z"
    }, {
      localDate: "2018-08-31T00:00:00.000Z",
      solarGenerated: 329080,
      gridConsumed: 4706265,
      solarReturned: 285,
      solarConsumption: 328795,
      co2Saved: 282820,
      co2Produced: 4046950,
      netConsumed: 5035060,
      date: "2018-08-31T00:00:00.000Z"
    }]
  }, {
    year: 2018,
    month: "Sep",
    dates: [{
      localDate: "2018-09-01T00:00:00.000Z",
      solarGenerated: 295800,
      gridConsumed: 2950945,
      solarReturned: 220,
      solarConsumption: 295580,
      co2Saved: 254180,
      co2Produced: 2537350,
      netConsumed: 3246525,
      date: "2018-09-01T00:00:00.000Z"
    }, {
      localDate: "2018-09-02T00:00:00.000Z",
      solarGenerated: 349020,
      gridConsumed: 2337885,
      solarReturned: 505,
      solarConsumption: 348515,
      co2Saved: 300120,
      co2Produced: 2010140,
      netConsumed: 2686400,
      date: "2018-09-02T00:00:00.000Z"
    }, {
      localDate: "2018-09-03T00:00:00.000Z",
      solarGenerated: 203280,
      gridConsumed: 4560290,
      solarReturned: 475,
      solarConsumption: 202805,
      co2Saved: 174740,
      co2Produced: 3921415,
      netConsumed: 4763095,
      date: "2018-09-03T00:00:00.000Z"
    }, {
      localDate: "2018-09-04T00:00:00.000Z",
      solarGenerated: 260360,
      gridConsumed: 4812840,
      solarReturned: 3050,
      solarConsumption: 257310,
      co2Saved: 223820,
      co2Produced: 4138655,
      netConsumed: 5070150,
      date: "2018-09-04T00:00:00.000Z"
    }, {
      localDate: "2018-09-05T00:00:00.000Z",
      solarGenerated: 214020,
      gridConsumed: 4910075,
      solarReturned: 3645,
      solarConsumption: 210375,
      co2Saved: 183660,
      co2Produced: 4222295,
      netConsumed: 5120450,
      date: "2018-09-05T00:00:00.000Z"
    }, {
      localDate: "2018-09-06T00:00:00.000Z",
      solarGenerated: 180500,
      gridConsumed: 4239830,
      solarReturned: 5,
      solarConsumption: 180495,
      co2Saved: 154840,
      co2Produced: 3645840,
      netConsumed: 4420325,
      date: "2018-09-06T00:00:00.000Z"
    }, {
      localDate: "2018-09-07T00:00:00.000Z",
      solarGenerated: 315100,
      gridConsumed: 4626770,
      solarReturned: 625,
      solarConsumption: 314475,
      co2Saved: 270740,
      co2Produced: 3978635,
      netConsumed: 4941245,
      date: "2018-09-07T00:00:00.000Z"
    }, {
      localDate: "2018-09-08T00:00:00.000Z",
      solarGenerated: 164540,
      gridConsumed: 1913490,
      solarReturned: 3405,
      solarConsumption: 161135,
      co2Saved: 141280,
      co2Produced: 1645245,
      netConsumed: 2074625,
      date: "2018-09-08T00:00:00.000Z"
    }, {
      localDate: "2018-09-09T00:00:00.000Z",
      solarGenerated: 368680,
      gridConsumed: 2155020,
      solarReturned: 9925,
      solarConsumption: 358755,
      co2Saved: 316820,
      co2Produced: 1852940,
      netConsumed: 2513775,
      date: "2018-09-09T00:00:00.000Z"
    }, {
      localDate: "2018-09-10T00:00:00.000Z",
      solarGenerated: 376900,
      gridConsumed: 4497470,
      solarReturned: 3335,
      solarConsumption: 373565,
      co2Saved: 323980,
      co2Produced: 3867425,
      netConsumed: 4871035,
      date: "2018-09-10T00:00:00.000Z"
    }, {
      localDate: "2018-09-11T00:00:00.000Z",
      solarGenerated: 328780,
      gridConsumed: 4826725,
      solarReturned: 70,
      solarConsumption: 328710,
      co2Saved: 282500,
      co2Produced: 4150590,
      netConsumed: 5155435,
      date: "2018-09-11T00:00:00.000Z"
    }, {
      localDate: "2018-09-12T00:00:00.000Z",
      solarGenerated: 284680,
      gridConsumed: 4235795,
      solarReturned: 155,
      solarConsumption: 284525,
      co2Saved: 244640,
      co2Produced: 3642370,
      netConsumed: 4520320,
      date: "2018-09-12T00:00:00.000Z"
    }, {
      localDate: "2018-09-13T00:00:00.000Z",
      solarGenerated: 366060,
      gridConsumed: 4662925,
      solarReturned: 210,
      solarConsumption: 365850,
      co2Saved: 314640,
      co2Produced: 4009785,
      netConsumed: 5028775,
      date: "2018-09-13T00:00:00.000Z"
    }, {
      localDate: "2018-09-14T00:00:00.000Z",
      solarGenerated: 327260,
      gridConsumed: 4978900,
      solarReturned: 220,
      solarConsumption: 327040,
      co2Saved: 281320,
      co2Produced: 4281385,
      netConsumed: 5305940,
      date: "2018-09-14T00:00:00.000Z"
    }, {
      localDate: "2018-09-15T00:00:00.000Z",
      solarGenerated: 382500,
      gridConsumed: 2097190,
      solarReturned: 170,
      solarConsumption: 382330,
      co2Saved: 328740,
      co2Produced: 1803185,
      netConsumed: 2479520,
      date: "2018-09-15T00:00:00.000Z"
    }, {
      localDate: "2018-09-16T00:00:00.000Z",
      solarGenerated: 345800,
      gridConsumed: 2256875,
      solarReturned: 1440,
      solarConsumption: 344360,
      co2Saved: 297220,
      co2Produced: 1940550,
      netConsumed: 2601235,
      date: "2018-09-16T00:00:00.000Z"
    }, {
      localDate: "2018-09-17T00:00:00.000Z",
      solarGenerated: 378040,
      gridConsumed: 4482380,
      solarReturned: 3260,
      solarConsumption: 374780,
      co2Saved: 324900,
      co2Produced: 3854505,
      netConsumed: 4857160,
      date: "2018-09-17T00:00:00.000Z"
    }, {
      localDate: "2018-09-18T00:00:00.000Z",
      solarGenerated: 292500,
      gridConsumed: 4339960,
      solarReturned: 0,
      solarConsumption: 292500,
      co2Saved: 251400,
      co2Produced: 3731975,
      netConsumed: 4632460,
      date: "2018-09-18T00:00:00.000Z"
    }, {
      localDate: "2018-09-19T00:00:00.000Z",
      solarGenerated: 397900,
      gridConsumed: 4508560,
      solarReturned: 455,
      solarConsumption: 397445,
      co2Saved: 341920,
      co2Produced: 3876930,
      netConsumed: 4906005,
      date: "2018-09-19T00:00:00.000Z"
    }, {
      localDate: "2018-09-20T00:00:00.000Z",
      solarGenerated: 341060,
      gridConsumed: 4961480,
      solarReturned: 110,
      solarConsumption: 340950,
      co2Saved: 293000,
      co2Produced: 4266555,
      netConsumed: 5302430,
      date: "2018-09-20T00:00:00.000Z"
    }, {
      localDate: "2018-09-21T00:00:00.000Z",
      solarGenerated: 395020,
      gridConsumed: 4390960,
      solarReturned: 1230,
      solarConsumption: 393790,
      co2Saved: 339420,
      co2Produced: 3775825,
      netConsumed: 4784750,
      date: "2018-09-21T00:00:00.000Z"
    }, {
      localDate: "2018-09-22T00:00:00.000Z",
      solarGenerated: 332080,
      gridConsumed: 1950295,
      solarReturned: 395,
      solarConsumption: 331685,
      co2Saved: 285360,
      co2Produced: 1676695,
      netConsumed: 2281980,
      date: "2018-09-22T00:00:00.000Z"
    }, {
      localDate: "2018-09-23T00:00:00.000Z",
      solarGenerated: 398160,
      gridConsumed: 1945830,
      solarReturned: 465,
      solarConsumption: 397695,
      co2Saved: 342040,
      co2Produced: 1673040,
      netConsumed: 2343525,
      date: "2018-09-23T00:00:00.000Z"
    }, {
      localDate: "2018-09-24T00:00:00.000Z",
      solarGenerated: 260620,
      gridConsumed: 3004555,
      solarReturned: 430,
      solarConsumption: 260190,
      co2Saved: 223800,
      co2Produced: 2583505,
      netConsumed: 3264745,
      date: "2018-09-24T00:00:00.000Z"
    }, {
      localDate: "2018-09-25T00:00:00.000Z",
      solarGenerated: 181580,
      gridConsumed: 3180980,
      solarReturned: 25,
      solarConsumption: 181555,
      co2Saved: 155980,
      co2Produced: 2735285,
      netConsumed: 3362535,
      date: "2018-09-25T00:00:00.000Z"
    }, {
      localDate: "2018-09-26T00:00:00.000Z",
      solarGenerated: 270480,
      gridConsumed: 3219760,
      solarReturned: 500,
      solarConsumption: 269980,
      co2Saved: 232360,
      co2Produced: 2768565,
      netConsumed: 3489740,
      date: "2018-09-26T00:00:00.000Z"
    }, {
      localDate: "2018-09-27T00:00:00.000Z",
      solarGenerated: 207320,
      gridConsumed: 2866695,
      solarReturned: 355,
      solarConsumption: 206965,
      co2Saved: 178120,
      co2Produced: 2464935,
      netConsumed: 3073660,
      date: "2018-09-27T00:00:00.000Z"
    }, {
      localDate: "2018-09-28T00:00:00.000Z",
      solarGenerated: 358860,
      gridConsumed: 3060150,
      solarReturned: 420,
      solarConsumption: 358440,
      co2Saved: 308400,
      co2Produced: 2631320,
      netConsumed: 3418590,
      date: "2018-09-28T00:00:00.000Z"
    }, {
      localDate: "2018-09-29T00:00:00.000Z",
      solarGenerated: 352600,
      gridConsumed: 2140315,
      solarReturned: 190,
      solarConsumption: 352410,
      co2Saved: 303080,
      co2Produced: 1840320,
      netConsumed: 2492725,
      date: "2018-09-29T00:00:00.000Z"
    }, {
      localDate: "2018-09-30T00:00:00.000Z",
      solarGenerated: 104740,
      gridConsumed: 1881435,
      solarReturned: 3655,
      solarConsumption: 101085,
      co2Saved: 89740,
      co2Produced: 1617685,
      netConsumed: 1982520,
      date: "2018-09-30T00:00:00.000Z"
    }]
  }, {
    year: 2018,
    month: "Oct",
    dates: [{
      localDate: "2018-10-01T00:00:00.000Z",
      solarGenerated: 378760,
      gridConsumed: 2712160,
      solarReturned: 615,
      solarConsumption: 378145,
      co2Saved: 325660,
      co2Produced: 2332060,
      netConsumed: 3090305,
      date: "2018-10-01T00:00:00.000Z"
    }, {
      localDate: "2018-10-02T00:00:00.000Z",
      solarGenerated: 376840,
      gridConsumed: 2843590,
      solarReturned: 520,
      solarConsumption: 376320,
      co2Saved: 323920,
      co2Produced: 2444975,
      netConsumed: 3219910,
      date: "2018-10-02T00:00:00.000Z"
    }, {
      localDate: "2018-10-03T00:00:00.000Z",
      solarGenerated: 402980,
      gridConsumed: 2822605,
      solarReturned: 530,
      solarConsumption: 402450,
      co2Saved: 346340,
      co2Produced: 2427100,
      netConsumed: 3225055,
      date: "2018-10-03T00:00:00.000Z"
    }, {
      localDate: "2018-10-04T00:00:00.000Z",
      solarGenerated: 423240,
      gridConsumed: 2883490,
      solarReturned: 580,
      solarConsumption: 422660,
      co2Saved: 363800,
      co2Produced: 2479355,
      netConsumed: 3306150,
      date: "2018-10-04T00:00:00.000Z"
    }, {
      localDate: "2018-10-05T00:00:00.000Z",
      solarGenerated: 224400,
      gridConsumed: 3021050,
      solarReturned: 225,
      solarConsumption: 224175,
      co2Saved: 192860,
      co2Produced: 2597820,
      netConsumed: 3245225,
      date: "2018-10-05T00:00:00.000Z"
    }, {
      localDate: "2018-10-06T00:00:00.000Z",
      solarGenerated: 161400,
      gridConsumed: 2523985,
      solarReturned: 440,
      solarConsumption: 160960,
      co2Saved: 138500,
      co2Produced: 2170185,
      netConsumed: 2684945,
      date: "2018-10-06T00:00:00.000Z"
    }, {
      localDate: "2018-10-07T00:00:00.000Z",
      solarGenerated: 285520,
      gridConsumed: 2640235,
      solarReturned: 750,
      solarConsumption: 284770,
      co2Saved: 245340,
      co2Produced: 2270295,
      netConsumed: 2925005,
      date: "2018-10-07T00:00:00.000Z"
    }, {
      localDate: "2018-10-08T00:00:00.000Z",
      solarGenerated: 364840,
      gridConsumed: 5465225,
      solarReturned: 480,
      solarConsumption: 364360,
      co2Saved: 313440,
      co2Produced: 4699775,
      netConsumed: 5829585,
      date: "2018-10-08T00:00:00.000Z"
    }, {
      localDate: "2018-10-09T00:00:00.000Z",
      solarGenerated: 303400,
      gridConsumed: 5970630,
      solarReturned: 115,
      solarConsumption: 303285,
      co2Saved: 260760,
      co2Produced: 5134400,
      netConsumed: 6273915,
      date: "2018-10-09T00:00:00.000Z"
    }, {
      localDate: "2018-10-10T00:00:00.000Z",
      solarGenerated: 419460,
      gridConsumed: 6776935,
      solarReturned: 235,
      solarConsumption: 419225,
      co2Saved: 360520,
      co2Produced: 5827725,
      netConsumed: 7196160,
      date: "2018-10-10T00:00:00.000Z"
    }, {
      localDate: "2018-10-11T00:00:00.000Z",
      solarGenerated: 157060,
      gridConsumed: 5704580,
      solarReturned: 1405,
      solarConsumption: 155655,
      co2Saved: 134860,
      co2Produced: 4905490,
      netConsumed: 5860235,
      date: "2018-10-11T00:00:00.000Z"
    }, {
      localDate: "2018-10-12T00:00:00.000Z",
      solarGenerated: 150820,
      gridConsumed: 4716765,
      solarReturned: 970,
      solarConsumption: 149850,
      co2Saved: 129460,
      co2Produced: 4055980,
      netConsumed: 4866615,
      date: "2018-10-12T00:00:00.000Z"
    }, {
      localDate: "2018-10-13T00:00:00.000Z",
      solarGenerated: 124680,
      gridConsumed: 2297435,
      solarReturned: 1250,
      solarConsumption: 123430,
      co2Saved: 107100,
      co2Produced: 1975305,
      netConsumed: 2420865,
      date: "2018-10-13T00:00:00.000Z"
    }, {
      localDate: "2018-10-14T00:00:00.000Z",
      solarGenerated: 149140,
      gridConsumed: 2397510,
      solarReturned: 1885,
      solarConsumption: 147255,
      co2Saved: 128140,
      co2Produced: 2061440,
      netConsumed: 2544765,
      date: "2018-10-14T00:00:00.000Z"
    }, {
      localDate: "2018-10-15T00:00:00.000Z",
      solarGenerated: 160700,
      gridConsumed: 4769370,
      solarReturned: 630,
      solarConsumption: 160070,
      co2Saved: 138100,
      co2Produced: 4101330,
      netConsumed: 4929440,
      date: "2018-10-15T00:00:00.000Z"
    }, {
      localDate: "2018-10-16T00:00:00.000Z",
      solarGenerated: 330660,
      gridConsumed: 5360310,
      solarReturned: 110,
      solarConsumption: 330550,
      co2Saved: 284300,
      co2Produced: 4609525,
      netConsumed: 5690860,
      date: "2018-10-16T00:00:00.000Z"
    }, {
      localDate: "2018-10-17T00:00:00.000Z",
      solarGenerated: 314960,
      gridConsumed: 5746125,
      solarReturned: 140,
      solarConsumption: 314820,
      co2Saved: 270720,
      co2Produced: 4941235,
      netConsumed: 6060945,
      date: "2018-10-17T00:00:00.000Z"
    }, {
      localDate: "2018-10-18T00:00:00.000Z",
      solarGenerated: 199080,
      gridConsumed: 5125890,
      solarReturned: 0,
      solarConsumption: 199080,
      co2Saved: 170960,
      co2Produced: 4407905,
      netConsumed: 5324970,
      date: "2018-10-18T00:00:00.000Z"
    }, {
      localDate: "2018-10-19T00:00:00.000Z",
      solarGenerated: 261400,
      gridConsumed: 5602670,
      solarReturned: 235,
      solarConsumption: 261165,
      co2Saved: 224640,
      co2Produced: 4817840,
      netConsumed: 5863835,
      date: "2018-10-19T00:00:00.000Z"
    }, {
      localDate: "2018-10-20T00:00:00.000Z",
      solarGenerated: 397360,
      gridConsumed: 2636875,
      solarReturned: 2565,
      solarConsumption: 394795,
      co2Saved: 341380,
      co2Produced: 2267215,
      netConsumed: 3031670,
      date: "2018-10-20T00:00:00.000Z"
    }, {
      localDate: "2018-10-21T00:00:00.000Z",
      solarGenerated: 260160,
      gridConsumed: 2315210,
      solarReturned: 4235,
      solarConsumption: 255925,
      co2Saved: 223620,
      co2Produced: 1990845,
      netConsumed: 2571135,
      date: "2018-10-21T00:00:00.000Z"
    }, {
      localDate: "2018-10-22T00:00:00.000Z",
      solarGenerated: 335600,
      gridConsumed: 4658525,
      solarReturned: 790,
      solarConsumption: 334810,
      co2Saved: 288340,
      co2Produced: 4005905,
      netConsumed: 4993335,
      date: "2018-10-22T00:00:00.000Z"
    }, {
      localDate: "2018-10-23T00:00:00.000Z",
      solarGenerated: 450280,
      gridConsumed: 7010980,
      solarReturned: 225,
      solarConsumption: 450055,
      co2Saved: 387020,
      co2Produced: 6028980,
      netConsumed: 7461035,
      date: "2018-10-23T00:00:00.000Z"
    }, {
      localDate: "2018-10-24T00:00:00.000Z",
      solarGenerated: 420060,
      gridConsumed: 7948470,
      solarReturned: 1090,
      solarConsumption: 418970,
      co2Saved: 361060,
      co2Produced: 6835305,
      netConsumed: 8367440,
      date: "2018-10-24T00:00:00.000Z"
    }]
  }],
  startTime: "2016-12-15T00:00:00.000Z",
  endTime: "2018-10-24T00:00:00.000Z"
};

/**
 * Groups data dates by month for rendering
 *
 * @param {Array} dataDates
 */

var groupDateCollectionByMonth = function groupDateCollectionByMonth(dataDates) {
  var dateKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "localDate";
  return groupBy(dataDates, function (d) {
    return format(d[dateKey], "YYYY-M");
  });
};
/**
 * Groups data dates by month for rendering
 *
 * @param {Array} dataDates
 */

var groupDateCollectionByWeek = function groupDateCollectionByWeek(dataDates) {
  var dateKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "localDate";
  return groupBy(dataDates, function (d) {
    return getISOWeek(d[dateKey]);
  });
};
/**
 * is the date same or before
 *
 * @param {Date} date
 * @param {Date} comparisonDate
 */

var isDaySameOrBefore = function isDaySameOrBefore(date, comparisonDate) {
  return isBeforeDay(date, comparisonDate) || isSameDay(date, comparisonDate);
};
/**
 * determines if a collection of dates starts on a sunday
 *
 * @param {Array<Date>} dataDates
 * @param {String} dateKey
 */

var doesDateCollectionStartOnSunday = function doesDateCollectionStartOnSunday(dataDates) {
  var dateKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "localDate";
  return getISODay(dataDates[0][dateKey]) === 7;
};

/**
 * Energy Units Utility Module
 */

/**
 * Automatically determines the best fit for energy units
 * @param {*} value the number in wh
 */

var determineBestUnit = function determineBestUnit(value) {
  var units = ["Wh", "kWh", "MWh", "GWh", "TWh"];
  var converted = units.map(function (u) {
    return {
      unit: u,
      value: unit(value, "Wh").to(u).toNumber()
    };
  });

  var _ref = converted.filter(function (e) {
    return e.value > 1 && e.value < 1000;
  })[0] || {},
      unit$1 = _ref.unit;

  return unit$1 ? unit$1 : "kWh";
};
/**
 * auto formats the energy value based on the best unit
 * @param {*} value the number in wh
 */

var autoFormatEnergyValue = function autoFormatEnergyValue(value) {
  var unit$1 = determineBestUnit(value);
  var num = unit(value, "Wh").to(unit$1).toJSON();
  return "".concat(parseFloat(num.value).toFixed(2).toLocaleString(), "  ").concat(num.unit);
};

var Warning = function Warning(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ["className"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 2",
    viewBox: "0 0 56 56"
  }, otherProps, {
    className: className
  }), React.createElement("path", {
    d: "M28 0a28 28 0 1 0 28 28A28 28 0 0 0 28 0zm0 54a26 26 0 1 1 26-26 26 26 0 0 1-26 26z"
  }), React.createElement("path", {
    d: "M28 10.5a1 1 0 0 0-1 1v24a1 1 0 0 0 2 0v-24a1 1 0 0 0-1-1zM28 39.5a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1z"
  }));
};

var Info = function Info(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ["className"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 2",
    viewBox: "0 0 24 24"
  }, otherProps, {
    className: className
  }), React.createElement("path", {
    d: "M 12 0 C 5.371094 0 0 5.371094 0 12 C 0 18.628906 5.371094 24 12 24 C 18.628906 24 24 18.628906 24 12 C 24 5.371094 18.628906 0 12 0 Z M 12 2 C 17.523438 2 22 6.476563 22 12 C 22 17.523438 17.523438 22 12 22 C 6.476563 22 2 17.523438 2 12 C 2 6.476563 6.476563 2 12 2 Z M 12 5.8125 C 11.816406 5.8125 11.664063 5.808594 11.5 5.84375 C 11.335938 5.878906 11.183594 5.96875 11.0625 6.0625 C 10.941406 6.15625 10.851563 6.285156 10.78125 6.4375 C 10.710938 6.589844 10.6875 6.769531 10.6875 7 C 10.6875 7.226563 10.710938 7.40625 10.78125 7.5625 C 10.851563 7.71875 10.941406 7.84375 11.0625 7.9375 C 11.183594 8.03125 11.335938 8.085938 11.5 8.125 C 11.664063 8.164063 11.816406 8.1875 12 8.1875 C 12.179688 8.1875 12.371094 8.164063 12.53125 8.125 C 12.691406 8.085938 12.816406 8.03125 12.9375 7.9375 C 13.058594 7.84375 13.148438 7.71875 13.21875 7.5625 C 13.289063 7.410156 13.34375 7.226563 13.34375 7 C 13.34375 6.769531 13.289063 6.589844 13.21875 6.4375 C 13.148438 6.285156 13.058594 6.15625 12.9375 6.0625 C 12.816406 5.96875 12.691406 5.878906 12.53125 5.84375 C 12.371094 5.808594 12.179688 5.8125 12 5.8125 Z M 10.78125 9.15625 L 10.78125 18.125 L 13.21875 18.125 L 13.21875 9.15625 Z"
  }));
};

var InfoIconContainer = styled.span({
  marginLeft: "1rem",
  cursor: "pointer"
});
var GridItem = styled.rect(function (_ref) {
  var canInteract = _ref.canInteract;
  return _objectSpread2({}, canInteract && {
    cursor: "pointer",
    "&:hover": {}
  });
});
var GradientScaleContainer = styled.div(function (_ref2) {
  var min = _ref2.min,
      max = _ref2.max;
  return {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    flexBasis: "100%",
    border: "1px solid lightgray",
    borderRadius: "8px",
    height: "1.3rem",
    "&::before": {
      alignSelf: "center",
      content: "'".concat(min, "'"),
      fontSize: "0.8rem",
      paddingLeft: "0.8rem",
      paddingRight: "0.8rem",
      whiteSpace: "nowrap"
    },
    "&::after": {
      alignSelf: "center",
      content: "'".concat(max, "'"),
      fontSize: "0.8rem",
      paddingLeft: "0.8rem",
      paddingRight: "0.8rem",
      whiteSpace: "nowrap"
    }
  };
});
var GradientScale = styled.div(function (_ref3) {
  var background = _ref3.background;
  return {
    background: background ? background : "#EEEEEE",
    width: "100%",
    height: "auto",
    borderLeft: "1px solid lightgray",
    borderRight: "1px solid lightgray"
  };
});
var StyledReactTooltip = styled(ReactTooltip)({
  borderRadius: "1rem",
  opacity: 1
});

/**
 * GLOBAL GRID REM SIZE
 */

var gridRem = 1.5;

var ReversedCalendarHeatMap = function ReversedCalendarHeatMap(_ref) {
  var data = _ref.data,
      dataKey = _ref.dataKey,
      dateKey = _ref.dateKey,
      months = _ref.months,
      maximumColor = _ref.maximumColor,
      title = _ref.title,
      category = _ref.category,
      clickHandler = _ref.clickHandler,
      cellSize = _ref.cellSize,
      gutterSize = _ref.gutterSize,
      themeColor = _ref.themeColor,
      transformUnit = _ref.transformUnit,
      hasTooltip = _ref.hasTooltip,
      transformDataValues = _ref.transformDataValues;

  /**
   * Component Methods
   */
  var formatExtents = function formatExtents(_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        mi = _ref3[0],
        ma = _ref3[1];

    var min = transformUnit(mi);
    var max = transformUnit(ma);
    return {
      min: min,
      max: max
    };
  };

  var minimumColor = function minimumColor(maximumColor, basePercent) {
    return tinycolor(maximumColor).lighten(basePercent);
  };

  var findMinimumColor = function findMinimumColor(maximumColor) {
    var basePercent = 95;
    var color = minimumColor(maximumColor, basePercent).toHexString();

    while (color === "#ffffff") {
      basePercent = basePercent * 0.85;
      color = minimumColor(maximumColor, basePercent).toHexString();
    }

    return color;
  };

  var colorScale = function colorScale(extents, min, max) {
    return scaleLinear().domain(extents).range([min, max]).clamp(true);
  };

  var getMonthStringFromDataKey = function getMonthStringFromDataKey(key) {
    var params = key.split("-");
    params[1] = params[1] - 1;
    return format(_construct(Date, _toConsumableArray(params)), "MMM");
  };
  /**
   * Rendering Helpers
   */


  var renderWarning = function renderWarning() {
    return React.createElement("div", {
      className: "mb-1 w-100 d-flex"
    }, React.createElement(Warning, {
      className: "pr-3 h-100",
      style: {
        width: "3.5rem",
        fill: "".concat(themeColor)
      }
    }), React.createElement("div", {
      className: "flex flex-column"
    }, React.createElement("span", {
      className: "paragraph d-block"
    }, "There's currently no data available."), React.createElement("small", {
      className: "d-block"
    }, "If this message is unexpected, please contact Solar Schools.")));
  };

  var renderMonthGroup = function renderMonthGroup(cellSize, gutterSize, dates, index, month) {
    var monthEndsOnSundy = doesDateCollectionStartOnSunday(dates);
    var dataWeeks = handleEndOfYear(groupDateCollectionByWeek(dates, dateKey));
    var weekKeys = Object.keys(dataWeeks);
    var weeks = weekKeys.length;
    var boxHeight = cellSize * 7 + gutterSize * 6;
    var boxWidth = cellSize * weeks + gutterSize * (weeks - 1);
    var baseStyles = {
      width: "".concat(weeks * gridRem, "rem"),
      padding: ".1rem"
    };

    if (monthEndsOnSundy) {
      baseStyles["marginLeft"] = "".concat(gridRem, "rem");
    }

    return React.createElement("div", {
      key: index,
      style: baseStyles
    }, React.createElement("p", {
      className: "text-center"
    }, getMonthStringFromDataKey(month)), React.createElement("svg", {
      weeks: weeks,
      viewBox: "0 0 ".concat(boxWidth, " ").concat(boxHeight),
      xmlns: "http://www.w3.org/2000/svg"
    }, weekKeys.reverse().map(function (week, index) {
      var days = dataWeeks[week];
      return renderWeek(cellSize, gutterSize, days, index, week);
    })));
  };

  var toolTipContent = function toolTipContent(day) {
    var content = "";
    content += day[dataKey] ? "<center>".concat(format(day[dateKey], "D MMM YYYY"), "<br /> ").concat(transformUnit(day[dataKey]), " ").concat(dataKey === "gridConsumed" || dataKey === "usage" || dataKey === "consumed" ? "consumed" : "generated", "</center>") : "";
    return content.length ? content : null;
  };

  var renderWeek = function renderWeek(cellSize, gutterSize, days, index, week) {
    return React.createElement("g", {
      week: week,
      key: index,
      transform: "translate(".concat((gutterSize + cellSize) * index, ", 0)")
    }, days.map(function (day, i) {
      var canInteract = day[dataKey] && day[dataKey] > 0;
      return React.createElement(GridItem, {
        canInteract: canInteract,
        key: i,
        dayname: format(day[dateKey], "dddd"),
        date: day[dateKey],
        "data-tip": canInteract && hasTooltip ? toolTipContent(day) : null,
        isodate: getISODay(day[dateKey]) - 1,
        fill: canInteract ? scale(day[dataKey]) : "#eeeeee",
        onClick: function onClick() {
          return canInteract ? clickHandler(day, day[dataKey]) : null;
        },
        width: cellSize,
        height: cellSize,
        x: "0",
        y: (gutterSize + cellSize) * (getISODay(day[dateKey]) - 1)
      });
    }));
  };

  var renderHeatMap = function renderHeatMap(cellSize, gutterSize, dataMonths, monthKeys) {
    return React.createElement("div", {
      className: "d-flex flex-row"
    }, React.createElement("div", {
      className: "mb-3",
      style: {
        padding: "0.1rem"
      }
    }, React.createElement("p", {
      className: "invisible"
    }, "D"), React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        width: "".concat(gridRem, "rem")
      },
      viewBox: "0 0 11 77"
    }, React.createElement("g", {
      week: "52",
      transform: ""
    }, React.createElement("g", {
      transform: "translate(0,0)"
    }, React.createElement("rect", {
      fill: "#ffffff",
      width: "10",
      height: "10",
      x: "0",
      y: "0"
    }), React.createElement("text", {
      x: "5",
      y: "5",
      alignmentBaseline: "middle",
      fontSize: "6",
      strokeWidth: "0",
      stroke: "#5e5d63",
      fill: "#5e5d63",
      textAnchor: "middle"
    }, "M")), React.createElement("g", {
      transform: "translate(0,11)"
    }, React.createElement("rect", {
      fill: "#ffffff",
      width: "10",
      height: "10",
      x: "0",
      y: "0"
    }), React.createElement("text", {
      x: "5",
      y: "5",
      alignmentBaseline: "middle",
      fontSize: "6",
      strokeWidth: "0",
      stroke: "#5e5d63",
      fill: "#5e5d63",
      textAnchor: "middle"
    }, "T")), React.createElement("g", {
      transform: "translate(0,22)"
    }, React.createElement("rect", {
      fill: "#ffffff",
      width: "10",
      height: "10",
      x: "0",
      y: "0"
    }), React.createElement("text", {
      x: "5",
      y: "5",
      alignmentBaseline: "middle",
      fontSize: "6",
      strokeWidth: "0",
      stroke: "#5e5d63",
      fill: "#5e5d63",
      textAnchor: "middle"
    }, "W")), React.createElement("g", {
      transform: "translate(0,33)"
    }, React.createElement("rect", {
      fill: "#ffffff",
      width: "10",
      height: "10",
      x: "0",
      y: "0"
    }), React.createElement("text", {
      x: "5",
      y: "5",
      alignmentBaseline: "middle",
      fontSize: "6",
      strokeWidth: "0",
      stroke: "#5e5d63",
      fill: "#5e5d63",
      textAnchor: "middle"
    }, "T")), React.createElement("g", {
      transform: "translate(0,44)"
    }, React.createElement("rect", {
      fill: "#ffffff",
      width: "10",
      height: "10",
      x: "0",
      y: "0"
    }), React.createElement("text", {
      x: "5",
      y: "5",
      alignmentBaseline: "middle",
      fontSize: "6",
      strokeWidth: "0",
      stroke: "#5e5d63",
      fill: "#5e5d63",
      textAnchor: "middle"
    }, "F")), React.createElement("g", {
      transform: "translate(0,55)"
    }, React.createElement("rect", {
      fill: "#ffffff",
      width: "10",
      height: "10",
      x: "0",
      y: "0"
    }), React.createElement("text", {
      x: "5",
      y: "5",
      alignmentBaseline: "middle",
      fontSize: "6",
      strokeWidth: "0",
      stroke: "#5e5d63",
      fill: "#5e5d63",
      textAnchor: "middle"
    }, "S")), React.createElement("g", {
      transform: "translate(0,66)"
    }, React.createElement("rect", {
      fill: "#ffffff",
      width: "10",
      height: "10",
      x: "0",
      y: "0"
    }), React.createElement("text", {
      x: "5",
      y: "5",
      alignmentBaseline: "middle",
      fontSize: "6",
      strokeWidth: "0",
      stroke: "#5e5d63",
      fill: "#5e5d63",
      textAnchor: "middle"
    }, "S"))))), React.createElement("div", {
      className: "w-100",
      style: {
        overflowX: "auto"
      }
    }, React.createElement("div", {
      className: "d-inline-flex flex-row mb-3"
    }, monthKeys.map(function (month, index) {
      var dates = dataMonths[month];
      return renderMonthGroup(cellSize, gutterSize, dates, index, month);
    }))));
  };
  /**
   * Component Variables
   */


  var startDate = getStartDate(months);
  var boundDataDates = bindDataToDates(data, startDate, dateKey, transformDataValues);
  var dataMonths = groupDateCollectionByMonth(boundDataDates, dateKey);
  var monthKeys = Object.keys(dataMonths);
  var datas = boundDataDates.reduce(function (acc, c) {
    if (c[dataKey]) {
      acc.push(c[dataKey]);
    }

    return acc;
  }, []);
  var extents = extent(datas.length ? datas : [0, 0]);

  var _extents = _slicedToArray(extents, 2),
      rawMin = _extents[0],
      rawMax = _extents[1];

  var hasData = datas.length && rawMin > 0 && rawMax > 0;

  var _formatExtents = formatExtents(extents),
      min = _formatExtents.min,
      max = _formatExtents.max;

  var minColor = findMinimumColor(maximumColor);
  var scale = colorScale(extents, minColor, maximumColor);
  var dateFormat = "D MMM YYYY";
  return React.createElement("div", {
    className: "mt-4"
  }, React.createElement("div", {
    className: "d-flex flex-column justify-content-between align-items-start mb-3"
  }, React.createElement("div", {
    className: "mb-1 d-flex mb-3"
  }, React.createElement("span", {
    className: "h3 mr-1 mb-0 align-items-center",
    style: {
      color: maximumColor
    }
  }, React.createElement("strong", null, title)), React.createElement(InfoIconContainer, {
    "data-tip": "Click a square to view the day's data and scroll horizontally to see more dates.",
    "data-place": "right"
  }, React.createElement(Info, {
    width: "20px",
    height: "20px",
    fill: maximumColor
  }))), React.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "flex-start",
    alignItems: "center",
    spacing: 3
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12,
    md: 6
  }, React.createElement("div", {
    className: "mr-2",
    style: {
      flexBasis: "100%"
    }
  }, React.createElement("p", {
    className: "paragraph mb-1 d-block"
  }, "Range displayed: ".concat(format(subMonths(new Date(), months), dateFormat), " to ").concat(format(new Date(), dateFormat))))), React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12,
    md: 6
  }, React.createElement(GradientScaleContainer, {
    min: min,
    max: max
  }, React.createElement(GradientScale, {
    background: "linear-gradient(90deg, ".concat(minColor, ", ").concat(maximumColor, ")")
  }))))), hasData ? renderHeatMap(cellSize, gutterSize, dataMonths, monthKeys) : renderWarning(), React.createElement(StyledReactTooltip, {
    effect: "solid",
    type: "light",
    className: "shadow-lg p-3",
    html: true
  }));
};
/**
 * returns the start date of the sequence
 *
 * @param {*} months
 */


var getStartDate = function getStartDate(months) {
  return subMonths(new Date(), months);
};
/**
 * Binds the requested data to the dates request
 *
 * @param {Array} data
 * @param {Number} months
 */

var bindDataToDates = function bindDataToDates(data, startDate, dateKey, transformDataValues) {
  var endDate = new Date();
  var sanitised = transformDataValues(data);
  var iteratorDate = startDate;
  var dates = [];

  while (isDaySameOrBefore(iteratorDate, endDate)) {
    iteratorDate = addDays(iteratorDate, 1);
    var datum = sanitised.has(startOfDay(iteratorDate).toISOString()) ? sanitised.get(startOfDay(iteratorDate).toISOString()) : {};

    if (!datum[dateKey]) {
      datum[dateKey] = startOfDay(iteratorDate).toISOString();
    }

    dates.push(datum);
  }

  return dates.reverse();
};
/**
 * returns a flat data structure for the dates as supplied
 *
 * @param {Array} data
 */

var flattenDataDates = function flattenDataDates(data) {
  return new Map(data.reduce(function (acc, current) {
    var _current$dates = current.dates,
        dates = _current$dates === void 0 ? [] : _current$dates;
    return Array.isArray(dates) ? acc.concat(dates) : acc;
  }, []).map(function (i) {
    return [startOfDay(new Date(i.localDate)).toISOString(), i];
  }));
};
/**
 * substitues week in in end of year grouping with week 53
 *
 * @param {Array} weeks
 */

var handleEndOfYear = function handleEndOfYear(weeks) {
  var keys = Object.keys(weeks);

  if (keys.includes("52") && keys.includes("1")) {
    var newWeeks = {};
    delete Object.assign(newWeeks, weeks, {
      "53": weeks["1"]
    })["1"];
    return newWeeks;
  }

  return weeks;
};
ReversedCalendarHeatMap.propTypes = {
  transformDataValues: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  dataKey: PropTypes.string.isRequired,
  dateKey: PropTypes.string.isRequired,
  months: PropTypes.number.isRequired,
  maximumColor: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tagline: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  clickHandler: PropTypes.func.isRequired,
  cellSize: PropTypes.number.isRequired,
  gutterSize: PropTypes.number.isRequired,
  transformUnit: PropTypes.func.isRequired,
  hasTooltip: PropTypes.bool.isRequired
};
ReversedCalendarHeatMap.defaultProps = {
  transformDataValues: flattenDataDates,
  data: mockdata.data,
  dataKey: "gridConsumed",
  dateKey: "localDate",
  months: 12,
  maximumColor: "#EB7625",
  unit: "kWh",
  title: "Daily Consumption Matrix",
  category: "Grid Consumption",
  clickHandler: function clickHandler(value) {
    console.log(value);
  },
  gutterSize: 2,
  cellSize: 10,
  transformUnit: autoFormatEnergyValue,
  hasTooltip: true
};

export default ReversedCalendarHeatMap;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/component-lib/components/ReversedCalendarHeatMap/index.js
// module id = +Qvk
// module chunks = 3